import { unzip, strFromU8, strToU8, zip } from 'fflate';
import { object, string, optional, array, union, number, boolean, literal, nativeEnum, record, any, safeParse, flatten } from 'valibot';

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

// ../../node_modules/.pnpm/ieee754@1.2.1/node_modules/ieee754/index.js
var require_ieee754 = __commonJS({
  "../../node_modules/.pnpm/ieee754@1.2.1/node_modules/ieee754/index.js"(exports) {
    exports.read = function(buffer, offset, isLE, mLen, nBytes) {
      var e, m;
      var eLen = nBytes * 8 - mLen - 1;
      var eMax = (1 << eLen) - 1;
      var eBias = eMax >> 1;
      var nBits = -7;
      var i = isLE ? nBytes - 1 : 0;
      var d = isLE ? -1 : 1;
      var s = buffer[offset + i];
      i += d;
      e = s & (1 << -nBits) - 1;
      s >>= -nBits;
      nBits += eLen;
      for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {
      }
      m = e & (1 << -nBits) - 1;
      e >>= -nBits;
      nBits += mLen;
      for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {
      }
      if (e === 0) {
        e = 1 - eBias;
      } else if (e === eMax) {
        return m ? NaN : (s ? -1 : 1) * Infinity;
      } else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
      }
      return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
    };
    exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
      var e, m, c;
      var eLen = nBytes * 8 - mLen - 1;
      var eMax = (1 << eLen) - 1;
      var eBias = eMax >> 1;
      var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
      var i = isLE ? 0 : nBytes - 1;
      var d = isLE ? 1 : -1;
      var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
      value = Math.abs(value);
      if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
      } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
          e--;
          c *= 2;
        }
        if (e + eBias >= 1) {
          value += rt / c;
        } else {
          value += rt * Math.pow(2, 1 - eBias);
        }
        if (value * c >= 2) {
          e++;
          c /= 2;
        }
        if (e + eBias >= eMax) {
          m = 0;
          e = eMax;
        } else if (e + eBias >= 1) {
          m = (value * c - 1) * Math.pow(2, mLen);
          e = e + eBias;
        } else {
          m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
          e = 0;
        }
      }
      for (; mLen >= 8; buffer[offset + i] = m & 255, i += d, m /= 256, mLen -= 8) {
      }
      e = e << mLen | m;
      eLen += mLen;
      for (; eLen > 0; buffer[offset + i] = e & 255, i += d, e /= 256, eLen -= 8) {
      }
      buffer[offset + i - d] |= s * 128;
    };
  }
});

// ../../node_modules/.pnpm/@rgba-image+copy@0.1.3/node_modules/@rgba-image/copy/dist/index.js
var require_dist = __commonJS({
  "../../node_modules/.pnpm/@rgba-image+copy@0.1.3/node_modules/@rgba-image/copy/dist/index.js"(exports) {
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.copy = void 0;
    var copy = (source, dest, sx = 0, sy = 0, sw = source.width - sx, sh = source.height - sy, dx = 0, dy = 0) => {
      sx = sx | 0;
      sy = sy | 0;
      sw = sw | 0;
      sh = sh | 0;
      dx = dx | 0;
      dy = dy | 0;
      if (sw <= 0 || sh <= 0)
        return;
      const sourceData = new Uint32Array(source.data.buffer);
      const destData = new Uint32Array(dest.data.buffer);
      for (let y = 0; y < sh; y++) {
        const sourceY = sy + y;
        if (sourceY < 0 || sourceY >= source.height)
          continue;
        const destY = dy + y;
        if (destY < 0 || destY >= dest.height)
          continue;
        for (let x = 0; x < sw; x++) {
          const sourceX = sx + x;
          if (sourceX < 0 || sourceX >= source.width)
            continue;
          const destX = dx + x;
          if (destX < 0 || destX >= dest.width)
            continue;
          const sourceIndex = sourceY * source.width + sourceX;
          const destIndex = destY * dest.width + destX;
          destData[destIndex] = sourceData[sourceIndex];
        }
      }
    };
    exports.copy = copy;
  }
});

// ../../node_modules/.pnpm/@rgba-image+create-image@0.1.1/node_modules/@rgba-image/create-image/dist/index.js
var require_dist2 = __commonJS({
  "../../node_modules/.pnpm/@rgba-image+create-image@0.1.1/node_modules/@rgba-image/create-image/dist/index.js"(exports) {
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.CreateImageFactory = (fill = [0, 0, 0, 0], channels = 4) => {
      channels = Math.floor(channels);
      if (isNaN(channels) || channels < 1) {
        throw TypeError("channels should be a positive non-zero number");
      }
      if (!("length" in fill) || fill.length < channels) {
        throw TypeError(`fill should be iterable with at least ${channels} members`);
      }
      fill = new Uint8ClampedArray(fill).slice(0, channels);
      const allZero = fill.every((v) => v === 0);
      const createImage = (width, height, data) => {
        if (width === void 0 || height === void 0) {
          throw TypeError("Not enough arguments");
        }
        width = Math.floor(width);
        height = Math.floor(height);
        if (isNaN(width) || width < 1 || isNaN(height) || height < 1) {
          throw TypeError("Index or size is negative or greater than the allowed amount");
        }
        const length = width * height * channels;
        if (data === void 0) {
          data = new Uint8ClampedArray(length);
        }
        if (data instanceof Uint8ClampedArray) {
          if (data.length !== length) {
            throw TypeError("Index or size is negative or greater than the allowed amount");
          }
          if (!allZero) {
            for (let y = 0; y < height; y++) {
              for (let x = 0; x < width; x++) {
                const index = (y * width + x) * channels;
                for (let c = 0; c < channels; c++) {
                  data[index + c] = fill[c];
                }
              }
            }
          }
          return {
            get width() {
              return width;
            },
            get height() {
              return height;
            },
            get data() {
              return data;
            }
          };
        }
        throw TypeError("Expected data to be Uint8ClampedArray or undefined");
      };
      return createImage;
    };
    exports.createImage = exports.CreateImageFactory();
  }
});

// ../../node_modules/.pnpm/@rgba-image+lanczos@0.1.1/node_modules/@rgba-image/lanczos/dist/filters.js
var require_filters = __commonJS({
  "../../node_modules/.pnpm/@rgba-image+lanczos@0.1.1/node_modules/@rgba-image/lanczos/dist/filters.js"(exports) {
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.filters = void 0;
    var fixedFracBits = 14;
    var filterValue = (x, a) => {
      if (x <= -a || x >= a)
        return 0;
      if (x == 0)
        return 0;
      const xPi = x * Math.PI;
      return Math.sin(xPi) / xPi * Math.sin(xPi / a) / (xPi / a);
    };
    var toFixedPoint = (value) => Math.round(value * ((1 << fixedFracBits) - 1));
    var filters = (srcSize, destSize, scale, offset, use2) => {
      const a = use2 ? 2 : 3;
      const scaleInverted = 1 / scale;
      const scaleClamped = Math.min(1, scale);
      const srcWindow = a / scaleClamped;
      const maxFilterElementSize = Math.floor((srcWindow + 1) * 2);
      const packedFilter = new Int16Array((maxFilterElementSize + 2) * destSize);
      let packedFilterPtr = 0;
      for (let destPixel = 0; destPixel < destSize; destPixel++) {
        const sourcePixel = (destPixel + 0.5) * scaleInverted + offset;
        const sourceFirst = Math.max(0, Math.floor(sourcePixel - srcWindow));
        const sourceLast = Math.min(srcSize - 1, Math.ceil(sourcePixel + srcWindow));
        const filterElementSize = sourceLast - sourceFirst + 1;
        const floatFilter = new Float32Array(filterElementSize);
        const fxpFilter = new Int16Array(filterElementSize);
        let total = 0;
        let index = 0;
        for (let pixel = sourceFirst; pixel <= sourceLast; pixel++) {
          const floatValue = filterValue((pixel + 0.5 - sourcePixel) * scaleClamped, a);
          total += floatValue;
          floatFilter[index] = floatValue;
          index++;
        }
        let filterTotal = 0;
        for (let index2 = 0; index2 < floatFilter.length; index2++) {
          const filterValue2 = floatFilter[index2] / total;
          filterTotal += filterValue2;
          fxpFilter[index2] = toFixedPoint(filterValue2);
        }
        fxpFilter[destSize >> 1] += toFixedPoint(1 - filterTotal);
        let leftNotEmpty = 0;
        while (leftNotEmpty < fxpFilter.length && fxpFilter[leftNotEmpty] === 0) {
          leftNotEmpty++;
        }
        let rightNotEmpty = fxpFilter.length - 1;
        while (rightNotEmpty > 0 && fxpFilter[rightNotEmpty] === 0) {
          rightNotEmpty--;
        }
        const filterShift = sourceFirst + leftNotEmpty;
        const filterSize = rightNotEmpty - leftNotEmpty + 1;
        packedFilter[packedFilterPtr++] = filterShift;
        packedFilter[packedFilterPtr++] = filterSize;
        packedFilter.set(fxpFilter.subarray(leftNotEmpty, rightNotEmpty + 1), packedFilterPtr);
        packedFilterPtr += filterSize;
      }
      return packedFilter;
    };
    exports.filters = filters;
  }
});

// ../../node_modules/.pnpm/@rgba-image+lanczos@0.1.1/node_modules/@rgba-image/lanczos/dist/convolve.js
var require_convolve = __commonJS({
  "../../node_modules/.pnpm/@rgba-image+lanczos@0.1.1/node_modules/@rgba-image/lanczos/dist/convolve.js"(exports) {
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.convolve = void 0;
    var fixedFracBits = 14;
    var convolve = (source, dest, sw, sh, dw, filters) => {
      let srcOffset = 0;
      let destOffset = 0;
      for (let sourceY = 0; sourceY < sh; sourceY++) {
        let filterPtr = 0;
        for (let destX = 0; destX < dw; destX++) {
          const filterShift = filters[filterPtr++];
          let srcPtr = srcOffset + filterShift * 4 | 0;
          let r = 0;
          let g = 0;
          let b = 0;
          let a = 0;
          for (let filterSize = filters[filterPtr++]; filterSize > 0; filterSize--) {
            const filterValue = filters[filterPtr++];
            r = r + filterValue * source[srcPtr] | 0;
            g = g + filterValue * source[srcPtr + 1] | 0;
            b = b + filterValue * source[srcPtr + 2] | 0;
            a = a + filterValue * source[srcPtr + 3] | 0;
            srcPtr = srcPtr + 4 | 0;
          }
          dest[destOffset] = r + (1 << 13) >> fixedFracBits;
          dest[destOffset + 1] = g + (1 << 13) >> fixedFracBits;
          dest[destOffset + 2] = b + (1 << 13) >> fixedFracBits;
          dest[destOffset + 3] = a + (1 << 13) >> fixedFracBits;
          destOffset = destOffset + sh * 4 | 0;
        }
        destOffset = (sourceY + 1) * 4 | 0;
        srcOffset = (sourceY + 1) * sw * 4 | 0;
      }
    };
    exports.convolve = convolve;
  }
});

// ../../node_modules/.pnpm/@rgba-image+lanczos@0.1.1/node_modules/@rgba-image/lanczos/dist/index.js
var require_dist3 = __commonJS({
  "../../node_modules/.pnpm/@rgba-image+lanczos@0.1.1/node_modules/@rgba-image/lanczos/dist/index.js"(exports) {
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.lanczos2 = exports.lanczos = void 0;
    var copy_1 = require_dist();
    var create_image_1 = require_dist2();
    var filters_1 = require_filters();
    var convolve_1 = require_convolve();
    var resize = (source, dest, use2 = false) => {
      const xRatio = dest.width / source.width;
      const yRatio = dest.height / source.height;
      const filtersX = filters_1.filters(source.width, dest.width, xRatio, 0, use2);
      const filtersY = filters_1.filters(source.height, dest.height, yRatio, 0, use2);
      const tmp = new Uint8ClampedArray(dest.width * source.height * 4);
      convolve_1.convolve(source.data, tmp, source.width, source.height, dest.width, filtersX);
      convolve_1.convolve(tmp, dest.data, source.height, dest.width, dest.height, filtersY);
    };
    var lanczos2 = (source, dest, sx = 0, sy = 0, sw = source.width - sx, sh = source.height - sy, dx = 0, dy = 0, dw = dest.width - dx, dh = dest.height - dy) => {
      sx = sx | 0;
      sy = sy | 0;
      sw = sw | 0;
      sh = sh | 0;
      dx = dx | 0;
      dy = dy | 0;
      dw = dw | 0;
      dh = dh | 0;
      if (sw <= 0 || sh <= 0 || dw <= 0 || dh <= 0)
        return;
      if (sx === 0 && sy === 0 && sw === source.width && sh === source.height && dx === 0 && dy === 0 && dw === dest.width && dh === dest.height) {
        resize(source, dest);
        return;
      }
      const croppedSource = create_image_1.createImage(sw, sh);
      const croppedDest = create_image_1.createImage(dw, dh);
      copy_1.copy(source, croppedSource, sx, sy);
      resize(croppedSource, croppedDest);
      copy_1.copy(croppedDest, dest, 0, 0, croppedDest.width, croppedDest.height, dx, dy);
    };
    exports.lanczos = lanczos2;
    var lanczos22 = (source, dest, sx = 0, sy = 0, sw = source.width - sx, sh = source.height - sy, dx = 0, dy = 0, dw = dest.width - dx, dh = dest.height - dy) => {
      sx = sx | 0;
      sy = sy | 0;
      sw = sw | 0;
      sh = sh | 0;
      dx = dx | 0;
      dy = dy | 0;
      dw = dw | 0;
      dh = dh | 0;
      if (sw <= 0 || sh <= 0 || dw <= 0 || dh <= 0)
        return;
      if (sx === 0 && sy === 0 && sw === source.width && sh === source.height && dx === 0 && dy === 0 && dw === dest.width && dh === dest.height) {
        resize(source, dest, true);
        return;
      }
      const croppedSource = create_image_1.createImage(sw, sh);
      const croppedDest = create_image_1.createImage(dw, dh);
      copy_1.copy(source, croppedSource, sx, sy);
      resize(croppedSource, croppedDest, true);
      copy_1.copy(croppedDest, dest, 0, 0, croppedDest.width, croppedDest.height, dx, dy);
    };
    exports.lanczos2 = lanczos22;
  }
});

// ../../node_modules/.pnpm/token-types@6.0.0/node_modules/token-types/lib/index.js
__toESM(require_ieee754(), 1);
function dv(array5) {
  return new DataView(array5.buffer, array5.byteOffset);
}
var UINT8 = {
  len: 1,
  get(array5, offset) {
    return dv(array5).getUint8(offset);
  },
  put(array5, offset, value) {
    dv(array5).setUint8(offset, value);
    return offset + 1;
  }
};
var UINT16_LE = {
  len: 2,
  get(array5, offset) {
    return dv(array5).getUint16(offset, true);
  },
  put(array5, offset, value) {
    dv(array5).setUint16(offset, value, true);
    return offset + 2;
  }
};
var UINT16_BE = {
  len: 2,
  get(array5, offset) {
    return dv(array5).getUint16(offset);
  },
  put(array5, offset, value) {
    dv(array5).setUint16(offset, value);
    return offset + 2;
  }
};
var UINT32_LE = {
  len: 4,
  get(array5, offset) {
    return dv(array5).getUint32(offset, true);
  },
  put(array5, offset, value) {
    dv(array5).setUint32(offset, value, true);
    return offset + 4;
  }
};
var UINT32_BE = {
  len: 4,
  get(array5, offset) {
    return dv(array5).getUint32(offset);
  },
  put(array5, offset, value) {
    dv(array5).setUint32(offset, value);
    return offset + 4;
  }
};
var INT32_BE = {
  len: 4,
  get(array5, offset) {
    return dv(array5).getInt32(offset);
  },
  put(array5, offset, value) {
    dv(array5).setInt32(offset, value);
    return offset + 4;
  }
};
var UINT64_LE = {
  len: 8,
  get(array5, offset) {
    return dv(array5).getBigUint64(offset, true);
  },
  put(array5, offset, value) {
    dv(array5).setBigUint64(offset, value, true);
    return offset + 8;
  }
};
var StringType = class {
  constructor(len, encoding) {
    this.len = len;
    this.encoding = encoding;
    this.textDecoder = new TextDecoder(encoding);
  }
  get(uint8Array, offset) {
    return this.textDecoder.decode(uint8Array.subarray(offset, offset + this.len));
  }
};

// ../../node_modules/.pnpm/peek-readable@5.3.1/node_modules/peek-readable/lib/EndOfStreamError.js
var defaultMessages = "End-Of-Stream";
var EndOfStreamError = class extends Error {
  constructor() {
    super(defaultMessages);
  }
};

// ../../node_modules/.pnpm/peek-readable@5.3.1/node_modules/peek-readable/lib/AbstractStreamReader.js
var AbstractStreamReader = class {
  constructor() {
    this.maxStreamReadSize = 1 * 1024 * 1024;
    this.endOfStream = false;
    this.peekQueue = [];
  }
  async peek(uint8Array, offset, length) {
    const bytesRead = await this.read(uint8Array, offset, length);
    this.peekQueue.push(uint8Array.subarray(offset, offset + bytesRead));
    return bytesRead;
  }
  async read(buffer, offset, length) {
    if (length === 0) {
      return 0;
    }
    let bytesRead = this.readFromPeekBuffer(buffer, offset, length);
    bytesRead += await this.readRemainderFromStream(buffer, offset + bytesRead, length - bytesRead);
    if (bytesRead === 0) {
      throw new EndOfStreamError();
    }
    return bytesRead;
  }
  /**
   * Read chunk from stream
   * @param buffer - Target Uint8Array (or Buffer) to store data read from stream in
   * @param offset - Offset target
   * @param length - Number of bytes to read
   * @returns Number of bytes read
   */
  readFromPeekBuffer(buffer, offset, length) {
    let remaining = length;
    let bytesRead = 0;
    while (this.peekQueue.length > 0 && remaining > 0) {
      const peekData = this.peekQueue.pop();
      if (!peekData)
        throw new Error("peekData should be defined");
      const lenCopy = Math.min(peekData.length, remaining);
      buffer.set(peekData.subarray(0, lenCopy), offset + bytesRead);
      bytesRead += lenCopy;
      remaining -= lenCopy;
      if (lenCopy < peekData.length) {
        this.peekQueue.push(peekData.subarray(lenCopy));
      }
    }
    return bytesRead;
  }
  async readRemainderFromStream(buffer, offset, initialRemaining) {
    let remaining = initialRemaining;
    let bytesRead = 0;
    while (remaining > 0 && !this.endOfStream) {
      const reqLen = Math.min(remaining, this.maxStreamReadSize);
      const chunkLen = await this.readFromStream(buffer, offset + bytesRead, reqLen);
      if (chunkLen === 0)
        break;
      bytesRead += chunkLen;
      remaining -= chunkLen;
    }
    return bytesRead;
  }
};

// ../../node_modules/.pnpm/peek-readable@5.3.1/node_modules/peek-readable/lib/WebStreamReader.js
var WebStreamReader = class extends AbstractStreamReader {
  constructor(stream) {
    super();
    this.reader = stream.getReader({ mode: "byob" });
  }
  async readFromStream(buffer, offset, length) {
    if (this.endOfStream) {
      throw new EndOfStreamError();
    }
    const result = await this.reader.read(new Uint8Array(length));
    if (result.done) {
      this.endOfStream = result.done;
    }
    if (result.value) {
      buffer.set(result.value, offset);
      return result.value.byteLength;
    }
    return 0;
  }
  async abort() {
    await this.reader.cancel();
    this.reader.releaseLock();
  }
};

// ../../node_modules/.pnpm/strtok3@9.0.1/node_modules/strtok3/lib/AbstractTokenizer.js
var AbstractTokenizer = class {
  /**
   * Constructor
   * @param options Tokenizer options
   * @protected
   */
  constructor(options) {
    this.position = 0;
    this.numBuffer = new Uint8Array(8);
    this.fileInfo = options?.fileInfo ?? {};
    this.onClose = options?.onClose;
    if (options?.abortSignal) {
      options.abortSignal.addEventListener("abort", () => {
        this.abort();
      });
    }
  }
  /**
   * Read a token from the tokenizer-stream
   * @param token - The token to read
   * @param position - If provided, the desired position in the tokenizer-stream
   * @returns Promise with token data
   */
  async readToken(token, position = this.position) {
    const uint8Array = new Uint8Array(token.len);
    const len = await this.readBuffer(uint8Array, { position });
    if (len < token.len)
      throw new EndOfStreamError();
    return token.get(uint8Array, 0);
  }
  /**
   * Peek a token from the tokenizer-stream.
   * @param token - Token to peek from the tokenizer-stream.
   * @param position - Offset where to begin reading within the file. If position is null, data will be read from the current file position.
   * @returns Promise with token data
   */
  async peekToken(token, position = this.position) {
    const uint8Array = new Uint8Array(token.len);
    const len = await this.peekBuffer(uint8Array, { position });
    if (len < token.len)
      throw new EndOfStreamError();
    return token.get(uint8Array, 0);
  }
  /**
   * Read a numeric token from the stream
   * @param token - Numeric token
   * @returns Promise with number
   */
  async readNumber(token) {
    const len = await this.readBuffer(this.numBuffer, { length: token.len });
    if (len < token.len)
      throw new EndOfStreamError();
    return token.get(this.numBuffer, 0);
  }
  /**
   * Read a numeric token from the stream
   * @param token - Numeric token
   * @returns Promise with number
   */
  async peekNumber(token) {
    const len = await this.peekBuffer(this.numBuffer, { length: token.len });
    if (len < token.len)
      throw new EndOfStreamError();
    return token.get(this.numBuffer, 0);
  }
  /**
   * Ignore number of bytes, advances the pointer in under tokenizer-stream.
   * @param length - Number of bytes to ignore
   * @return resolves the number of bytes ignored, equals length if this available, otherwise the number of bytes available
   */
  async ignore(length) {
    if (this.fileInfo.size !== void 0) {
      const bytesLeft = this.fileInfo.size - this.position;
      if (length > bytesLeft) {
        this.position += bytesLeft;
        return bytesLeft;
      }
    }
    this.position += length;
    return length;
  }
  async close() {
    await this.abort();
    await this.onClose?.();
  }
  normalizeOptions(uint8Array, options) {
    if (options && options.position !== void 0 && options.position < this.position) {
      throw new Error("`options.position` must be equal or greater than `tokenizer.position`");
    }
    if (options) {
      return {
        mayBeLess: options.mayBeLess === true,
        offset: options.offset ? options.offset : 0,
        length: options.length ? options.length : uint8Array.length - (options.offset ? options.offset : 0),
        position: options.position ? options.position : this.position
      };
    }
    return {
      mayBeLess: false,
      offset: 0,
      length: uint8Array.length,
      position: this.position
    };
  }
  abort() {
    return Promise.resolve();
  }
};

// ../../node_modules/.pnpm/strtok3@9.0.1/node_modules/strtok3/lib/ReadStreamTokenizer.js
var maxBufferSize = 256e3;
var ReadStreamTokenizer = class extends AbstractTokenizer {
  /**
   * Constructor
   * @param streamReader stream-reader to read from
   * @param options Tokenizer options
   */
  constructor(streamReader, options) {
    super(options);
    this.streamReader = streamReader;
  }
  /**
   * Read buffer from tokenizer
   * @param uint8Array - Target Uint8Array to fill with data read from the tokenizer-stream
   * @param options - Read behaviour options
   * @returns Promise with number of bytes read
   */
  async readBuffer(uint8Array, options) {
    const normOptions = this.normalizeOptions(uint8Array, options);
    const skipBytes = normOptions.position - this.position;
    if (skipBytes > 0) {
      await this.ignore(skipBytes);
      return this.readBuffer(uint8Array, options);
    }
    if (skipBytes < 0) {
      throw new Error("`options.position` must be equal or greater than `tokenizer.position`");
    }
    if (normOptions.length === 0) {
      return 0;
    }
    const bytesRead = await this.streamReader.read(uint8Array, normOptions.offset, normOptions.length);
    this.position += bytesRead;
    if ((!options || !options.mayBeLess) && bytesRead < normOptions.length) {
      throw new EndOfStreamError();
    }
    return bytesRead;
  }
  /**
   * Peek (read ahead) buffer from tokenizer
   * @param uint8Array - Uint8Array (or Buffer) to write data to
   * @param options - Read behaviour options
   * @returns Promise with number of bytes peeked
   */
  async peekBuffer(uint8Array, options) {
    const normOptions = this.normalizeOptions(uint8Array, options);
    let bytesRead = 0;
    if (normOptions.position) {
      const skipBytes = normOptions.position - this.position;
      if (skipBytes > 0) {
        const skipBuffer = new Uint8Array(normOptions.length + skipBytes);
        bytesRead = await this.peekBuffer(skipBuffer, { mayBeLess: normOptions.mayBeLess });
        uint8Array.set(skipBuffer.subarray(skipBytes), normOptions.offset);
        return bytesRead - skipBytes;
      }
      if (skipBytes < 0) {
        throw new Error("Cannot peek from a negative offset in a stream");
      }
    }
    if (normOptions.length > 0) {
      try {
        bytesRead = await this.streamReader.peek(uint8Array, normOptions.offset, normOptions.length);
      } catch (err) {
        if (options?.mayBeLess && err instanceof EndOfStreamError) {
          return 0;
        }
        throw err;
      }
      if (!normOptions.mayBeLess && bytesRead < normOptions.length) {
        throw new EndOfStreamError();
      }
    }
    return bytesRead;
  }
  async ignore(length) {
    const bufSize = Math.min(maxBufferSize, length);
    const buf = new Uint8Array(bufSize);
    let totBytesRead = 0;
    while (totBytesRead < length) {
      const remaining = length - totBytesRead;
      const bytesRead = await this.readBuffer(buf, { length: Math.min(bufSize, remaining) });
      if (bytesRead < 0) {
        return bytesRead;
      }
      totBytesRead += bytesRead;
    }
    return totBytesRead;
  }
  abort() {
    return this.streamReader.abort();
  }
};

// ../../node_modules/.pnpm/strtok3@9.0.1/node_modules/strtok3/lib/BufferTokenizer.js
var BufferTokenizer = class extends AbstractTokenizer {
  /**
   * Construct BufferTokenizer
   * @param uint8Array - Uint8Array to tokenize
   * @param options Tokenizer options
   */
  constructor(uint8Array, options) {
    super(options);
    this.uint8Array = uint8Array;
    this.fileInfo.size = this.fileInfo.size ? this.fileInfo.size : uint8Array.length;
  }
  /**
   * Read buffer from tokenizer
   * @param uint8Array - Uint8Array to tokenize
   * @param options - Read behaviour options
   * @returns {Promise<number>}
   */
  async readBuffer(uint8Array, options) {
    if (options?.position) {
      if (options.position < this.position) {
        throw new Error("`options.position` must be equal or greater than `tokenizer.position`");
      }
      this.position = options.position;
    }
    const bytesRead = await this.peekBuffer(uint8Array, options);
    this.position += bytesRead;
    return bytesRead;
  }
  /**
   * Peek (read ahead) buffer from tokenizer
   * @param uint8Array
   * @param options - Read behaviour options
   * @returns {Promise<number>}
   */
  async peekBuffer(uint8Array, options) {
    const normOptions = this.normalizeOptions(uint8Array, options);
    const bytes2read = Math.min(this.uint8Array.length - normOptions.position, normOptions.length);
    if (!normOptions.mayBeLess && bytes2read < normOptions.length) {
      throw new EndOfStreamError();
    }
    uint8Array.set(this.uint8Array.subarray(normOptions.position, normOptions.position + bytes2read), normOptions.offset);
    return bytes2read;
  }
  close() {
    return super.close();
  }
};

// ../../node_modules/.pnpm/strtok3@9.0.1/node_modules/strtok3/lib/core.js
function fromWebStream(webStream, options) {
  return new ReadStreamTokenizer(new WebStreamReader(webStream), options);
}
function fromBuffer(uint8Array, options) {
  return new BufferTokenizer(uint8Array, options);
}

// ../../node_modules/.pnpm/uint8array-extras@1.4.0/node_modules/uint8array-extras/index.js
({
  utf8: new globalThis.TextDecoder("utf8")
});
new globalThis.TextEncoder();
Array.from({ length: 256 }, (_, index) => index.toString(16).padStart(2, "0"));
function getUintBE(view) {
  const { byteLength } = view;
  if (byteLength === 6) {
    return view.getUint16(0) * 2 ** 32 + view.getUint32(2);
  }
  if (byteLength === 5) {
    return view.getUint8(0) * 2 ** 32 + view.getUint32(1);
  }
  if (byteLength === 4) {
    return view.getUint32(0);
  }
  if (byteLength === 3) {
    return view.getUint8(0) * 2 ** 16 + view.getUint16(1);
  }
  if (byteLength === 2) {
    return view.getUint16(0);
  }
  if (byteLength === 1) {
    return view.getUint8(0);
  }
}
function indexOf(array5, value) {
  const arrayLength = array5.length;
  const valueLength = value.length;
  if (valueLength === 0) {
    return -1;
  }
  if (valueLength > arrayLength) {
    return -1;
  }
  const validOffsetLength = arrayLength - valueLength;
  for (let index = 0; index <= validOffsetLength; index++) {
    let isMatch = true;
    for (let index2 = 0; index2 < valueLength; index2++) {
      if (array5[index + index2] !== value[index2]) {
        isMatch = false;
        break;
      }
    }
    if (isMatch) {
      return index;
    }
  }
  return -1;
}
function includes(array5, value) {
  return indexOf(array5, value) !== -1;
}

// ../../node_modules/.pnpm/file-type@19.6.0/node_modules/file-type/util.js
function stringToBytes(string5) {
  return [...string5].map((character) => character.charCodeAt(0));
}
function tarHeaderChecksumMatches(arrayBuffer, offset = 0) {
  const readSum = Number.parseInt(new StringType(6).get(arrayBuffer, 148).replace(/\0.*$/, "").trim(), 8);
  if (Number.isNaN(readSum)) {
    return false;
  }
  let sum = 8 * 32;
  for (let index = offset; index < offset + 148; index++) {
    sum += arrayBuffer[index];
  }
  for (let index = offset + 156; index < offset + 512; index++) {
    sum += arrayBuffer[index];
  }
  return readSum === sum;
}
var uint32SyncSafeToken = {
  get: (buffer, offset) => buffer[offset + 3] & 127 | buffer[offset + 2] << 7 | buffer[offset + 1] << 14 | buffer[offset] << 21,
  len: 4
};

// ../../node_modules/.pnpm/file-type@19.6.0/node_modules/file-type/supported.js
var extensions = [
  "jpg",
  "png",
  "apng",
  "gif",
  "webp",
  "flif",
  "xcf",
  "cr2",
  "cr3",
  "orf",
  "arw",
  "dng",
  "nef",
  "rw2",
  "raf",
  "tif",
  "bmp",
  "icns",
  "jxr",
  "psd",
  "indd",
  "zip",
  "tar",
  "rar",
  "gz",
  "bz2",
  "7z",
  "dmg",
  "mp4",
  "mid",
  "mkv",
  "webm",
  "mov",
  "avi",
  "mpg",
  "mp2",
  "mp3",
  "m4a",
  "oga",
  "ogg",
  "ogv",
  "opus",
  "flac",
  "wav",
  "spx",
  "amr",
  "pdf",
  "epub",
  "elf",
  "macho",
  "exe",
  "swf",
  "rtf",
  "wasm",
  "woff",
  "woff2",
  "eot",
  "ttf",
  "otf",
  "ico",
  "flv",
  "ps",
  "xz",
  "sqlite",
  "nes",
  "crx",
  "xpi",
  "cab",
  "deb",
  "ar",
  "rpm",
  "Z",
  "lz",
  "cfb",
  "mxf",
  "mts",
  "blend",
  "bpg",
  "docx",
  "pptx",
  "xlsx",
  "3gp",
  "3g2",
  "j2c",
  "jp2",
  "jpm",
  "jpx",
  "mj2",
  "aif",
  "qcp",
  "odt",
  "ods",
  "odp",
  "xml",
  "mobi",
  "heic",
  "cur",
  "ktx",
  "ape",
  "wv",
  "dcm",
  "ics",
  "glb",
  "pcap",
  "dsf",
  "lnk",
  "alias",
  "voc",
  "ac3",
  "m4v",
  "m4p",
  "m4b",
  "f4v",
  "f4p",
  "f4b",
  "f4a",
  "mie",
  "asf",
  "ogm",
  "ogx",
  "mpc",
  "arrow",
  "shp",
  "aac",
  "mp1",
  "it",
  "s3m",
  "xm",
  "ai",
  "skp",
  "avif",
  "eps",
  "lzh",
  "pgp",
  "asar",
  "stl",
  "chm",
  "3mf",
  "zst",
  "jxl",
  "vcf",
  "jls",
  "pst",
  "dwg",
  "parquet",
  "class",
  "arj",
  "cpio",
  "ace",
  "avro",
  "icc",
  "fbx",
  "vsdx",
  "vtt",
  "apk"
];
var mimeTypes = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
  "image/flif",
  "image/x-xcf",
  "image/x-canon-cr2",
  "image/x-canon-cr3",
  "image/tiff",
  "image/bmp",
  "image/vnd.ms-photo",
  "image/vnd.adobe.photoshop",
  "application/x-indesign",
  "application/epub+zip",
  "application/x-xpinstall",
  "application/vnd.oasis.opendocument.text",
  "application/vnd.oasis.opendocument.spreadsheet",
  "application/vnd.oasis.opendocument.presentation",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/zip",
  "application/x-tar",
  "application/x-rar-compressed",
  "application/gzip",
  "application/x-bzip2",
  "application/x-7z-compressed",
  "application/x-apple-diskimage",
  "application/x-apache-arrow",
  "video/mp4",
  "audio/midi",
  "video/x-matroska",
  "video/webm",
  "video/quicktime",
  "video/vnd.avi",
  "audio/wav",
  "audio/qcelp",
  "audio/x-ms-asf",
  "video/x-ms-asf",
  "application/vnd.ms-asf",
  "video/mpeg",
  "video/3gpp",
  "audio/mpeg",
  "audio/mp4",
  // RFC 4337
  "video/ogg",
  "audio/ogg",
  "audio/ogg; codecs=opus",
  "application/ogg",
  "audio/x-flac",
  "audio/ape",
  "audio/wavpack",
  "audio/amr",
  "application/pdf",
  "application/x-elf",
  "application/x-mach-binary",
  "application/x-msdownload",
  "application/x-shockwave-flash",
  "application/rtf",
  "application/wasm",
  "font/woff",
  "font/woff2",
  "application/vnd.ms-fontobject",
  "font/ttf",
  "font/otf",
  "image/x-icon",
  "video/x-flv",
  "application/postscript",
  "application/eps",
  "application/x-xz",
  "application/x-sqlite3",
  "application/x-nintendo-nes-rom",
  "application/x-google-chrome-extension",
  "application/vnd.ms-cab-compressed",
  "application/x-deb",
  "application/x-unix-archive",
  "application/x-rpm",
  "application/x-compress",
  "application/x-lzip",
  "application/x-cfb",
  "application/x-mie",
  "application/mxf",
  "video/mp2t",
  "application/x-blender",
  "image/bpg",
  "image/j2c",
  "image/jp2",
  "image/jpx",
  "image/jpm",
  "image/mj2",
  "audio/aiff",
  "application/xml",
  "application/x-mobipocket-ebook",
  "image/heif",
  "image/heif-sequence",
  "image/heic",
  "image/heic-sequence",
  "image/icns",
  "image/ktx",
  "application/dicom",
  "audio/x-musepack",
  "text/calendar",
  "text/vcard",
  "text/vtt",
  "model/gltf-binary",
  "application/vnd.tcpdump.pcap",
  "audio/x-dsf",
  // Non-standard
  "application/x.ms.shortcut",
  // Invented by us
  "application/x.apple.alias",
  // Invented by us
  "audio/x-voc",
  "audio/vnd.dolby.dd-raw",
  "audio/x-m4a",
  "image/apng",
  "image/x-olympus-orf",
  "image/x-sony-arw",
  "image/x-adobe-dng",
  "image/x-nikon-nef",
  "image/x-panasonic-rw2",
  "image/x-fujifilm-raf",
  "video/x-m4v",
  "video/3gpp2",
  "application/x-esri-shape",
  "audio/aac",
  "audio/x-it",
  "audio/x-s3m",
  "audio/x-xm",
  "video/MP1S",
  "video/MP2P",
  "application/vnd.sketchup.skp",
  "image/avif",
  "application/x-lzh-compressed",
  "application/pgp-encrypted",
  "application/x-asar",
  "model/stl",
  "application/vnd.ms-htmlhelp",
  "model/3mf",
  "image/jxl",
  "application/zstd",
  "image/jls",
  "application/vnd.ms-outlook",
  "image/vnd.dwg",
  "application/x-parquet",
  "application/java-vm",
  "application/x-arj",
  "application/x-cpio",
  "application/x-ace-compressed",
  "application/avro",
  "application/vnd.iccprofile",
  "application/x.autodesk.fbx",
  // Invented by us
  "application/vnd.visio",
  "application/vnd.android.package-archive"
];

// ../../node_modules/.pnpm/file-type@19.6.0/node_modules/file-type/core.js
var reasonableDetectionSizeInBytes = 4100;
async function fileTypeFromBuffer(input) {
  return new FileTypeParser().fromBuffer(input);
}
function _check(buffer, headers, options) {
  options = {
    offset: 0,
    ...options
  };
  for (const [index, header] of headers.entries()) {
    if (options.mask) {
      if (header !== (options.mask[index] & buffer[index + options.offset])) {
        return false;
      }
    } else if (header !== buffer[index + options.offset]) {
      return false;
    }
  }
  return true;
}
var FileTypeParser = class {
  constructor(options) {
    this.detectors = options?.customDetectors;
    this.tokenizerOptions = {
      abortSignal: options?.signal
    };
    this.fromTokenizer = this.fromTokenizer.bind(this);
    this.fromBuffer = this.fromBuffer.bind(this);
    this.parse = this.parse.bind(this);
  }
  async fromTokenizer(tokenizer) {
    const initialPosition = tokenizer.position;
    for (const detector of this.detectors || []) {
      const fileType = await detector(tokenizer);
      if (fileType) {
        return fileType;
      }
      if (initialPosition !== tokenizer.position) {
        return void 0;
      }
    }
    return this.parse(tokenizer);
  }
  async fromBuffer(input) {
    if (!(input instanceof Uint8Array || input instanceof ArrayBuffer)) {
      throw new TypeError(`Expected the \`input\` argument to be of type \`Uint8Array\` or \`ArrayBuffer\`, got \`${typeof input}\``);
    }
    const buffer = input instanceof Uint8Array ? input : new Uint8Array(input);
    if (!(buffer?.length > 1)) {
      return;
    }
    return this.fromTokenizer(fromBuffer(buffer, this.tokenizerOptions));
  }
  async fromBlob(blob) {
    return this.fromStream(blob.stream());
  }
  async fromStream(stream) {
    const tokenizer = await fromWebStream(stream, this.tokenizerOptions);
    try {
      return await this.fromTokenizer(tokenizer);
    } finally {
      await tokenizer.close();
    }
  }
  async toDetectionStream(stream, options) {
    const { sampleSize = reasonableDetectionSizeInBytes } = options;
    let detectedFileType;
    let firstChunk;
    const reader = stream.getReader({ mode: "byob" });
    try {
      const { value: chunk, done } = await reader.read(new Uint8Array(sampleSize));
      firstChunk = chunk;
      if (!done && chunk) {
        try {
          detectedFileType = await this.fromBuffer(chunk.slice(0, sampleSize));
        } catch (error) {
          if (!(error instanceof EndOfStreamError)) {
            throw error;
          }
          detectedFileType = void 0;
        }
      }
      firstChunk = chunk;
    } finally {
      reader.releaseLock();
    }
    const transformStream = new TransformStream({
      async start(controller) {
        controller.enqueue(firstChunk);
      },
      transform(chunk, controller) {
        controller.enqueue(chunk);
      }
    });
    const newStream = stream.pipeThrough(transformStream);
    newStream.fileType = detectedFileType;
    return newStream;
  }
  check(header, options) {
    return _check(this.buffer, header, options);
  }
  checkString(header, options) {
    return this.check(stringToBytes(header), options);
  }
  async parse(tokenizer) {
    this.buffer = new Uint8Array(reasonableDetectionSizeInBytes);
    if (tokenizer.fileInfo.size === void 0) {
      tokenizer.fileInfo.size = Number.MAX_SAFE_INTEGER;
    }
    this.tokenizer = tokenizer;
    await tokenizer.peekBuffer(this.buffer, { length: 12, mayBeLess: true });
    if (this.check([66, 77])) {
      return {
        ext: "bmp",
        mime: "image/bmp"
      };
    }
    if (this.check([11, 119])) {
      return {
        ext: "ac3",
        mime: "audio/vnd.dolby.dd-raw"
      };
    }
    if (this.check([120, 1])) {
      return {
        ext: "dmg",
        mime: "application/x-apple-diskimage"
      };
    }
    if (this.check([77, 90])) {
      return {
        ext: "exe",
        mime: "application/x-msdownload"
      };
    }
    if (this.check([37, 33])) {
      await tokenizer.peekBuffer(this.buffer, { length: 24, mayBeLess: true });
      if (this.checkString("PS-Adobe-", { offset: 2 }) && this.checkString(" EPSF-", { offset: 14 })) {
        return {
          ext: "eps",
          mime: "application/eps"
        };
      }
      return {
        ext: "ps",
        mime: "application/postscript"
      };
    }
    if (this.check([31, 160]) || this.check([31, 157])) {
      return {
        ext: "Z",
        mime: "application/x-compress"
      };
    }
    if (this.check([199, 113])) {
      return {
        ext: "cpio",
        mime: "application/x-cpio"
      };
    }
    if (this.check([96, 234])) {
      return {
        ext: "arj",
        mime: "application/x-arj"
      };
    }
    if (this.check([239, 187, 191])) {
      this.tokenizer.ignore(3);
      return this.parse(tokenizer);
    }
    if (this.check([71, 73, 70])) {
      return {
        ext: "gif",
        mime: "image/gif"
      };
    }
    if (this.check([73, 73, 188])) {
      return {
        ext: "jxr",
        mime: "image/vnd.ms-photo"
      };
    }
    if (this.check([31, 139, 8])) {
      return {
        ext: "gz",
        mime: "application/gzip"
      };
    }
    if (this.check([66, 90, 104])) {
      return {
        ext: "bz2",
        mime: "application/x-bzip2"
      };
    }
    if (this.checkString("ID3")) {
      await tokenizer.ignore(6);
      const id3HeaderLength = await tokenizer.readToken(uint32SyncSafeToken);
      if (tokenizer.position + id3HeaderLength > tokenizer.fileInfo.size) {
        return {
          ext: "mp3",
          mime: "audio/mpeg"
        };
      }
      await tokenizer.ignore(id3HeaderLength);
      return this.fromTokenizer(tokenizer);
    }
    if (this.checkString("MP+")) {
      return {
        ext: "mpc",
        mime: "audio/x-musepack"
      };
    }
    if ((this.buffer[0] === 67 || this.buffer[0] === 70) && this.check([87, 83], { offset: 1 })) {
      return {
        ext: "swf",
        mime: "application/x-shockwave-flash"
      };
    }
    if (this.check([255, 216, 255])) {
      if (this.check([247], { offset: 3 })) {
        return {
          ext: "jls",
          mime: "image/jls"
        };
      }
      return {
        ext: "jpg",
        mime: "image/jpeg"
      };
    }
    if (this.check([79, 98, 106, 1])) {
      return {
        ext: "avro",
        mime: "application/avro"
      };
    }
    if (this.checkString("FLIF")) {
      return {
        ext: "flif",
        mime: "image/flif"
      };
    }
    if (this.checkString("8BPS")) {
      return {
        ext: "psd",
        mime: "image/vnd.adobe.photoshop"
      };
    }
    if (this.checkString("WEBP", { offset: 8 })) {
      return {
        ext: "webp",
        mime: "image/webp"
      };
    }
    if (this.checkString("MPCK")) {
      return {
        ext: "mpc",
        mime: "audio/x-musepack"
      };
    }
    if (this.checkString("FORM")) {
      return {
        ext: "aif",
        mime: "audio/aiff"
      };
    }
    if (this.checkString("icns", { offset: 0 })) {
      return {
        ext: "icns",
        mime: "image/icns"
      };
    }
    if (this.check([80, 75, 3, 4])) {
      try {
        while (tokenizer.position + 30 < tokenizer.fileInfo.size) {
          await tokenizer.readBuffer(this.buffer, { length: 30 });
          const view = new DataView(this.buffer.buffer);
          const zipHeader = {
            compressedSize: view.getUint32(18, true),
            uncompressedSize: view.getUint32(22, true),
            filenameLength: view.getUint16(26, true),
            extraFieldLength: view.getUint16(28, true)
          };
          zipHeader.filename = await tokenizer.readToken(new StringType(zipHeader.filenameLength, "utf-8"));
          await tokenizer.ignore(zipHeader.extraFieldLength);
          if (/classes\d*\.dex/.test(zipHeader.filename)) {
            return {
              ext: "apk",
              mime: "application/vnd.android.package-archive"
            };
          }
          if (zipHeader.filename === "META-INF/mozilla.rsa") {
            return {
              ext: "xpi",
              mime: "application/x-xpinstall"
            };
          }
          if (zipHeader.filename.endsWith(".rels") || zipHeader.filename.endsWith(".xml")) {
            const type = zipHeader.filename.split("/")[0];
            switch (type) {
              case "_rels":
                break;
              case "word":
                return {
                  ext: "docx",
                  mime: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                };
              case "ppt":
                return {
                  ext: "pptx",
                  mime: "application/vnd.openxmlformats-officedocument.presentationml.presentation"
                };
              case "xl":
                return {
                  ext: "xlsx",
                  mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                };
              case "visio":
                return {
                  ext: "vsdx",
                  mime: "application/vnd.visio"
                };
              default:
                break;
            }
          }
          if (zipHeader.filename.startsWith("xl/")) {
            return {
              ext: "xlsx",
              mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            };
          }
          if (zipHeader.filename.startsWith("3D/") && zipHeader.filename.endsWith(".model")) {
            return {
              ext: "3mf",
              mime: "model/3mf"
            };
          }
          if (zipHeader.filename === "mimetype" && zipHeader.compressedSize === zipHeader.uncompressedSize) {
            let mimeType = await tokenizer.readToken(new StringType(zipHeader.compressedSize, "utf-8"));
            mimeType = mimeType.trim();
            switch (mimeType) {
              case "application/epub+zip":
                return {
                  ext: "epub",
                  mime: "application/epub+zip"
                };
              case "application/vnd.oasis.opendocument.text":
                return {
                  ext: "odt",
                  mime: "application/vnd.oasis.opendocument.text"
                };
              case "application/vnd.oasis.opendocument.spreadsheet":
                return {
                  ext: "ods",
                  mime: "application/vnd.oasis.opendocument.spreadsheet"
                };
              case "application/vnd.oasis.opendocument.presentation":
                return {
                  ext: "odp",
                  mime: "application/vnd.oasis.opendocument.presentation"
                };
              default:
            }
          }
          if (zipHeader.compressedSize === 0) {
            let nextHeaderIndex = -1;
            while (nextHeaderIndex < 0 && tokenizer.position < tokenizer.fileInfo.size) {
              await tokenizer.peekBuffer(this.buffer, { mayBeLess: true });
              nextHeaderIndex = indexOf(this.buffer, new Uint8Array([80, 75, 3, 4]));
              await tokenizer.ignore(nextHeaderIndex >= 0 ? nextHeaderIndex : this.buffer.length);
            }
          } else {
            await tokenizer.ignore(zipHeader.compressedSize);
          }
        }
      } catch (error) {
        if (!(error instanceof EndOfStreamError)) {
          throw error;
        }
      }
      return {
        ext: "zip",
        mime: "application/zip"
      };
    }
    if (this.checkString("OggS")) {
      await tokenizer.ignore(28);
      const type = new Uint8Array(8);
      await tokenizer.readBuffer(type);
      if (_check(type, [79, 112, 117, 115, 72, 101, 97, 100])) {
        return {
          ext: "opus",
          mime: "audio/ogg; codecs=opus"
        };
      }
      if (_check(type, [128, 116, 104, 101, 111, 114, 97])) {
        return {
          ext: "ogv",
          mime: "video/ogg"
        };
      }
      if (_check(type, [1, 118, 105, 100, 101, 111, 0])) {
        return {
          ext: "ogm",
          mime: "video/ogg"
        };
      }
      if (_check(type, [127, 70, 76, 65, 67])) {
        return {
          ext: "oga",
          mime: "audio/ogg"
        };
      }
      if (_check(type, [83, 112, 101, 101, 120, 32, 32])) {
        return {
          ext: "spx",
          mime: "audio/ogg"
        };
      }
      if (_check(type, [1, 118, 111, 114, 98, 105, 115])) {
        return {
          ext: "ogg",
          mime: "audio/ogg"
        };
      }
      return {
        ext: "ogx",
        mime: "application/ogg"
      };
    }
    if (this.check([80, 75]) && (this.buffer[2] === 3 || this.buffer[2] === 5 || this.buffer[2] === 7) && (this.buffer[3] === 4 || this.buffer[3] === 6 || this.buffer[3] === 8)) {
      return {
        ext: "zip",
        mime: "application/zip"
      };
    }
    if (this.checkString("ftyp", { offset: 4 }) && (this.buffer[8] & 96) !== 0) {
      const brandMajor = new StringType(4, "latin1").get(this.buffer, 8).replace("\0", " ").trim();
      switch (brandMajor) {
        case "avif":
        case "avis":
          return { ext: "avif", mime: "image/avif" };
        case "mif1":
          return { ext: "heic", mime: "image/heif" };
        case "msf1":
          return { ext: "heic", mime: "image/heif-sequence" };
        case "heic":
        case "heix":
          return { ext: "heic", mime: "image/heic" };
        case "hevc":
        case "hevx":
          return { ext: "heic", mime: "image/heic-sequence" };
        case "qt":
          return { ext: "mov", mime: "video/quicktime" };
        case "M4V":
        case "M4VH":
        case "M4VP":
          return { ext: "m4v", mime: "video/x-m4v" };
        case "M4P":
          return { ext: "m4p", mime: "video/mp4" };
        case "M4B":
          return { ext: "m4b", mime: "audio/mp4" };
        case "M4A":
          return { ext: "m4a", mime: "audio/x-m4a" };
        case "F4V":
          return { ext: "f4v", mime: "video/mp4" };
        case "F4P":
          return { ext: "f4p", mime: "video/mp4" };
        case "F4A":
          return { ext: "f4a", mime: "audio/mp4" };
        case "F4B":
          return { ext: "f4b", mime: "audio/mp4" };
        case "crx":
          return { ext: "cr3", mime: "image/x-canon-cr3" };
        default:
          if (brandMajor.startsWith("3g")) {
            if (brandMajor.startsWith("3g2")) {
              return { ext: "3g2", mime: "video/3gpp2" };
            }
            return { ext: "3gp", mime: "video/3gpp" };
          }
          return { ext: "mp4", mime: "video/mp4" };
      }
    }
    if (this.checkString("MThd")) {
      return {
        ext: "mid",
        mime: "audio/midi"
      };
    }
    if (this.checkString("wOFF") && (this.check([0, 1, 0, 0], { offset: 4 }) || this.checkString("OTTO", { offset: 4 }))) {
      return {
        ext: "woff",
        mime: "font/woff"
      };
    }
    if (this.checkString("wOF2") && (this.check([0, 1, 0, 0], { offset: 4 }) || this.checkString("OTTO", { offset: 4 }))) {
      return {
        ext: "woff2",
        mime: "font/woff2"
      };
    }
    if (this.check([212, 195, 178, 161]) || this.check([161, 178, 195, 212])) {
      return {
        ext: "pcap",
        mime: "application/vnd.tcpdump.pcap"
      };
    }
    if (this.checkString("DSD ")) {
      return {
        ext: "dsf",
        mime: "audio/x-dsf"
        // Non-standard
      };
    }
    if (this.checkString("LZIP")) {
      return {
        ext: "lz",
        mime: "application/x-lzip"
      };
    }
    if (this.checkString("fLaC")) {
      return {
        ext: "flac",
        mime: "audio/x-flac"
      };
    }
    if (this.check([66, 80, 71, 251])) {
      return {
        ext: "bpg",
        mime: "image/bpg"
      };
    }
    if (this.checkString("wvpk")) {
      return {
        ext: "wv",
        mime: "audio/wavpack"
      };
    }
    if (this.checkString("%PDF")) {
      try {
        await tokenizer.ignore(1350);
        const maxBufferSize2 = 10 * 1024 * 1024;
        const buffer = new Uint8Array(Math.min(maxBufferSize2, tokenizer.fileInfo.size));
        await tokenizer.readBuffer(buffer, { mayBeLess: true });
        if (includes(buffer, new TextEncoder().encode("AIPrivateData"))) {
          return {
            ext: "ai",
            mime: "application/postscript"
          };
        }
      } catch (error) {
        if (!(error instanceof EndOfStreamError)) {
          throw error;
        }
      }
      return {
        ext: "pdf",
        mime: "application/pdf"
      };
    }
    if (this.check([0, 97, 115, 109])) {
      return {
        ext: "wasm",
        mime: "application/wasm"
      };
    }
    if (this.check([73, 73])) {
      const fileType = await this.readTiffHeader(false);
      if (fileType) {
        return fileType;
      }
    }
    if (this.check([77, 77])) {
      const fileType = await this.readTiffHeader(true);
      if (fileType) {
        return fileType;
      }
    }
    if (this.checkString("MAC ")) {
      return {
        ext: "ape",
        mime: "audio/ape"
      };
    }
    if (this.check([26, 69, 223, 163])) {
      async function readField() {
        const msb = await tokenizer.peekNumber(UINT8);
        let mask = 128;
        let ic = 0;
        while ((msb & mask) === 0 && mask !== 0) {
          ++ic;
          mask >>= 1;
        }
        const id = new Uint8Array(ic + 1);
        await tokenizer.readBuffer(id);
        return id;
      }
      async function readElement() {
        const idField = await readField();
        const lengthField = await readField();
        lengthField[0] ^= 128 >> lengthField.length - 1;
        const nrLength = Math.min(6, lengthField.length);
        const idView = new DataView(idField.buffer);
        const lengthView = new DataView(lengthField.buffer, lengthField.length - nrLength, nrLength);
        return {
          id: getUintBE(idView),
          len: getUintBE(lengthView)
        };
      }
      async function readChildren(children) {
        while (children > 0) {
          const element = await readElement();
          if (element.id === 17026) {
            const rawValue = await tokenizer.readToken(new StringType(element.len));
            return rawValue.replaceAll(/\00.*$/g, "");
          }
          await tokenizer.ignore(element.len);
          --children;
        }
      }
      const re = await readElement();
      const docType = await readChildren(re.len);
      switch (docType) {
        case "webm":
          return {
            ext: "webm",
            mime: "video/webm"
          };
        case "matroska":
          return {
            ext: "mkv",
            mime: "video/x-matroska"
          };
        default:
          return;
      }
    }
    if (this.check([82, 73, 70, 70])) {
      if (this.check([65, 86, 73], { offset: 8 })) {
        return {
          ext: "avi",
          mime: "video/vnd.avi"
        };
      }
      if (this.check([87, 65, 86, 69], { offset: 8 })) {
        return {
          ext: "wav",
          mime: "audio/wav"
        };
      }
      if (this.check([81, 76, 67, 77], { offset: 8 })) {
        return {
          ext: "qcp",
          mime: "audio/qcelp"
        };
      }
    }
    if (this.checkString("SQLi")) {
      return {
        ext: "sqlite",
        mime: "application/x-sqlite3"
      };
    }
    if (this.check([78, 69, 83, 26])) {
      return {
        ext: "nes",
        mime: "application/x-nintendo-nes-rom"
      };
    }
    if (this.checkString("Cr24")) {
      return {
        ext: "crx",
        mime: "application/x-google-chrome-extension"
      };
    }
    if (this.checkString("MSCF") || this.checkString("ISc(")) {
      return {
        ext: "cab",
        mime: "application/vnd.ms-cab-compressed"
      };
    }
    if (this.check([237, 171, 238, 219])) {
      return {
        ext: "rpm",
        mime: "application/x-rpm"
      };
    }
    if (this.check([197, 208, 211, 198])) {
      return {
        ext: "eps",
        mime: "application/eps"
      };
    }
    if (this.check([40, 181, 47, 253])) {
      return {
        ext: "zst",
        mime: "application/zstd"
      };
    }
    if (this.check([127, 69, 76, 70])) {
      return {
        ext: "elf",
        mime: "application/x-elf"
      };
    }
    if (this.check([33, 66, 68, 78])) {
      return {
        ext: "pst",
        mime: "application/vnd.ms-outlook"
      };
    }
    if (this.checkString("PAR1")) {
      return {
        ext: "parquet",
        mime: "application/x-parquet"
      };
    }
    if (this.check([207, 250, 237, 254])) {
      return {
        ext: "macho",
        mime: "application/x-mach-binary"
      };
    }
    if (this.check([79, 84, 84, 79, 0])) {
      return {
        ext: "otf",
        mime: "font/otf"
      };
    }
    if (this.checkString("#!AMR")) {
      return {
        ext: "amr",
        mime: "audio/amr"
      };
    }
    if (this.checkString("{\\rtf")) {
      return {
        ext: "rtf",
        mime: "application/rtf"
      };
    }
    if (this.check([70, 76, 86, 1])) {
      return {
        ext: "flv",
        mime: "video/x-flv"
      };
    }
    if (this.checkString("IMPM")) {
      return {
        ext: "it",
        mime: "audio/x-it"
      };
    }
    if (this.checkString("-lh0-", { offset: 2 }) || this.checkString("-lh1-", { offset: 2 }) || this.checkString("-lh2-", { offset: 2 }) || this.checkString("-lh3-", { offset: 2 }) || this.checkString("-lh4-", { offset: 2 }) || this.checkString("-lh5-", { offset: 2 }) || this.checkString("-lh6-", { offset: 2 }) || this.checkString("-lh7-", { offset: 2 }) || this.checkString("-lzs-", { offset: 2 }) || this.checkString("-lz4-", { offset: 2 }) || this.checkString("-lz5-", { offset: 2 }) || this.checkString("-lhd-", { offset: 2 })) {
      return {
        ext: "lzh",
        mime: "application/x-lzh-compressed"
      };
    }
    if (this.check([0, 0, 1, 186])) {
      if (this.check([33], { offset: 4, mask: [241] })) {
        return {
          ext: "mpg",
          // May also be .ps, .mpeg
          mime: "video/MP1S"
        };
      }
      if (this.check([68], { offset: 4, mask: [196] })) {
        return {
          ext: "mpg",
          // May also be .mpg, .m2p, .vob or .sub
          mime: "video/MP2P"
        };
      }
    }
    if (this.checkString("ITSF")) {
      return {
        ext: "chm",
        mime: "application/vnd.ms-htmlhelp"
      };
    }
    if (this.check([202, 254, 186, 190])) {
      return {
        ext: "class",
        mime: "application/java-vm"
      };
    }
    if (this.check([253, 55, 122, 88, 90, 0])) {
      return {
        ext: "xz",
        mime: "application/x-xz"
      };
    }
    if (this.checkString("<?xml ")) {
      return {
        ext: "xml",
        mime: "application/xml"
      };
    }
    if (this.check([55, 122, 188, 175, 39, 28])) {
      return {
        ext: "7z",
        mime: "application/x-7z-compressed"
      };
    }
    if (this.check([82, 97, 114, 33, 26, 7]) && (this.buffer[6] === 0 || this.buffer[6] === 1)) {
      return {
        ext: "rar",
        mime: "application/x-rar-compressed"
      };
    }
    if (this.checkString("solid ")) {
      return {
        ext: "stl",
        mime: "model/stl"
      };
    }
    if (this.checkString("AC")) {
      const version = new StringType(4, "latin1").get(this.buffer, 2);
      if (version.match("^d*") && version >= 1e3 && version <= 1050) {
        return {
          ext: "dwg",
          mime: "image/vnd.dwg"
        };
      }
    }
    if (this.checkString("070707")) {
      return {
        ext: "cpio",
        mime: "application/x-cpio"
      };
    }
    if (this.checkString("BLENDER")) {
      return {
        ext: "blend",
        mime: "application/x-blender"
      };
    }
    if (this.checkString("!<arch>")) {
      await tokenizer.ignore(8);
      const string5 = await tokenizer.readToken(new StringType(13, "ascii"));
      if (string5 === "debian-binary") {
        return {
          ext: "deb",
          mime: "application/x-deb"
        };
      }
      return {
        ext: "ar",
        mime: "application/x-unix-archive"
      };
    }
    if (this.checkString("WEBVTT") && // One of LF, CR, tab, space, or end of file must follow "WEBVTT" per the spec (see `fixture/fixture-vtt-*.vtt` for examples). Note that `\0` is technically the null character (there is no such thing as an EOF character). However, checking for `\0` gives us the same result as checking for the end of the stream.
    ["\n", "\r", "	", " ", "\0"].some((char7) => this.checkString(char7, { offset: 6 }))) {
      return {
        ext: "vtt",
        mime: "text/vtt"
      };
    }
    if (this.check([137, 80, 78, 71, 13, 10, 26, 10])) {
      await tokenizer.ignore(8);
      async function readChunkHeader() {
        return {
          length: await tokenizer.readToken(INT32_BE),
          type: await tokenizer.readToken(new StringType(4, "latin1"))
        };
      }
      do {
        const chunk = await readChunkHeader();
        if (chunk.length < 0) {
          return;
        }
        switch (chunk.type) {
          case "IDAT":
            return {
              ext: "png",
              mime: "image/png"
            };
          case "acTL":
            return {
              ext: "apng",
              mime: "image/apng"
            };
          default:
            await tokenizer.ignore(chunk.length + 4);
        }
      } while (tokenizer.position + 8 < tokenizer.fileInfo.size);
      return {
        ext: "png",
        mime: "image/png"
      };
    }
    if (this.check([65, 82, 82, 79, 87, 49, 0, 0])) {
      return {
        ext: "arrow",
        mime: "application/x-apache-arrow"
      };
    }
    if (this.check([103, 108, 84, 70, 2, 0, 0, 0])) {
      return {
        ext: "glb",
        mime: "model/gltf-binary"
      };
    }
    if (this.check([102, 114, 101, 101], { offset: 4 }) || this.check([109, 100, 97, 116], { offset: 4 }) || this.check([109, 111, 111, 118], { offset: 4 }) || this.check([119, 105, 100, 101], { offset: 4 })) {
      return {
        ext: "mov",
        mime: "video/quicktime"
      };
    }
    if (this.check([73, 73, 82, 79, 8, 0, 0, 0, 24])) {
      return {
        ext: "orf",
        mime: "image/x-olympus-orf"
      };
    }
    if (this.checkString("gimp xcf ")) {
      return {
        ext: "xcf",
        mime: "image/x-xcf"
      };
    }
    if (this.check([73, 73, 85, 0, 24, 0, 0, 0, 136, 231, 116, 216])) {
      return {
        ext: "rw2",
        mime: "image/x-panasonic-rw2"
      };
    }
    if (this.check([48, 38, 178, 117, 142, 102, 207, 17, 166, 217])) {
      async function readHeader() {
        const guid = new Uint8Array(16);
        await tokenizer.readBuffer(guid);
        return {
          id: guid,
          size: Number(await tokenizer.readToken(UINT64_LE))
        };
      }
      await tokenizer.ignore(30);
      while (tokenizer.position + 24 < tokenizer.fileInfo.size) {
        const header = await readHeader();
        let payload = header.size - 24;
        if (_check(header.id, [145, 7, 220, 183, 183, 169, 207, 17, 142, 230, 0, 192, 12, 32, 83, 101])) {
          const typeId = new Uint8Array(16);
          payload -= await tokenizer.readBuffer(typeId);
          if (_check(typeId, [64, 158, 105, 248, 77, 91, 207, 17, 168, 253, 0, 128, 95, 92, 68, 43])) {
            return {
              ext: "asf",
              mime: "audio/x-ms-asf"
            };
          }
          if (_check(typeId, [192, 239, 25, 188, 77, 91, 207, 17, 168, 253, 0, 128, 95, 92, 68, 43])) {
            return {
              ext: "asf",
              mime: "video/x-ms-asf"
            };
          }
          break;
        }
        await tokenizer.ignore(payload);
      }
      return {
        ext: "asf",
        mime: "application/vnd.ms-asf"
      };
    }
    if (this.check([171, 75, 84, 88, 32, 49, 49, 187, 13, 10, 26, 10])) {
      return {
        ext: "ktx",
        mime: "image/ktx"
      };
    }
    if ((this.check([126, 16, 4]) || this.check([126, 24, 4])) && this.check([48, 77, 73, 69], { offset: 4 })) {
      return {
        ext: "mie",
        mime: "application/x-mie"
      };
    }
    if (this.check([39, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], { offset: 2 })) {
      return {
        ext: "shp",
        mime: "application/x-esri-shape"
      };
    }
    if (this.check([255, 79, 255, 81])) {
      return {
        ext: "j2c",
        mime: "image/j2c"
      };
    }
    if (this.check([0, 0, 0, 12, 106, 80, 32, 32, 13, 10, 135, 10])) {
      await tokenizer.ignore(20);
      const type = await tokenizer.readToken(new StringType(4, "ascii"));
      switch (type) {
        case "jp2 ":
          return {
            ext: "jp2",
            mime: "image/jp2"
          };
        case "jpx ":
          return {
            ext: "jpx",
            mime: "image/jpx"
          };
        case "jpm ":
          return {
            ext: "jpm",
            mime: "image/jpm"
          };
        case "mjp2":
          return {
            ext: "mj2",
            mime: "image/mj2"
          };
        default:
          return;
      }
    }
    if (this.check([255, 10]) || this.check([0, 0, 0, 12, 74, 88, 76, 32, 13, 10, 135, 10])) {
      return {
        ext: "jxl",
        mime: "image/jxl"
      };
    }
    if (this.check([254, 255])) {
      if (this.check([0, 60, 0, 63, 0, 120, 0, 109, 0, 108], { offset: 2 })) {
        return {
          ext: "xml",
          mime: "application/xml"
        };
      }
      return void 0;
    }
    if (this.check([0, 0, 1, 186]) || this.check([0, 0, 1, 179])) {
      return {
        ext: "mpg",
        mime: "video/mpeg"
      };
    }
    if (this.check([0, 1, 0, 0, 0])) {
      return {
        ext: "ttf",
        mime: "font/ttf"
      };
    }
    if (this.check([0, 0, 1, 0])) {
      return {
        ext: "ico",
        mime: "image/x-icon"
      };
    }
    if (this.check([0, 0, 2, 0])) {
      return {
        ext: "cur",
        mime: "image/x-icon"
      };
    }
    if (this.check([208, 207, 17, 224, 161, 177, 26, 225])) {
      return {
        ext: "cfb",
        mime: "application/x-cfb"
      };
    }
    await tokenizer.peekBuffer(this.buffer, { length: Math.min(256, tokenizer.fileInfo.size), mayBeLess: true });
    if (this.check([97, 99, 115, 112], { offset: 36 })) {
      return {
        ext: "icc",
        mime: "application/vnd.iccprofile"
      };
    }
    if (this.checkString("**ACE", { offset: 7 }) && this.checkString("**", { offset: 12 })) {
      return {
        ext: "ace",
        mime: "application/x-ace-compressed"
      };
    }
    if (this.checkString("BEGIN:")) {
      if (this.checkString("VCARD", { offset: 6 })) {
        return {
          ext: "vcf",
          mime: "text/vcard"
        };
      }
      if (this.checkString("VCALENDAR", { offset: 6 })) {
        return {
          ext: "ics",
          mime: "text/calendar"
        };
      }
    }
    if (this.checkString("FUJIFILMCCD-RAW")) {
      return {
        ext: "raf",
        mime: "image/x-fujifilm-raf"
      };
    }
    if (this.checkString("Extended Module:")) {
      return {
        ext: "xm",
        mime: "audio/x-xm"
      };
    }
    if (this.checkString("Creative Voice File")) {
      return {
        ext: "voc",
        mime: "audio/x-voc"
      };
    }
    if (this.check([4, 0, 0, 0]) && this.buffer.length >= 16) {
      const jsonSize = new DataView(this.buffer.buffer).getUint32(12, true);
      if (jsonSize > 12 && this.buffer.length >= jsonSize + 16) {
        try {
          const header = new TextDecoder().decode(this.buffer.slice(16, jsonSize + 16));
          const json = JSON.parse(header);
          if (json.files) {
            return {
              ext: "asar",
              mime: "application/x-asar"
            };
          }
        } catch {
        }
      }
    }
    if (this.check([6, 14, 43, 52, 2, 5, 1, 1, 13, 1, 2, 1, 1, 2])) {
      return {
        ext: "mxf",
        mime: "application/mxf"
      };
    }
    if (this.checkString("SCRM", { offset: 44 })) {
      return {
        ext: "s3m",
        mime: "audio/x-s3m"
      };
    }
    if (this.check([71]) && this.check([71], { offset: 188 })) {
      return {
        ext: "mts",
        mime: "video/mp2t"
      };
    }
    if (this.check([71], { offset: 4 }) && this.check([71], { offset: 196 })) {
      return {
        ext: "mts",
        mime: "video/mp2t"
      };
    }
    if (this.check([66, 79, 79, 75, 77, 79, 66, 73], { offset: 60 })) {
      return {
        ext: "mobi",
        mime: "application/x-mobipocket-ebook"
      };
    }
    if (this.check([68, 73, 67, 77], { offset: 128 })) {
      return {
        ext: "dcm",
        mime: "application/dicom"
      };
    }
    if (this.check([76, 0, 0, 0, 1, 20, 2, 0, 0, 0, 0, 0, 192, 0, 0, 0, 0, 0, 0, 70])) {
      return {
        ext: "lnk",
        mime: "application/x.ms.shortcut"
        // Invented by us
      };
    }
    if (this.check([98, 111, 111, 107, 0, 0, 0, 0, 109, 97, 114, 107, 0, 0, 0, 0])) {
      return {
        ext: "alias",
        mime: "application/x.apple.alias"
        // Invented by us
      };
    }
    if (this.checkString("Kaydara FBX Binary  \0")) {
      return {
        ext: "fbx",
        mime: "application/x.autodesk.fbx"
        // Invented by us
      };
    }
    if (this.check([76, 80], { offset: 34 }) && (this.check([0, 0, 1], { offset: 8 }) || this.check([1, 0, 2], { offset: 8 }) || this.check([2, 0, 2], { offset: 8 }))) {
      return {
        ext: "eot",
        mime: "application/vnd.ms-fontobject"
      };
    }
    if (this.check([6, 6, 237, 245, 216, 29, 70, 229, 189, 49, 239, 231, 254, 116, 183, 29])) {
      return {
        ext: "indd",
        mime: "application/x-indesign"
      };
    }
    await tokenizer.peekBuffer(this.buffer, { length: Math.min(512, tokenizer.fileInfo.size), mayBeLess: true });
    if (tarHeaderChecksumMatches(this.buffer)) {
      return {
        ext: "tar",
        mime: "application/x-tar"
      };
    }
    if (this.check([255, 254])) {
      if (this.check([60, 0, 63, 0, 120, 0, 109, 0, 108, 0], { offset: 2 })) {
        return {
          ext: "xml",
          mime: "application/xml"
        };
      }
      if (this.check([255, 14, 83, 0, 107, 0, 101, 0, 116, 0, 99, 0, 104, 0, 85, 0, 112, 0, 32, 0, 77, 0, 111, 0, 100, 0, 101, 0, 108, 0], { offset: 2 })) {
        return {
          ext: "skp",
          mime: "application/vnd.sketchup.skp"
        };
      }
      return void 0;
    }
    if (this.checkString("-----BEGIN PGP MESSAGE-----")) {
      return {
        ext: "pgp",
        mime: "application/pgp-encrypted"
      };
    }
    if (this.buffer.length >= 2 && this.check([255, 224], { offset: 0, mask: [255, 224] })) {
      if (this.check([16], { offset: 1, mask: [22] })) {
        if (this.check([8], { offset: 1, mask: [8] })) {
          return {
            ext: "aac",
            mime: "audio/aac"
          };
        }
        return {
          ext: "aac",
          mime: "audio/aac"
        };
      }
      if (this.check([2], { offset: 1, mask: [6] })) {
        return {
          ext: "mp3",
          mime: "audio/mpeg"
        };
      }
      if (this.check([4], { offset: 1, mask: [6] })) {
        return {
          ext: "mp2",
          mime: "audio/mpeg"
        };
      }
      if (this.check([6], { offset: 1, mask: [6] })) {
        return {
          ext: "mp1",
          mime: "audio/mpeg"
        };
      }
    }
  }
  async readTiffTag(bigEndian) {
    const tagId = await this.tokenizer.readToken(bigEndian ? UINT16_BE : UINT16_LE);
    this.tokenizer.ignore(10);
    switch (tagId) {
      case 50341:
        return {
          ext: "arw",
          mime: "image/x-sony-arw"
        };
      case 50706:
        return {
          ext: "dng",
          mime: "image/x-adobe-dng"
        };
    }
  }
  async readTiffIFD(bigEndian) {
    const numberOfTags = await this.tokenizer.readToken(bigEndian ? UINT16_BE : UINT16_LE);
    for (let n = 0; n < numberOfTags; ++n) {
      const fileType = await this.readTiffTag(bigEndian);
      if (fileType) {
        return fileType;
      }
    }
  }
  async readTiffHeader(bigEndian) {
    const version = (bigEndian ? UINT16_BE : UINT16_LE).get(this.buffer, 2);
    const ifdOffset = (bigEndian ? UINT32_BE : UINT32_LE).get(this.buffer, 4);
    if (version === 42) {
      if (ifdOffset >= 6) {
        if (this.checkString("CR", { offset: 8 })) {
          return {
            ext: "cr2",
            mime: "image/x-canon-cr2"
          };
        }
        if (ifdOffset >= 8 && (this.check([28, 0, 254, 0], { offset: 8 }) || this.check([31, 0, 11, 0], { offset: 8 }))) {
          return {
            ext: "nef",
            mime: "image/x-nikon-nef"
          };
        }
      }
      await this.tokenizer.ignore(ifdOffset);
      const fileType = await this.readTiffIFD(bigEndian);
      return fileType ?? {
        ext: "tif",
        mime: "image/tiff"
      };
    }
    if (version === 43) {
      return {
        ext: "tif",
        mime: "image/tiff"
      };
    }
  }
};
new Set(extensions);
new Set(mimeTypes);

// src/utils.ts
var ErrorCodes = /* @__PURE__ */ ((ErrorCodes2) => {
  ErrorCodes2["ASSET_NOT_FOUND"] = "ASSET_NOT_FOUND";
  ErrorCodes2["INVALID_DOTLOTTIE"] = "INVALID_DOTLOTTIE";
  ErrorCodes2["INVALID_STATEMACHINE"] = "INVALID_STATEMACHINE";
  ErrorCodes2["INVALID_URL"] = "INVALID_URL";
  return ErrorCodes2;
})(ErrorCodes || {});
var DotLottieError = class extends Error {
  constructor(message, code) {
    super(message);
    __publicField(this, "code");
    this.name = "[dotLottie-js]";
    this.code = code;
  }
};
var base64ToUint8Array = (base64String) => {
  const withoutMeta = base64String.substring(base64String.indexOf(",") + 1);
  const binaryString = typeof window === "undefined" ? Buffer.from(withoutMeta, "base64").toString("binary") : atob(withoutMeta);
  const uint8Array = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i += 1) {
    uint8Array[i] = binaryString.charCodeAt(i);
  }
  return uint8Array;
};
var getMimeTypeFromUint8Data = async (file) => {
  const data = await fileTypeFromBuffer(file);
  return data?.mime.toString();
};
var getMimeTypeFromBase64 = async (base64) => {
  const data = base64ToUint8Array(base64);
  const mime = await fileTypeFromBuffer(data);
  return mime?.mime.toString();
};
var getExtensionTypeFromBase64 = async (base64) => {
  const data = base64ToUint8Array(base64);
  const mime = await fileTypeFromBuffer(data);
  if (mime?.ext.toString() === "jpg") {
    return "jpeg";
  }
  return mime?.ext.toString();
};
var isValidURL = (url) => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};
async function dataUrlFromU8(uint8Data) {
  let base64;
  if (typeof window === "undefined") {
    base64 = Buffer.from(uint8Data).toString("base64");
  } else {
    const binaryString = Array.prototype.map.call(uint8Data, (byte) => String.fromCharCode(byte)).join("");
    base64 = window.btoa(binaryString);
  }
  const mimeType = await getMimeTypeFromUint8Data(uint8Data);
  return `data:${mimeType};base64,${base64}`;
}
function isImageAsset(asset) {
  return "w" in asset && "h" in asset && !("xt" in asset) && "p" in asset;
}
function isAudioAsset(asset) {
  return !("h" in asset) && !("w" in asset) && "p" in asset && "e" in asset && "u" in asset && "id" in asset;
}
async function unzipDotLottie(dotLottie, filter = () => true) {
  if (!(dotLottie instanceof Uint8Array)) {
    throw new DotLottieError("dotLottie not found", "INVALID_DOTLOTTIE" /* INVALID_DOTLOTTIE */);
  }
  const unzipped = await new Promise((resolve, reject) => {
    unzip(dotLottie, { filter }, (err, data) => {
      if (err) {
        reject(err);
      }
      resolve(data);
    });
  });
  return unzipped;
}
async function unzipDotLottieFile(dotLottie, path, filter) {
  if (!(dotLottie instanceof Uint8Array)) {
    throw new DotLottieError("Invalid dotLottie", "INVALID_DOTLOTTIE" /* INVALID_DOTLOTTIE */);
  }
  const unzipped = await unzipDotLottie(dotLottie, (file) => file.name === path && (!filter || filter(file)));
  return unzipped[path];
}
async function getManifest(dotLottie) {
  const manifestFileName = "manifest.json";
  const unzipped = await unzipDotLottie(dotLottie, (file) => file.name === manifestFileName);
  const unzippedManifest = unzipped[manifestFileName];
  if (typeof unzippedManifest === "undefined") {
    return void 0;
  }
  return JSON.parse(strFromU8(unzippedManifest, false));
}
async function getDotLottieVersion(dotLottie) {
  const manifest = await getManifest(dotLottie);
  return manifest?.version ?? "1.0.0";
}
async function validateDotLottie(dotLottie) {
  if (!(dotLottie instanceof Uint8Array)) {
    return { success: false, error: "dotLottie not found" };
  }
  const manifest = await getManifest(dotLottie);
  if (typeof manifest === "undefined") {
    return { success: false, error: "manifest.json is missing" };
  }
  return { success: true };
}
async function loadFromArrayBuffer(arrayBuffer) {
  const dotLottie = new Uint8Array(arrayBuffer);
  const validationResult = await validateDotLottie(dotLottie);
  if (validationResult.error) {
    throw new DotLottieError(validationResult.error, "INVALID_DOTLOTTIE" /* INVALID_DOTLOTTIE */);
  }
  return dotLottie;
}
async function loadFromURL(src) {
  if (!isValidURL(src)) {
    throw new DotLottieError("Invalid url provided for .lottie file", "INVALID_URL" /* INVALID_URL */);
  }
  const response = await fetch(src);
  const arrayBuffer = await response.arrayBuffer();
  const zipMagicHeader = new Uint8Array([80, 75, 3, 4]);
  const header = new Uint8Array(arrayBuffer.slice(0, 4));
  if (!header.every((value, index) => value === zipMagicHeader[index])) {
    throw new DotLottieError("Invalid .lottie file", "INVALID_DOTLOTTIE" /* INVALID_DOTLOTTIE */);
  }
  const dotLottie = await loadFromArrayBuffer(arrayBuffer);
  return dotLottie;
}
async function getAudio(dotLottie, filename, filter) {
  const version = await getDotLottieVersion(dotLottie);
  let audioPath = "audio/";
  if (version === "2") {
    audioPath = "u/";
  }
  const audioFilename = `${audioPath}${filename}`;
  const unzipped = await unzipDotLottieFile(dotLottie, audioFilename, filter);
  if (typeof unzipped === "undefined") {
    return void 0;
  }
  return dataUrlFromU8(unzipped);
}
async function getAllAudio(dotLottie, filter) {
  const version = await getDotLottieVersion(dotLottie);
  let audioPath = "audio/";
  if (version === "2") {
    audioPath = "u/";
  }
  const unzippedAudio = await unzipDotLottie(dotLottie, (file) => {
    const name = file.name.replace(audioPath, "");
    return file.name.startsWith(audioPath) && (!filter || filter({ ...file, name }));
  });
  const audio = {};
  for (const audioFilename in unzippedAudio) {
    const unzippedSingleAudio = unzippedAudio[audioFilename];
    if (unzippedSingleAudio instanceof Uint8Array) {
      const audioId = audioFilename.replace(audioPath, "");
      audio[audioId] = await dataUrlFromU8(unzippedSingleAudio);
    }
  }
  return audio;
}
async function inlineAudioAssets(dotLottie, animations) {
  const audioMap = /* @__PURE__ */ new Map();
  for (const [animationId, animationData] of Object.entries(animations)) {
    for (const asset of animationData.assets || []) {
      if (isAudioAsset(asset)) {
        const audioId = asset.p;
        if (!audioMap.has(audioId)) {
          audioMap.set(audioId, /* @__PURE__ */ new Set());
        }
        audioMap.get(audioId)?.add(animationId);
      }
    }
  }
  const unzippedAudio = await getAllAudio(dotLottie, (file) => audioMap.has(file.name));
  for (const [audioId, animationIdsSet] of audioMap) {
    const audioDataURL = unzippedAudio[audioId];
    if (audioDataURL) {
      for (const animationId of animationIdsSet) {
        const animationData = animations[animationId];
        for (const asset of animationData?.assets || []) {
          if (isAudioAsset(asset) && asset.p === audioId) {
            asset.p = audioDataURL;
            asset.u = "";
            asset.e = 1;
          }
        }
      }
    }
  }
}
async function getImage(dotLottie, filename, filter) {
  const version = await getDotLottieVersion(dotLottie);
  let imagesPath = "images/";
  if (version === "2") {
    imagesPath = "i/";
  }
  const imageFilename = `${imagesPath}${filename}`;
  const unzipped = await unzipDotLottieFile(dotLottie, imageFilename, filter);
  if (typeof unzipped === "undefined") {
    return void 0;
  }
  return dataUrlFromU8(unzipped);
}
async function getImages(dotLottie, filter) {
  const version = await getDotLottieVersion(dotLottie);
  let imagesPath = "images/";
  if (version === "2") {
    imagesPath = "i/";
  }
  const unzippedImages = await unzipDotLottie(dotLottie, (file) => {
    const name = file.name.replace(imagesPath, "");
    return file.name.startsWith(imagesPath) && (!filter || filter({ ...file, name }));
  });
  const images = {};
  for (const imagePath in unzippedImages) {
    const unzippedImage = unzippedImages[imagePath];
    if (unzippedImage instanceof Uint8Array) {
      const imageId = imagePath.replace(imagePath, "");
      images[imageId] = await dataUrlFromU8(unzippedImage);
    }
  }
  return images;
}
async function inlineImageAssets(dotLottie, animations) {
  const imagesMap = /* @__PURE__ */ new Map();
  for (const [animationId, animationData] of Object.entries(animations)) {
    for (const asset of animationData.assets || []) {
      if (isImageAsset(asset)) {
        const imageId = asset.p;
        if (!imagesMap.has(imageId)) {
          imagesMap.set(imageId, /* @__PURE__ */ new Set());
        }
        imagesMap.get(imageId)?.add(animationId);
      }
    }
  }
  const unzippedImages = await getImages(dotLottie, (file) => imagesMap.has(file.name));
  for (const [imageId, animationIdsSet] of imagesMap) {
    const imageDataURL = unzippedImages[imageId];
    if (imageDataURL) {
      for (const animationId of animationIdsSet) {
        const animationData = animations[animationId];
        for (const asset of animationData?.assets || []) {
          if (isImageAsset(asset) && asset.p === imageId) {
            asset.p = imageDataURL;
            asset.u = "";
            asset.e = 1;
          }
        }
      }
    }
  }
}
async function getAnimation(dotLottie, animationId, { inlineAssets } = {}, filter) {
  const animationFilename = `animations/${animationId}.json`;
  const unzippedAnimation = await unzipDotLottieFile(dotLottie, animationFilename, filter);
  if (typeof unzippedAnimation === "undefined") {
    return void 0;
  }
  const animationData = JSON.parse(strFromU8(unzippedAnimation, false));
  if (!inlineAssets) {
    return animationData;
  }
  const animationsMap = {
    [animationId]: animationData
  };
  await inlineImageAssets(dotLottie, animationsMap);
  await inlineAudioAssets(dotLottie, animationsMap);
  return animationData;
}
async function getAnimations(dotLottie, { inlineAssets } = {}, filter) {
  const animationsMap = {};
  const version = await getDotLottieVersion(dotLottie);
  let animationsPath = "animations/";
  if (version === "2") {
    animationsPath = "a/";
  }
  const unzippedAnimations = await unzipDotLottie(dotLottie, (file) => {
    const filename = file.name.replace(animationsPath, "").replace(".json", "");
    return file.name.startsWith(animationsPath) && (!filter || filter({ ...file, name: filename }));
  });
  for (const animationPath in unzippedAnimations) {
    const data = unzippedAnimations[animationPath];
    if (data instanceof Uint8Array) {
      const animationId = animationPath.replace(animationsPath, "").replace(".json", "");
      const animationData = JSON.parse(strFromU8(data, false));
      animationsMap[animationId] = animationData;
    }
  }
  if (!inlineAssets) {
    return animationsMap;
  }
  await inlineImageAssets(dotLottie, animationsMap);
  return animationsMap;
}
async function getThemes(dotLottie, filter) {
  const themesMap = {};
  const unzippedThemes = await unzipDotLottie(dotLottie, (file) => {
    const name = file.name.replace("t/", "").replace(".json", "");
    return file.name.startsWith("t/") && (!filter || filter({ ...file, name }));
  });
  for (const themePath in unzippedThemes) {
    const data = unzippedThemes[themePath];
    if (data instanceof Uint8Array) {
      const themeId = themePath.replace("t/", "").replace(".json", "");
      themesMap[themeId] = JSON.parse(strFromU8(data, false));
    }
  }
  return themesMap;
}
async function getTheme(dotLottie, themeId, filter) {
  const themeFilename = `t/${themeId}.json`;
  const unzippedTheme = await unzipDotLottieFile(dotLottie, themeFilename, filter);
  if (typeof unzippedTheme === "undefined") {
    return void 0;
  }
  return JSON.parse(strFromU8(unzippedTheme, false));
}
async function getStateMachines(dotLottie, filter) {
  const statesMap = {};
  const unzippedStates = await unzipDotLottie(dotLottie, (file) => {
    const name = file.name.replace("s/", "").replace(".json", "");
    return file.name.startsWith("s/") && (!filter || filter({ ...file, name }));
  });
  for (const statePath in unzippedStates) {
    const data = unzippedStates[statePath];
    if (data instanceof Uint8Array) {
      const themeId = statePath.replace("s/", "").replace(".json", "");
      statesMap[themeId] = strFromU8(data, false);
    }
  }
  return statesMap;
}
async function getStateMachine(dotLottie, stateMachineId, filter) {
  const stateMachineFilename = `s/${stateMachineId}.json`;
  const unzippedStateMachine = await unzipDotLottieFile(dotLottie, stateMachineFilename, filter);
  if (typeof unzippedStateMachine === "undefined") {
    return void 0;
  }
  const stateMachine = JSON.parse(strFromU8(unzippedStateMachine, false));
  return stateMachine;
}

// package.json
var package_default = {
  name: "@dotlottie/dotlottie-js",
  version: "1.0.2",
  type: "module",
  description: "This library helps in creating and modifying .lottie files.",
  repository: {
    type: "git",
    url: "git+https://github.com/dotlottie/dotlottie-js.git",
    directory: "packages/dotlottie-js"
  },
  homepage: "https://github.com/dotlottie/dotlottie-js#readme",
  bugs: "https://github.com/dotlottie/dotlottie-js/issues",
  author: "dotLottie",
  contributors: [
    "Karam Ali <karam@lottiefiles.com>",
    "Sam Osborne <sam@lottiefiles.com>",
    "Jawish Hameed <jawish@lottiefiles.com>",
    "Abdelrahman Ashraf <a.theashraf@gmail.com>"
  ],
  license: "MIT",
  engines: {
    node: ">=18.0.0"
  },
  main: "./dist/index.node.js",
  exports: {
    ".": {
      node: "./dist/index.node.js",
      default: "./dist/index.browser.js"
    },
    "./*": "./dist/*.js"
  },
  browser: "dist/index.browser.js",
  types: "./dist/index.browser.d.ts",
  typesVersions: {
    "*": {
      "*": [
        "dist/*",
        "dist/index.browser.d.ts"
      ]
    }
  },
  files: [
    "dist"
  ],
  scripts: {
    build: "tsup",
    dev: "tsup --watch",
    docs: "typedoc src",
    lint: "eslint --fix .",
    "stats:eslint": "cross-env TIMING=1 eslint .",
    "stats:ts": "tsc -p tsconfig.build.json --extendedDiagnostics",
    test: "pnpm run test:node && pnpm run test:browser",
    "test:browser": "vitest --config=vitest.browser.config.js",
    "test:node": "vitest --config=vitest.config.js",
    "type-check": "tsc --noEmit"
  },
  dependencies: {
    "@lottie-animation-community/lottie-types": "^1.2.0",
    "browser-image-hash": "^0.0.5",
    fflate: "^0.8.1",
    "file-type": "^19.6.0",
    sharp: "^0.33.2",
    "sharp-phash": "^2.1.0",
    valibot: "^0.13.1"
  },
  devDependencies: {
    "@types/jasmine": "4.3.5",
    "@types/node": "22.8.7",
    "@types/sharp": "0.31.1",
    "@vitest/browser": "2.1.3",
    "@vitest/coverage-v8": "2.1.3",
    "cross-env": "7.0.3",
    "js-base64": "3.7.5",
    nodemon: "2.0.20",
    playwright: "^1.48.2",
    tsup: "8.3.0",
    typescript: "4.7.4",
    "vite-plugin-arraybuffer": "^0.0.8",
    vitest: "^2.1.3"
  },
  publishConfig: {
    access: "public"
  }
};

// src/constants.ts
var PACKAGE_NAME = `${package_default.name}@${package_default.version}`;
var ManifestAnimationSchema = object({
  id: string(),
  name: optional(string()),
  initialTheme: optional(string()),
  background: optional(string()),
  themes: optional(array(string()))
});
var ManifestThemeSchema = object({
  id: string(),
  name: optional(string())
});
var ManifestStateMachineSchema = object({
  id: string(),
  name: optional(string())
});
var InitialObjectSchema = object({
  animation: optional(string()),
  stateMachine: optional(string())
});
var ManifestSchema = object({
  version: string(),
  generator: string(),
  initial: optional(InitialObjectSchema),
  animations: array(ManifestAnimationSchema),
  themes: optional(array(ManifestThemeSchema)),
  stateMachines: optional(array(ManifestStateMachineSchema))
});
var NumericGuardSchema = object({
  type: string("Numeric"),
  triggerName: string(),
  conditionType: string(),
  compareTo: union([string(), number(), boolean()])
});
var StringGuardSchema = object({
  type: string("String"),
  triggerName: string(),
  conditionType: string(),
  compareTo: string()
});
var BooleanGuardSchema = object({
  type: string("Boolean"),
  triggerName: string(),
  conditionType: string(),
  compareTo: union([string(), boolean()])
});
var EventGuardSchema = object({
  type: string("Event"),
  triggerName: string()
});
var GuardSchema = union([NumericGuardSchema, StringGuardSchema, BooleanGuardSchema, EventGuardSchema]);
object({ value: number() });
object({ value: boolean() });
object({ value: string() });
object({ target: optional(string()) });
var TransitionType = string("Transition");
var TransitionSchema = object({
  type: TransitionType,
  toState: string(),
  guards: optional(array(GuardSchema))
});
var TransitionsSchema = array(TransitionSchema);
var URLActionSchema = object({ type: string(), url: string() });
var ThemeActionSchema = object({ type: string(), themeId: string() });
var IncrementSchema = object({
  type: string(),
  triggerName: string(),
  value: optional(union([string(), number()]))
});
var DecrementSchema = object({
  type: string(),
  triggerName: string(),
  value: optional(union([string(), number()]))
});
var ToggleSchema = object({
  type: string(),
  triggerName: string()
});
var SetBooleanSchema = object({
  type: string(),
  triggerName: string(),
  value: optional(boolean())
});
var SetStringSchema = object({
  type: string(),
  triggerName: string(),
  value: optional(string())
});
var SetNumericSchema = object({
  type: string(),
  triggerName: string(),
  value: optional(number())
});
var FireSchema = object({
  type: string(),
  triggerName: string()
});
var ResetSchema = object({
  type: string(),
  triggerName: string()
});
var SetExpressionSchema = object({
  type: string(),
  layerName: string(),
  propertyIndex: number(),
  varName: string(),
  value: number()
});
var SetThemeSchema = object({
  type: string(),
  themeId: string()
});
var SetFrameSchema = object({
  type: string(),
  value: union([string(), number()])
});
var SetProgressSchema = object({
  type: string(),
  value: union([string(), number()])
});
var SetSlotSchema = object({
  type: string(),
  value: string()
});
var FireCustomEventSchema = object({
  type: string(),
  value: string()
});
var ActionSchema = union([
  URLActionSchema,
  ThemeActionSchema,
  IncrementSchema,
  DecrementSchema,
  ToggleSchema,
  SetBooleanSchema,
  SetStringSchema,
  SetNumericSchema,
  FireSchema,
  ResetSchema,
  SetExpressionSchema,
  SetThemeSchema,
  SetFrameSchema,
  SetProgressSchema,
  SetSlotSchema,
  FireCustomEventSchema
]);
var Modes = union([string("Forward"), string("Reverse"), string("Bounce"), string("ReverseBounce")]);
var StateType = union([string("PlaybackState"), string("GlobalState")]);
var PlaybackStateSchema = object({
  name: string(),
  type: StateType,
  animation: string(),
  loop: optional(boolean()),
  autoplay: optional(boolean()),
  final: optional(boolean()),
  mode: optional(Modes),
  speed: optional(number()),
  segment: optional(string()),
  backgroundColor: optional(number()),
  useFrameInterpolation: optional(boolean()),
  entryActions: optional(array(ActionSchema)),
  exitActions: optional(array(ActionSchema)),
  transitions: optional(TransitionsSchema)
});
var GlobalStateSchema = object({
  name: string(),
  type: StateType,
  entryActions: optional(array(ActionSchema)),
  exitActions: optional(array(ActionSchema)),
  transitions: optional(TransitionsSchema)
});
var StateSchema = union([PlaybackStateSchema, GlobalStateSchema]);
var StatesSchema = array(StateSchema);
var PointerUpSchema = object({
  type: string(),
  layerName: optional(string()),
  actions: array(ActionSchema)
});
var PointerDownSchema = object({
  type: string(),
  layerName: optional(string()),
  actions: array(ActionSchema)
});
var PointerEnterSchema = object({
  type: string(),
  layerName: optional(string()),
  actions: array(ActionSchema)
});
var PointerMoveSchema = object({
  type: string(),
  actions: array(ActionSchema)
});
var PointerExitSchema = object({
  type: string(),
  layerName: optional(string()),
  actions: array(ActionSchema)
});
var OnCompleteSchema = object({
  type: string(),
  stateName: string(),
  actions: array(ActionSchema)
});
var ListenerSchema = union([
  PointerUpSchema,
  PointerDownSchema,
  PointerEnterSchema,
  PointerMoveSchema,
  PointerExitSchema,
  OnCompleteSchema
]);
var ListenersSchema = array(ListenerSchema);
var NumericTriggerSchema = object({
  type: string("Numeric"),
  name: string(),
  value: number()
});
var StringTriggerSchema = object({
  type: string("String"),
  name: string(),
  value: string()
});
var BooleanTriggerSchema = object({
  type: string("Boolean"),
  name: string(),
  value: boolean()
});
var EventTriggerSchema = object({
  type: string("Event"),
  name: string()
});
var TriggerSchema = union([
  NumericTriggerSchema,
  StringTriggerSchema,
  BooleanTriggerSchema,
  EventTriggerSchema
]);
var TriggersSchema = array(TriggerSchema);
var DotLottieStateMachineSchema = object({
  initial: string(),
  states: StatesSchema,
  listeners: optional(ListenersSchema),
  triggers: optional(TriggersSchema)
});
var TangentSchema = object({
  x: union([number(), array(number())]),
  y: union([number(), array(number())])
});
var BaseKeyframeSchema = {
  frame: number(),
  inTangent: optional(TangentSchema),
  outTangent: optional(TangentSchema),
  hold: optional(boolean())
};
var ScalarKeyframeSchema = object({
  ...BaseKeyframeSchema,
  value: number()
});
var ColorKeyframeSchema = object({
  ...BaseKeyframeSchema,
  value: array(number())
});
var BaseRuleSchema = {
  animations: optional(array(string())),
  id: string()
};
var ScalarRuleSchema = object({
  ...BaseRuleSchema,
  type: literal("Scalar"),
  value: optional(number()),
  keyframes: optional(array(ScalarKeyframeSchema)),
  expression: optional(string())
});
var PositionKeyframeSchema = object({
  ...BaseKeyframeSchema,
  value: array(number()),
  valueInTangent: optional(number()),
  valueOutTangent: optional(number())
});
var PositionRuleSchema = object({
  ...BaseRuleSchema,
  type: literal("Position"),
  split: optional(boolean()),
  keyframes: optional(array(PositionKeyframeSchema)),
  expression: optional(string())
});
var ColorRuleSchema = object({
  ...BaseRuleSchema,
  type: literal("Color"),
  value: optional(array(number())),
  keyframes: optional(array(ColorKeyframeSchema)),
  expression: optional(string())
});
var ImageRuleSchema = object({
  ...BaseRuleSchema,
  type: literal("Image"),
  value: object({
    id: optional(string()),
    width: optional(number()),
    height: optional(number()),
    url: optional(string())
  })
});
var GradientKeyframeSchema = object({
  ...BaseKeyframeSchema,
  value: array(
    object({
      color: array(number()),
      offset: number()
    })
  )
});
var GradientRuleSchema = object({
  ...BaseRuleSchema,
  type: literal("Gradient"),
  value: optional(
    array(
      object({
        color: array(number()),
        offset: number()
      })
    )
  ),
  keyframes: optional(array(GradientKeyframeSchema))
});
var RuleSchema = union([ColorRuleSchema, ScalarRuleSchema, PositionRuleSchema, ImageRuleSchema, GradientRuleSchema]);
var RulesSchema = array(RuleSchema);
var ThemeDataSchema = object({
  rules: RulesSchema
});

// src/v2/common/state-machine.ts
var DotLottieStateMachineCommon = class {
  constructor(options) {
    __publicField(this, "_name");
    __publicField(this, "_id");
    __publicField(this, "_initial");
    __publicField(this, "_zipOptions");
    __publicField(this, "_states");
    __publicField(this, "_listeners");
    __publicField(this, "_triggers");
    this._requireValidId(options.id);
    this._requireValidTriggers(options.data.triggers ?? []);
    this._requireValidListeners(options.data.listeners ?? []);
    this._requireValidStates(options.data.states);
    this._requireValidInitial(options.data.initial, options.data.states);
    this._name = options.name;
    this._id = options.id;
    this._initial = options.data.initial;
    this._zipOptions = options.zipOptions ?? {};
    this._states = options.data.states;
    this._listeners = options.data.listeners ?? [];
    this._triggers = options.data.triggers ?? [];
  }
  get zipOptions() {
    return this._zipOptions;
  }
  set zipOptions(zipOptions) {
    this._zipOptions = zipOptions;
  }
  get id() {
    return this._id;
  }
  set id(id) {
    this._requireValidId(id);
    this._id = id;
  }
  get name() {
    return this._name;
  }
  set name(name) {
    this._name = name;
  }
  get states() {
    return this._states;
  }
  set states(states) {
    this._states = states;
  }
  get listeners() {
    return this._listeners;
  }
  set listeners(listeners) {
    this._listeners = listeners;
  }
  get triggers() {
    return this._triggers;
  }
  set triggers(triggers) {
    this._triggers = triggers;
  }
  get initial() {
    return this._initial;
  }
  set initial(initial) {
    this.initial = initial;
  }
  toString() {
    return JSON.stringify({
      initial: this._initial,
      states: this._states,
      triggers: this._triggers,
      listeners: this._listeners
    });
  }
  _requireValidId(id) {
    if (!id) {
      throw new DotLottieError("Invalid id.");
    }
  }
  _requireValidInitial(initial, states) {
    const result = safeParse(StatesSchema, states);
    if (!result.success) {
      const error = `Invalid state machine declaration, ${JSON.stringify(flatten(result.issues).nested, null, 2)}`;
      throw new DotLottieError(`Invalid initial state: ${error}`, "INVALID_STATEMACHINE" /* INVALID_STATEMACHINE */);
    }
    let found = false;
    for (const state of states) {
      if (state.name === initial) {
        found = true;
      }
    }
    if (!found) {
      throw new DotLottieError(`Initial state not found.`, "INVALID_STATEMACHINE" /* INVALID_STATEMACHINE */);
    }
  }
  _requireValidStates(states) {
    const result = safeParse(StatesSchema, states);
    if (!result.success) {
      const error = `Invalid state machine declaration, ${JSON.stringify(flatten(result.issues).nested, null, 2)}`;
      throw new DotLottieError(`Invalid states: ${error}`, "INVALID_STATEMACHINE" /* INVALID_STATEMACHINE */);
    }
    for (const state of states) {
      if (state.transitions) {
        this._requireValidTransitions(state.transitions);
      }
    }
  }
  _requireValidTriggers(triggers) {
    const result = safeParse(TriggersSchema, triggers);
    if (!result.success) {
      const error = `Invalid state machine declaration, ${JSON.stringify(flatten(result.issues).nested, null, 2)}`;
      throw new DotLottieError(`Invalid context variables: ${error}`, "INVALID_STATEMACHINE" /* INVALID_STATEMACHINE */);
    }
  }
  _requireValidListeners(listeners) {
    const result = safeParse(ListenersSchema, listeners);
    if (!result.success) {
      const error = `Invalid state machine declaration, ${JSON.stringify(flatten(result.issues).nested, null, 2)}`;
      throw new DotLottieError(`Invalid listeners: ${error}`, "INVALID_STATEMACHINE" /* INVALID_STATEMACHINE */);
    }
  }
  _requireValidTransitions(transitions) {
    const result = safeParse(TransitionsSchema, transitions);
    if (!result.success) {
      const error = `Invalid state machine declaration, ${JSON.stringify(flatten(result.issues).nested, null, 2)}`;
      throw new DotLottieError(`Invalid transitions: ${error}`, "INVALID_STATEMACHINE" /* INVALID_STATEMACHINE */);
    }
  }
};
var LottieThemeCommon = class {
  constructor(options) {
    __publicField(this, "_data");
    __publicField(this, "_id");
    __publicField(this, "_name");
    __publicField(this, "_zipOptions");
    this._requireValidId(options.id);
    this._requireValidData(options.data);
    this._name = options.name;
    this._data = options.data;
    this._id = options.id;
    this._zipOptions = options.zipOptions ?? {};
  }
  get zipOptions() {
    return this._zipOptions;
  }
  set zipOptions(zipOptions) {
    this._zipOptions = zipOptions;
  }
  get id() {
    return this._id;
  }
  set id(id) {
    this._requireValidId(id);
    this._id = id;
  }
  get name() {
    return this._name;
  }
  set name(name) {
    this._name = name;
  }
  get data() {
    return this._data;
  }
  set data(data) {
    this._requireValidData(data);
    this._data = data;
  }
  async toString() {
    return JSON.stringify(this._data);
  }
  _requireValidId(id) {
    if (typeof id !== "string" || !id) throw new DotLottieError("Invalid theme id");
  }
  _requireValidData(data) {
    const result = safeParse(ThemeDataSchema, data);
    if (!result.success) {
      const issues = JSON.stringify(result.issues, null, 2);
      throw new DotLottieError(`Invalid theme data: ${issues}`);
    }
  }
};

// src/v2/common/dotlottie.ts
var DotLottieCommon = class {
  constructor(options) {
    __publicField(this, "_animationsMap", /* @__PURE__ */ new Map());
    __publicField(this, "_plugins", []);
    __publicField(this, "_themesMap", /* @__PURE__ */ new Map());
    __publicField(this, "_stateMachinesMap", /* @__PURE__ */ new Map());
    __publicField(this, "_generator", PACKAGE_NAME);
    __publicField(this, "_version", "2");
    __publicField(this, "enableDuplicateImageOptimization");
    if (options?.generator) {
      this._generator = options.generator;
    }
    this.enableDuplicateImageOptimization = options?.enableDuplicateImageOptimization ?? false;
  }
  async toBase64(_options) {
    throw new DotLottieError("toBase64() method not implemented in concrete class!");
  }
  create(_options) {
    throw new DotLottieError("create() method not implemented in concrete class!");
  }
  async download(_fileName, _options = void 0) {
    throw new DotLottieError("download(fileName:string) method not implemented in concrete class!");
  }
  addPlugins(..._plugins) {
    throw new DotLottieError("addPlugins(...plugins: DotLottiePlugin[]) not implemented in concrete class!");
  }
  addAnimation(_animationOptions) {
    throw new DotLottieError("addAnimation(animationOptions: AnimationOptions) not implemented in concrete class!");
  }
  async fromArrayBuffer(_arrayBuffer) {
    throw new DotLottieError(
      "fromArrayBuffer(arrayBuffer: ArrayBuffer): Promise<DotLottieCommon> not implemented in concrete class!"
    );
  }
  async toArrayBuffer(_options = void 0) {
    throw new DotLottieError("toArrayBuffer(): Promise<ArrayBuffer> is not implemented in concrete class!");
  }
  get plugins() {
    return this._plugins;
  }
  get version() {
    return this._version;
  }
  get generator() {
    return this._generator;
  }
  get animations() {
    return Array.from(this._animationsMap.values());
  }
  get manifest() {
    return this._buildManifest();
  }
  get themes() {
    return Array.from(this._themesMap.values());
  }
  get stateMachines() {
    return Array.from(this._stateMachinesMap.values());
  }
  /**
   * Renames the underlying LottieImage, as well as updating the image asset path inside the animation data.
   * @param newName - desired id and fileName,
   * @param imageId - The id of the LottieImage to rename
   */
  async _renameImage(animation, newLottieAssetId, lottieAssetId) {
    for (const imageAsset of animation.imageAssets) {
      if (imageAsset.lottieAssetId === lottieAssetId) {
        const oldPath = imageAsset.fileName;
        await imageAsset.renameImage(newLottieAssetId);
        if (!animation.data) throw new DotLottieError("No animation data available.");
        const animationAssets = animation.data.assets;
        if (!animationAssets) throw new DotLottieError("No image assets to rename.");
        for (const asset of animationAssets) {
          if ("w" in asset && "h" in asset) {
            if (asset.p === oldPath) {
              asset.p = imageAsset.fileName;
            }
          }
        }
      }
    }
  }
  /**
   * Generates a map of duplicate image ids and their count.
   * @returns Map of duplicate image ids and their count.
   */
  _generateMapOfOccurencesFromImageIds() {
    const dupeMap = /* @__PURE__ */ new Map();
    this.animations.forEach((animation) => {
      animation.imageAssets.forEach((imageAsset) => {
        if (dupeMap.has(imageAsset.lottieAssetId)) {
          const count = dupeMap.get(imageAsset.lottieAssetId) ?? 0;
          dupeMap.set(imageAsset.lottieAssetId, count + 1);
        } else {
          dupeMap.set(imageAsset.lottieAssetId, 1);
        }
      });
    });
    return dupeMap;
  }
  /**
   * Renames the image assets in all animations to avoid conflicts.
   *
   * Steps:
   *  - Generate how many times across all animations the same image id has been used.
   *  - Loop through every animation in reverse order
   *  - Every time an animation uses an image asset that is also used elsewhere, append the count to the image's asset id and then decrement.
   *
   * Result of renaming for every animation:
   *
   * - Inside the Lottie's data and it's Asset object:
   *  - The Asset id stays the same, meaning that every reference to the asset is still valid (refId)
   *  - The path is changed to the new asset id with the format \{assetId\}_\{count\}
   *
   * - On the dotLottie file system scope:
   *  - The image file name is changed to the new asset id \{assetId\}_\{count\}.\{ext\}
   */
  async _renameImageAssets() {
    const occurenceMap = this._generateMapOfOccurencesFromImageIds();
    for (let i = this.animations.length - 1; i >= 0; i -= 1) {
      const animation = this.animations.at(i);
      if (animation) {
        for (let j = animation.imageAssets.length - 1; j >= 0; j -= 1) {
          const image = animation.imageAssets.at(j);
          if (image) {
            let count = occurenceMap.get(image.lottieAssetId) ?? 0;
            if (count > 0) {
              count -= 1;
            }
            occurenceMap.set(image.lottieAssetId, count);
            if (count > 0) {
              await this._renameImage(animation, `${image.lottieAssetId}_${count}`, image.lottieAssetId);
            }
          }
        }
      }
    }
  }
  /**
   * Renames the underlying LottieAudio, as well as updating the audio asset path inside the animation data.
   * @param newName - desired id and fileName,
   * @param audioId - The id of the LottieAudio to rename
   */
  async _renameAudio(animation, newName, audioId) {
    for (const audioAsset of animation.audioAssets) {
      if (audioAsset.id === audioId) {
        await audioAsset.renameAudio(newName);
        if (!animation.data) throw new DotLottieError("No animation data available.");
        const animationAssets = animation.data.assets;
        if (!animationAssets) throw new DotLottieError("No audio assets to rename.");
        for (const asset of animationAssets) {
          if (isAudioAsset(asset)) {
            if (asset.id === audioId) {
              asset.p = audioAsset.fileName;
            }
          }
        }
      }
    }
  }
  async _renameAudioAssets() {
    const audio = /* @__PURE__ */ new Map();
    this.animations.forEach((animation) => {
      audio.set(animation.id, animation.audioAssets);
    });
    let size = 0;
    audio.forEach((value) => {
      size += value.length;
    });
    for (let i = this.animations.length - 1; i >= 0; i -= 1) {
      const animation = this.animations.at(i);
      if (animation) {
        for (let j = animation.audioAssets.length - 1; j >= 0; j -= 1) {
          const audioAsset = animation.audioAssets.at(j);
          if (audioAsset) {
            await this._renameAudio(animation, `audio_${size}`, audioAsset.id);
            size -= 1;
          }
        }
      }
    }
  }
  _addLottieAnimation(animation) {
    if (this._animationsMap.get(animation.id)) {
      throw new DotLottieError("Duplicate animation id detected, aborting.");
    }
    this._animationsMap.set(animation.id, animation);
    return this;
  }
  /**
   * Inlines all assets of the passed animation
   * @param animation - Animation whose asset are to be inlined
   * @returns LottieAnimationCommon with inlined assets
   */
  async _findAssetsAndInline(animation) {
    const animationAssets = animation.data?.assets;
    if (!animationAssets) throw new DotLottieError("Failed to inline assets, the animation's assets are undefined.");
    const images = this.getImages();
    const audios = this.getAudio();
    for (const asset of animationAssets) {
      if (isImageAsset(asset)) {
        for (const image of images) {
          if (image.fileName === asset.p) {
            asset.e = 1;
            asset.u = "";
            asset.p = await image.toDataURL();
          }
        }
      } else if (isAudioAsset(asset)) {
        for (const audio of audios) {
          if (audio.fileName === asset.p) {
            asset.e = 1;
            asset.u = "";
            asset.p = await audio.toDataURL();
          }
        }
      }
    }
    return animation;
  }
  /**
   * Returns the desired animation
   * @param animationId - desired animation id
   * @param inlineAssets - if true will inline the assets inside the data of the LottieAnimationV1
   * @returns
   */
  async getAnimation(animationId, options) {
    if (!options?.inlineAssets) return this._animationsMap.get(animationId);
    let dataWithInlinedImages = this._animationsMap.get(animationId);
    if (!dataWithInlinedImages) throw new DotLottieError("Failed to find animation.");
    dataWithInlinedImages = await this._findAssetsAndInline(dataWithInlinedImages);
    return dataWithInlinedImages;
  }
  getAnimations() {
    return Array.from(this._animationsMap);
  }
  removeAnimation(animationId) {
    const targetAnimation = this._animationsMap.get(animationId);
    if (targetAnimation) {
      const assignedThemes = targetAnimation.themes;
      for (const assignedTheme of assignedThemes) {
        this.unscopeTheme({
          animationId: targetAnimation.id,
          themeId: assignedTheme.id
        });
      }
      this._animationsMap.delete(targetAnimation.id);
    }
    return this;
  }
  getImages() {
    const images = [];
    this.animations.map((animation) => {
      return images.push(...animation.imageAssets);
    });
    return images;
  }
  getAudio() {
    const audio = [];
    this.animations.map((animation) => {
      return audio.push(...animation.audioAssets);
    });
    return audio;
  }
  getTheme(themeId) {
    return this._themesMap.get(themeId);
  }
  _buildManifest() {
    const animationsList = Array.from(this._animationsMap.values());
    const themesList = Array.from(this._themesMap.values());
    const stateMachinesList = Array.from(this._stateMachinesMap.values());
    const activeAnimationId = animationsList.find((value) => value.defaultActiveAnimation)?.id ?? "";
    const manifest = {
      version: this.version,
      generator: this.generator,
      animations: animationsList.map((animation) => ({
        id: animation.id,
        ...animation.name ? { name: animation.name } : {},
        ...animation.initialTheme ? { initialTheme: animation.initialTheme } : {},
        ...animation.background ? { background: animation.background } : {},
        ...animation.themes.length > 0 ? { themes: animation.themes.map((theme) => theme.id) } : {}
      }))
    };
    if (themesList.length > 0) {
      manifest.themes = themesList.map((theme) => ({
        id: theme.id,
        ...theme.name ? { name: theme.name } : {}
      }));
    }
    if (stateMachinesList.length > 0) {
      manifest.stateMachines = stateMachinesList.map((stateMachine) => ({
        id: stateMachine.id,
        ...stateMachine.name ? { name: stateMachine.name } : {}
      }));
    }
    if (activeAnimationId) {
      manifest.initial = {
        animation: activeAnimationId
      };
    }
    return manifest;
  }
  /**
   * Constructs the manifest and calls toJSON on the animations
   * so the data is fetched for every animation.
   *
   * @returns DotLottie context
   */
  async build() {
    this._buildManifest();
    for (const animation of this.animations) {
      await animation.toJSON();
    }
    if (this.animations.length > 1) {
      await this._renameImageAssets();
      await this._renameAudioAssets();
    }
    const parallelPlugins = [];
    const sequentialPlugins = [];
    for (const plugin of this.plugins) {
      if (plugin.parallel) {
        parallelPlugins.push(plugin);
      } else {
        sequentialPlugins.push(plugin);
      }
    }
    await Promise.all(parallelPlugins.map(async (plugin) => plugin.onBuild()));
    for (const plugin of sequentialPlugins) {
      await plugin.onBuild();
    }
    return this;
  }
  async toBlob(options = void 0) {
    const arrayBuffer = await this.toArrayBuffer(options);
    return new Blob([arrayBuffer], { type: "application/zip" });
  }
  /**
   * Creates a DotLottie instance from a url to a dotlottie file
   * @param url - url to the dotlottie file
   * @returns DotLottie instance
   */
  async fromURL(url) {
    if (!isValidURL(url)) throw new DotLottieError("Invalid URL");
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new DotLottieError(response.statusText);
      }
      const arrayBuffer = await response.arrayBuffer();
      return this.fromArrayBuffer(arrayBuffer);
    } catch (err) {
      if (err instanceof Error) {
        throw new DotLottieError(err.message);
      }
    }
    throw new DotLottieError("Unknown error");
  }
  merge(...dotlotties) {
    const mergedDotlottie = this.create();
    for (const dotlottie of dotlotties) {
      dotlottie.themes.forEach((theme) => {
        mergedDotlottie.addTheme({
          id: theme.id,
          name: theme.name,
          data: theme.data
        });
      });
      dotlottie.animations.forEach((animation) => {
        if (animation.data) {
          mergedDotlottie.addAnimation({
            id: animation.id,
            name: animation.name,
            data: animation.data
          });
        } else if (animation.url) {
          mergedDotlottie.addAnimation({
            id: animation.id,
            name: animation.name,
            url: animation.url
          });
        }
        animation.themes.forEach((theme) => {
          mergedDotlottie.scopeTheme({
            animationId: animation.id,
            themeId: theme.id
          });
        });
      });
      dotlottie.stateMachines.forEach((stateMachine) => {
        const stateOption = {
          id: stateMachine.id,
          name: stateMachine.name,
          data: {
            states: stateMachine.states,
            initial: stateMachine.initial,
            listeners: stateMachine.listeners,
            triggers: stateMachine.triggers
          },
          zipOptions: stateMachine.zipOptions
        };
        mergedDotlottie.addStateMachine(stateOption);
      });
    }
    return mergedDotlottie;
  }
  addTheme(themeOptions) {
    const theme = new LottieThemeCommon(themeOptions);
    this._themesMap.set(theme.id, theme);
    return this;
  }
  removeTheme(id) {
    const targetTheme = this._themesMap.get(id);
    if (targetTheme) {
      for (const animation of this.animations) {
        if (animation.themes.includes(targetTheme)) {
          animation.unscopeTheme(targetTheme.id);
        }
      }
      this._themesMap.delete(targetTheme.id);
    }
    return this;
  }
  scopeTheme({ animationId, themeId }) {
    const theme = this._themesMap.get(themeId);
    if (!theme) throw new DotLottieError(`Failed to find theme with id ${themeId}`);
    const animation = this._animationsMap.get(animationId);
    if (!animation) throw new DotLottieError(`Failed to find animation with id ${animationId}`);
    animation.scopeTheme(theme);
    return this;
  }
  unscopeTheme({ animationId, themeId }) {
    const theme = this._themesMap.get(themeId);
    if (!theme) throw new DotLottieError(`Failed to find theme with id ${themeId}`);
    const animation = this._animationsMap.get(animationId);
    if (!animation) throw new DotLottieError(`Failed to find animation with id ${animationId}`);
    animation.unscopeTheme(theme.id);
    return this;
  }
  addStateMachine(stateMachineOptions) {
    const newState = new DotLottieStateMachineCommon(stateMachineOptions);
    this._stateMachinesMap.set(stateMachineOptions.id, newState);
    return this;
  }
  getStateMachine(stateId) {
    return this._stateMachinesMap.get(stateId);
  }
  removeStateMachine(stateMachineId) {
    this._stateMachinesMap.delete(stateMachineId);
    return this;
  }
  _requireValidDescription(description) {
    if (typeof description !== "string") throw new DotLottieError("Invalid description");
  }
  _requireValidGenerator(generator) {
    if (typeof generator !== "string") throw new DotLottieError("Invalid generator");
  }
  _requireValidKeywords(keywords) {
    if (typeof keywords !== "string") throw new DotLottieError("Invalid keywords");
  }
  _requireValidVersion(version) {
    if (typeof version !== "string") throw new DotLottieError("Invalid version");
  }
  _requireValidCustomData(customData) {
    if (!customData) throw new DotLottieError("Invalid customData");
  }
};

// src/v2/common/animation.ts
var LottieAnimationCommon = class {
  constructor(options) {
    __publicField(this, "_name");
    __publicField(this, "_data");
    __publicField(this, "_id", "");
    __publicField(this, "_url");
    __publicField(this, "_zipOptions");
    // This indicates if the player should play this animation by default rather than the first in the list.
    __publicField(this, "_defaultActiveAnimation");
    __publicField(this, "_imageAssets", []);
    __publicField(this, "_audioAssets", []);
    __publicField(this, "_themesMap", /* @__PURE__ */ new Map());
    __publicField(this, "_initialTheme", null);
    __publicField(this, "_background", null);
    this._requireValidOptions(options);
    this._id = options.id;
    this._name = options.name;
    this._zipOptions = options.zipOptions ?? {};
    if (options.data) this._data = options.data;
    if (options.url) this._url = options.url;
    this._background = options.background ?? null;
    this._initialTheme = options.initialTheme ?? null;
    this._defaultActiveAnimation = options.defaultActiveAnimation ?? false;
  }
  async toBase64() {
    throw new DotLottieError("lottie animation controls tobase64 not implemented!");
  }
  get zipOptions() {
    return this._zipOptions;
  }
  set zipOptions(zipOptions) {
    this._zipOptions = zipOptions;
  }
  get id() {
    return this._id;
  }
  set id(id) {
    this._requireValidId(id);
    this._id = id;
  }
  get name() {
    return this._name;
  }
  set name(name) {
    this._name = name;
  }
  get background() {
    return this._background;
  }
  set background(background) {
    this._background = background;
  }
  get initialTheme() {
    return this._initialTheme;
  }
  set initialTheme(initialTheme) {
    this._initialTheme = initialTheme;
  }
  get themes() {
    return Array.from(this._themesMap.values());
  }
  set themes(themes) {
    this._themesMap = /* @__PURE__ */ new Map();
    themes.forEach((theme) => {
      this._themesMap.set(theme.id, theme);
    });
  }
  get imageAssets() {
    return this._imageAssets;
  }
  set imageAssets(imageAssets) {
    this._imageAssets = imageAssets;
  }
  get audioAssets() {
    return this._audioAssets;
  }
  set audioAssets(audioAssets) {
    this._audioAssets = audioAssets;
  }
  get data() {
    return this._data;
  }
  set data(data) {
    this._requireValidLottieData(data);
    this._data = data;
  }
  get url() {
    return this._url;
  }
  set url(url) {
    this._requireValidUrl(url);
    this._url = url;
  }
  get defaultActiveAnimation() {
    return this._defaultActiveAnimation;
  }
  set defaultActiveAnimation(defaultActiveAnimation) {
    this._defaultActiveAnimation = defaultActiveAnimation;
  }
  scopeTheme(theme) {
    this._themesMap.set(theme.id, theme);
  }
  unscopeTheme(themeId) {
    this._themesMap.delete(themeId);
  }
  /**
   * Return the animation data as an array buffer.
   * @returns data - The animation data as an ArrayBuffer.
   * @throws Error - if the animation data is not set and the url is not provided.
   * @throws Error - if the animation data is not a valid Lottie animation data object.
   * @throws Error - if the fetch request fails.
   */
  async toArrayBuffer(options) {
    const dataJson = await this.toJSON(options);
    return new TextEncoder().encode(JSON.stringify(dataJson)).buffer;
  }
  async _extractImageAssets() {
    throw new DotLottieError("_extractImageAssets(): Promise<boolean> method not implemented in concrete class");
  }
  async _extractAudioAssets() {
    throw new DotLottieError("_extractAudioAssets(): Promise<boolean> method not implemented in concrete class");
  }
  /**
   * Return the animation data as a blob.
   * @returns blob - The animation data as a Blob.
   * @throws Error - if the animation data is not set and the url is not provided.
   * @throws Error - if the animation data is not a valid Lottie animation data object.
   * @throws Error - if the fetch request fails.
   */
  async toBlob(options) {
    const dataJson = await this.toJSON(options);
    return new Blob([JSON.stringify(dataJson)], { type: "application/json" });
  }
  /**
   * Return the animation data as a JSON object.
   * If the animation data is not already set, it will be fetched from the provided url.
   * @returns data - The animation data.
   * @throws Error - if the animation data is not a valid Lottie animation data object.
   * @throws Error - if the fetch request fails.
   */
  async toJSON(options) {
    if (this._url && !this._data) {
      this._data = await this._fromUrl(this._url);
    }
    this._requireValidLottieData(this._data);
    if (this._data.assets?.length) {
      await this._extractImageAssets();
      await this._extractAudioAssets();
      if (options?.inlineAssets) {
        const animationAssets = this.data?.assets;
        if (!animationAssets)
          throw new DotLottieError("Failed to inline assets, the animation's assets are undefined.");
        const images = this.imageAssets;
        const audios = this.audioAssets;
        for (const asset of animationAssets) {
          if ("w" in asset && "h" in asset && !("xt" in asset) && "p" in asset) {
            for (const image of images) {
              if (image.fileName === asset.p) {
                asset.e = 1;
                asset.u = "";
                asset.p = await image.toDataURL();
              }
            }
          } else if (isAudioAsset(asset)) {
            for (const audio of audios) {
              if (audio.fileName === asset.p) {
                asset.e = 1;
                asset.u = "";
                asset.p = await audio.toDataURL();
              }
            }
          }
        }
      }
    }
    return this._data;
  }
  /**
   * Fetch the animation data from the provided url.
   * @param url - The url to fetch the animation data from.
   * @returns animationData - The animation data.
   * @throws Error - if the fetch request fails.
   * @throws Error - if the data object is not a valid Lottie animation data object.
   */
  async _fromUrl(url) {
    const response = await fetch(url);
    const text = await response.text();
    let json;
    try {
      json = JSON.parse(text);
    } catch (error) {
      if (error instanceof Error) {
        throw new DotLottieError(`${error.message}: Invalid json returned from url`);
      }
    }
    this._requireValidLottieData(json);
    return json;
  }
  /**
   * Ensure that the provided url is a valid string.
   * The url must be a non-empty string, otherwise an error will be thrown.
   * @param url - The url to validate.
   * @throws Error - if the url is not a valid string.
   *
   */
  _requireValidUrl(url) {
    try {
      new URL(url || "");
    } catch (_err) {
      throw new DotLottieError("Invalid animation url");
    }
  }
  /**
   * Ensure that the provided data object is a valid Lottie animation data object.
   * The data object must contain the following mandatory properties: v, ip, op, layers, fr, w, h.
   * If the data object does not contain all mandatory properties, an error will be thrown.
   * @param data - The data object to validate.
   * @throws Error - if the data object is not a valid Lottie animation data object.
   */
  _requireValidLottieData(data) {
    const mandatoryLottieProperties = ["v", "ip", "op", "layers", "fr", "w", "h"];
    const hasAllMandatoryProperties = mandatoryLottieProperties.every(
      (field) => Object.prototype.hasOwnProperty.call(data, field)
    );
    if (!hasAllMandatoryProperties) {
      throw new DotLottieError("Received invalid Lottie data.");
    }
  }
  /**
   * Ensure that the provided id is a valid string.
   * The id must be a non-empty string, otherwise an error will be thrown.
   * @param id - The id to validate.
   * @throws Error - if the id is not a valid string.
   */
  _requireValidId(id) {
    if (!id) throw new DotLottieError("Invalid animation id");
  }
  /**
   * Ensure that the provided options object is a valid AnimationOptions object.
   * The options object must contain the following mandatory properties: id, data or url.
   * If the options object does not contain all mandatory properties, an error will be thrown.
   * @param options - The options object to validate.
   * @throws Error - if the options object is not a valid AnimationOptions object.
   * @throws Error - if the id is not a valid string.
   * @throws Error - if the data object is not a valid Lottie animation data object.
   * @throws Error - if the url is not a valid url string.
   * @throws Error - if the data object is not set and the url is not provided.
   */
  _requireValidOptions(options) {
    this._requireValidId(options.id);
    if (!options.data && !options.url) {
      throw new DotLottieError("No data or url provided.");
    }
    if (options.data) {
      this._requireValidLottieData(options.data);
    }
    if (options.url) {
      this._requireValidUrl(options.url);
    }
  }
};

// src/v2/common/image.ts
var LottieImageCommon = class {
  constructor(options) {
    __publicField(this, "_data");
    /**
     * Unique id for the LottieImageCommon object. This is never modified.
     */
    __publicField(this, "_id", "");
    /**
     * Asset id representing the image asset inside the Lottie animation. This can be modified.
     */
    __publicField(this, "_lottieAssetId", "");
    __publicField(this, "_fileName", "");
    __publicField(this, "_parentAnimations");
    __publicField(this, "_zipOptions");
    this._requireValidId(options.id);
    this._requireValidLottieAssetId(options.lottieAssetId);
    this._requireValidFileName(options.fileName);
    this._zipOptions = options.zipOptions ?? {};
    if (options.data) {
      this._data = options.data;
    }
    if (options.id) {
      this._id = options.id;
    }
    if (options.lottieAssetId) {
      this._lottieAssetId = options.lottieAssetId;
    }
    if (options.fileName) {
      this._fileName = options.fileName;
    }
    this._parentAnimations = options.parentAnimations || [];
  }
  get zipOptions() {
    return this._zipOptions;
  }
  set zipOptions(zipOptions) {
    this._zipOptions = zipOptions;
  }
  /**
   * Ensure that the provided id is a valid string.
   * The id must be a non-empty string, otherwise an error will be thrown.
   * @param id - The id to validate.
   * @throws Error - if the id is not a valid string.
   */
  _requireValidId(id) {
    if (!id) throw new DotLottieError("Invalid image id");
  }
  /**
   * Ensure that the provided id is a valid string.
   * The id must be a non-empty string, otherwise an error will be thrown.
   * @param id - The id to validate.
   * @throws Error - if the id is not a valid string.
   */
  _requireValidLottieAssetId(id) {
    if (!id) throw new DotLottieError("Invalid Lottie Image Asset Id");
  }
  /**
   * Ensure that the provided fileName is a valid string.
   * The fileName must be a non-empty string, otherwise an error will be thrown.
   * @param fileName - The fileName to validate.
   * @throws Error - if the fileName is not a valid string.
   */
  _requireValidFileName(fileName) {
    if (!fileName) throw new DotLottieError("Invalid image fileName");
  }
  get fileName() {
    return this._fileName;
  }
  set fileName(fileName) {
    this._requireValidFileName(fileName);
    this._fileName = fileName;
  }
  get id() {
    return this._id;
  }
  set id(id) {
    this._requireValidId(id);
    this._id = id;
  }
  get lottieAssetId() {
    return this._lottieAssetId;
  }
  set lottieAssetId(id) {
    this._requireValidLottieAssetId(id);
    this._lottieAssetId = id;
  }
  get data() {
    return this._data;
  }
  set data(data) {
    if (!data) {
      throw new DotLottieError("Invalid data");
    }
    this._data = data;
  }
  get parentAnimations() {
    return this._parentAnimations;
  }
  set parentAnimations(parentAnimations) {
    this._parentAnimations = parentAnimations;
  }
  async toDataURL() {
    if (this._data && this._isDataURL(this._data)) return this.data;
    const arrayBuffer = await this.toArrayBuffer();
    return dataUrlFromU8(new Uint8Array(arrayBuffer));
  }
  /**
   * Renames the id and fileName to newName.
   * @param newName - A new id and filename for the image.
   */
  async renameImage(newLottieAssetId) {
    this._lottieAssetId = newLottieAssetId;
    const data = await this.toDataURL();
    const ext = await getExtensionTypeFromBase64(data);
    if (!ext) {
      throw new DotLottieError("File extension type could not be detected from asset file.");
    }
    this.fileName = `${newLottieAssetId}.${ext}`;
  }
  async toArrayBuffer() {
    const blob = await (await this.toBlob()).arrayBuffer();
    return blob;
  }
  async toBlob() {
    if (!this._data) {
      throw new DotLottieError("Invalid image data.");
    }
    if (this._isDataURL(this._data)) {
      const data = this._data;
      const [header, base64] = data.split(",");
      if ((!header || !base64) && data.length) {
        return new Blob([data]);
      }
      if (!header || !base64) {
        throw new DotLottieError("Invalid image data.");
      }
      const type = header.replace("data:", "").replace(/;base64$/, "");
      return new Blob([base64], { type });
    }
    if (this._isArrayBuffer(this._data)) {
      return new Blob([this._data]);
    }
    if (this._isBlob(this._data)) {
      return this._data;
    }
    throw new DotLottieError("Invalid image data.");
  }
  async _fromUrlToBlob(url) {
    const response = await fetch(url);
    return response.blob();
  }
  _isArrayBuffer(data) {
    return data instanceof ArrayBuffer;
  }
  _isDataURL(data) {
    return typeof data === "string" && data.startsWith("data:");
  }
  _isBlob(data) {
    return data instanceof Blob;
  }
};

// src/v2/common/audio.ts
var LottieAudioCommon = class {
  constructor(options) {
    __publicField(this, "_data");
    __publicField(this, "_id", "");
    __publicField(this, "_url");
    __publicField(this, "_fileName", "");
    __publicField(this, "_parentAnimations");
    __publicField(this, "_zipOptions");
    this._requireValidId(options.id);
    this._requireValidFileName(options.fileName);
    this._zipOptions = options.zipOptions ?? {};
    if (options.data) {
      this._data = options.data;
    }
    if (options.id) {
      this._id = options.id;
    }
    if (options.url) {
      this._url = options.url;
    }
    if (options.fileName) {
      this._fileName = options.fileName;
    }
    this._parentAnimations = options.parentAnimations || [];
  }
  get zipOptions() {
    return this._zipOptions;
  }
  set zipOptions(zipOptions) {
    this._zipOptions = zipOptions;
  }
  get fileName() {
    return this._fileName;
  }
  set fileName(fileName) {
    if (!fileName) throw new DotLottieError("Invalid audio file name", "ASSET_NOT_FOUND" /* ASSET_NOT_FOUND */);
    this._fileName = fileName;
  }
  get id() {
    return this._id;
  }
  set id(id) {
    if (!id) throw new DotLottieError("Invalid audio id", "ASSET_NOT_FOUND" /* ASSET_NOT_FOUND */);
    this._id = id;
  }
  get data() {
    return this._data;
  }
  set data(data) {
    if (!data) {
      throw new DotLottieError("Invalid data");
    }
    this._data = data;
  }
  get parentAnimations() {
    return this._parentAnimations;
  }
  set parentAnimations(parentAnimations) {
    this._parentAnimations = parentAnimations;
  }
  async toDataURL() {
    if (this._data && this._isDataURL(this._data)) return this.data;
    const arrayBuffer = await this.toArrayBuffer();
    return dataUrlFromU8(new Uint8Array(arrayBuffer));
  }
  /**
   * Renames the id and fileName to newName.
   * @param newName - A new id and filename for the audio.
   */
  async renameAudio(newName) {
    this.id = newName;
    const data = await this.toDataURL();
    const ext = await getExtensionTypeFromBase64(data);
    if (!ext) {
      throw new DotLottieError("File extension type could not be detected from asset file.");
    }
    this.fileName = `${newName}.${ext}`;
  }
  async toArrayBuffer() {
    const blob = await (await this.toBlob()).arrayBuffer();
    return blob;
  }
  async toBlob() {
    if (!this._data && this._url) {
      this._data = await this._fromUrlToBlob(this._url);
    }
    if (!this._data) {
      throw new Error("Invalid data");
    }
    if (this._isDataURL(this._data)) {
      const data = this._data;
      const [header, base64] = data.split(",");
      if ((!header || !base64) && data.length) {
        return new Blob([data]);
      }
      if (!header || !base64) {
        throw new Error("Invalid data");
      }
      const type = header.replace("data:", "").replace(/;base64$/, "");
      return new Blob([base64], { type });
    }
    if (this._isArrayBuffer(this._data)) {
      return new Blob([this._data]);
    }
    if (this._isBlob(this._data)) {
      return this._data;
    }
    throw new Error("Invalid data");
  }
  async _fromUrlToBlob(url) {
    const response = await fetch(url);
    return response.blob();
  }
  _isArrayBuffer(data) {
    return data instanceof ArrayBuffer;
  }
  _isDataURL(data) {
    return typeof data === "string" && data.startsWith("data:");
  }
  _isBlob(data) {
    return data instanceof Blob;
  }
  /**
   * Ensure that the provided id is a valid string.
   * The id must be a non-empty string, otherwise an error will be thrown.
   * @param id - The id to validate.
   * @throws Error - if the id is not a valid string.
   */
  _requireValidId(id) {
    if (!id) throw new DotLottieError("Invalid audio id");
  }
  /**
   * Ensure that the provided fileName is a valid string.
   * The fileName must be a non-empty string, otherwise an error will be thrown.
   * @param fileName - The fileName to validate.
   * @throws Error - if the fileName is not a valid string.
   */
  _requireValidFileName(fileName) {
    if (!fileName) throw new DotLottieError("Invalid audio fileName");
  }
};

// src/v2/browser/audio.ts
var LottieAudio = class extends LottieAudioCommon {
  constructor(options) {
    super(options);
  }
};

// src/v2/browser/image.ts
var LottieImage = class extends LottieImageCommon {
  constructor(options) {
    super(options);
  }
};

// src/v2/browser/animation.ts
var LottieAnimation = class extends LottieAnimationCommon {
  constructor(options) {
    super(options);
  }
  /**
   * Return the animation data as a base64 encoded string.
   *
   * @returns data - The animation data as a base64 encoded string.
   * @throws Error - if the animation data is not set and the url is not provided.
   * @throws Error - if the animation data is not a valid Lottie animation data object.
   * @throws Error - if the fetch request fails.
   */
  async toBase64() {
    const data = await this.toArrayBuffer();
    if (typeof window === "undefined") return Buffer.from(data).toString("base64");
    const uint8Array = new Uint8Array(data);
    const binaryString = uint8Array.reduce((acc, val) => acc + String.fromCharCode(val), "");
    return window.btoa(binaryString);
  }
  /**
   *
   * Extract image assets from the animation.
   *
   * @returns boolean - true on error otherwise false on success
   */
  async _extractImageAssets() {
    if (!this._data) throw new DotLottieError("Failed to extract image assets: Animation data does not exist");
    const animationAssets = this._data.assets;
    if (!animationAssets) throw new DotLottieError("Failed to extract image assets: No assets found inside animation");
    for (const asset of animationAssets) {
      if ("w" in asset && "h" in asset && !("xt" in asset) && "p" in asset) {
        const imageData = asset.p.split(",");
        if (!imageData.length || !imageData[0] || !imageData[1]) {
          break;
        }
        let extType = null;
        const fileType = await getExtensionTypeFromBase64(asset.p);
        if (fileType) {
          extType = fileType;
          const fileName = `${asset.id}.${extType}`;
          this._imageAssets.push(
            new LottieImage({
              data: asset.p,
              id: asset.id,
              lottieAssetId: asset.id,
              fileName,
              parentAnimations: [this]
            })
          );
          asset.p = fileName;
          asset.u = "/i/";
          asset.e = 0;
        }
      }
    }
    return false;
  }
  /**
   *
   * Extract audio assets from the animation.
   *
   * @returns boolean - true on error otherwise false on success
   */
  async _extractAudioAssets() {
    if (!this._data) throw new DotLottieError("Failed to extract audio assets: Animation data does not exist");
    const animationAssets = this._data.assets;
    if (!animationAssets) throw new DotLottieError("Failed to extract image assets: No assets found inside animation");
    for (const asset of animationAssets) {
      if (isAudioAsset(asset)) {
        const audioData = asset.p.split(",");
        if (!audioData.length || !audioData[0] || !audioData[1]) {
          break;
        }
        let extType = null;
        const fileType = await getExtensionTypeFromBase64(asset.p);
        extType = fileType;
        const fileName = `${asset.id}.${extType}`;
        this._audioAssets.push(
          new LottieAudio({
            data: asset.p,
            id: asset.id,
            fileName,
            parentAnimations: [this]
          })
        );
        asset.p = fileName;
        asset.u = "/u/";
        asset.e = 0;
      }
    }
    return false;
  }
};

// ../../node_modules/.pnpm/browser-image-hash@0.0.5/node_modules/browser-image-hash/dist/HashableImageSourceConverter/DifferenceHash/VanilaConverter.js
var __read = function(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = function(to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
    to[j] = from[i];
  return to;
};
var VanilaConverter = (
  /** @class */
  function() {
    function VanilaConverter2(document2, glayScaleCalculator, resizer) {
      this.document = document2;
      this.glayScaleCalculator = glayScaleCalculator;
      this.resizer = resizer;
    }
    VanilaConverter2.prototype.createCanvasRenderingContext2D = function(width, height) {
      var canvas = this.document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      canvas.setAttribute("style", "image-rendering: -webkit-optimize-contrast; image-rendering: crisp-edges;");
      var ctx = canvas.getContext("2d");
      if (ctx === null) {
        throw new ReferenceError("undefined CanvasRenderingContext2D");
      }
      ctx.mozImageSmoothingEnabled = true;
      ctx.webkitImageSmoothingEnabled = true;
      ctx.msImageSmoothingEnabled = true;
      ctx.imageSmoothingEnabled = true;
      return ctx;
    };
    VanilaConverter2.prototype.convert = function(source) {
      var _this = this;
      var img = new Image();
      var result = new Promise(function(resolve) {
        img.onload = function() {
          var ctx = _this.createCanvasRenderingContext2D(img.width, img.height);
          ctx.drawImage(img, 0, 0, img.width, img.height);
          var colorMap = ctx.getImageData(0, 0, img.width, img.height).data;
          resolve(colorMap);
        };
      }).then(function(colorMap) {
        return _this.resizer.resize(colorMap, img.width, img.height, source.width, source.height);
      }).then(function(resizedColorMap) {
        var glayArraySouce = __spreadArray([], __read(Array(resizedColorMap.length / 4).keys())).map(function(i) {
          var index = i * 4;
          var _a = __read([
            resizedColorMap[index],
            resizedColorMap[index + 1],
            resizedColorMap[index + 2]
          ], 3), r = _a[0], g = _a[1], b = _a[2];
          return _this.glayScaleCalculator(r, g, b);
        });
        return new Uint8ClampedArray(glayArraySouce);
      });
      img.src = source.url.toString();
      return result;
    };
    return VanilaConverter2;
  }()
);
var VanilaConverter_default = VanilaConverter;

// ../../node_modules/.pnpm/browser-image-hash@0.0.5/node_modules/browser-image-hash/dist/HashSource.js
var HashSource = (
  /** @class */
  function() {
    function HashSource2(url, hashSize) {
      if (hashSize === void 0) {
        hashSize = 8;
      }
      this.url = url;
      this.hashSize = hashSize;
      this.width = hashSize + 1;
      this.height = hashSize;
    }
    HashSource2.prototype.calculateArea = function() {
      return this.width * this.height;
    };
    return HashSource2;
  }()
);
var HashSource_default = HashSource;

// ../../node_modules/.pnpm/browser-image-hash@0.0.5/node_modules/browser-image-hash/dist/HashableImageSourceConverter/Resizer/LanczosResizer.js
var import_lanczos = __toESM(require_dist3());
var LanczosResizer = (
  /** @class */
  function() {
    function LanczosResizer2() {
    }
    LanczosResizer2.prototype.resize = function(source, nativeWidth, nativeHeight, expectedWidth, expectedHeight) {
      var sourceImageData = new ImageDataSouce(nativeWidth, nativeHeight, source);
      var destImageData = new ImageDataSouce(expectedWidth, expectedHeight, new Uint8ClampedArray(expectedWidth * expectedHeight * 4));
      (0, import_lanczos.lanczos)(sourceImageData, destImageData);
      return destImageData.data;
    };
    return LanczosResizer2;
  }()
);
var LanczosResizer_default = LanczosResizer;
var ImageDataSouce = (
  /** @class */
  /* @__PURE__ */ function() {
    function ImageDataSouce2(width, height, source) {
      this.width = width;
      this.height = height;
      this.data = source;
    }
    return ImageDataSouce2;
  }()
);

// ../../node_modules/.pnpm/browser-image-hash@0.0.5/node_modules/browser-image-hash/dist/Hash.js
var __read2 = function(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray2 = function(to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
    to[j] = from[i];
  return to;
};
var Hash = (
  /** @class */
  function() {
    function Hash2(rawHash) {
      if (rawHash.split("").find(function(row) {
        return row !== "1" && row !== "0";
      })) {
        throw new TypeError("Not bits.");
      }
      this.rawHash = rawHash;
    }
    Hash2.prototype.getHammingDistance = function(hash) {
      if (this.rawHash.length !== hash.rawHash.length) {
        throw new TypeError("Not equal to hash length.");
      }
      var target = hash.rawHash.split("");
      var diff = this.rawHash.split("").filter(function(row, index) {
        return row !== (target[index] || "0");
      });
      return diff.length;
    };
    Hash2.prototype.toString = function() {
      return this.calcuateHexadecimal(this.rawHash.split("").map(function(row) {
        return row === "1" ? 1 : 0;
      }));
    };
    Hash2.prototype.arrayChunk = function(array5, chunk) {
      return __spreadArray2([], __read2(Array(Math.ceil(array5.length / chunk)).keys())).map(function(index) {
        return array5.slice(index * chunk, index * chunk + chunk);
      });
    };
    Hash2.prototype.calcuateHexadecimal = function(binalyNumbers) {
      return this.arrayChunk(binalyNumbers, 4).map(function(row) {
        return parseInt(row.join(""), 2).toString(16);
      }).join("");
    };
    return Hash2;
  }()
);
var Hash_default = Hash;

// ../../node_modules/.pnpm/browser-image-hash@0.0.5/node_modules/browser-image-hash/dist/HashGenerator.js
var __read3 = function(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray3 = function(to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
    to[j] = from[i];
  return to;
};
var HashGenerator = (
  /** @class */
  function() {
    function HashGenerator2(document2) {
      this.document = document2;
    }
    HashGenerator2.prototype.generateByImage = function(source, glayImage) {
      glayImage.width = source.width;
      glayImage.height = source.height;
      var canvas = this.document.createElement("canvas");
      var context = canvas.getContext("2d");
      if (context === null) {
        throw new ReferenceError("undefined CanvasRenderingContext2D");
      }
      context.drawImage(glayImage, 0, 0, source.width, source.height);
      return this.generate(source, context);
    };
    HashGenerator2.prototype.generateByCanvasRenderingContext2D = function(source, glayImageDrawingCanvasContext) {
      var imageData = glayImageDrawingCanvasContext.getImageData(0, 0, source.width, source.height).data;
      var glayArray = new Uint8ClampedArray(__spreadArray3([], __read3(Array(imageData.length / 4).keys())).map(function(i) {
        var index = i * 4;
        return imageData[index];
      }));
      return this.generate(source, glayArray);
    };
    HashGenerator2.prototype.generateByUint8ClampedArray = function(source, glayArray) {
      if (glayArray.length !== source.calculateArea()) {
        throw new Error("Not convertable grayArray, convertable grayArray length is " + source.calculateArea());
      }
      var binaryNumbers = Array.from(glayArray).map(function(row, index, colors) {
        return row <= colors[index + 1] ? 1 : 0;
      }).filter(function(_, index) {
        return (index + 1) % source.width !== 0;
      }).join("");
      return new Hash_default(binaryNumbers);
    };
    HashGenerator2.prototype.generate = function(source, glayImageSource) {
      if (glayImageSource instanceof HTMLImageElement) {
        return this.generateByImage(source, glayImageSource);
      } else if (glayImageSource instanceof CanvasRenderingContext2D) {
        return this.generateByCanvasRenderingContext2D(source, glayImageSource);
      } else if (glayImageSource instanceof Uint8ClampedArray) {
        return this.generateByUint8ClampedArray(source, glayImageSource);
      }
      throw new TypeError("Not generatable glay image source.");
    };
    return HashGenerator2;
  }()
);
var HashGenerator_default = HashGenerator;

// ../../node_modules/.pnpm/browser-image-hash@0.0.5/node_modules/browser-image-hash/dist/HashableImageSourceConverter/GlayScaleCalculator/ITU_R601_2Method.js
function ITU_R601_2Method(r, g, b) {
  return Math.round(r * 299 / 1e3 + g * 587 / 1e3 + b * 114 / 1e3);
}

// ../../node_modules/.pnpm/browser-image-hash@0.0.5/node_modules/browser-image-hash/dist/DifferenceHashBuilder.js
var __awaiter = function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, [])).next());
  });
};
var __generator = function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1) throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return { value: op[1], done: false };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var DifferenceHashBuilder = (
  /** @class */
  function() {
    function DifferenceHashBuilder2(dHashConverter, document2) {
      if (dHashConverter === void 0) {
        dHashConverter = null;
      }
      if (document2 === void 0) {
        document2 = window.document;
      }
      if (dHashConverter === null) {
        dHashConverter = new VanilaConverter_default(document2, ITU_R601_2Method, new LanczosResizer_default());
      }
      this.dHashConverter = dHashConverter;
      this.generator = new HashGenerator_default(document2);
    }
    DifferenceHashBuilder2.prototype.build = function(url, hashSize) {
      if (hashSize === void 0) {
        hashSize = 8;
      }
      return __awaiter(this, void 0, void 0, function() {
        var source, hashableImageSouce;
        return __generator(this, function(_a) {
          switch (_a.label) {
            case 0:
              source = new HashSource_default(url, hashSize);
              return [4, this.dHashConverter.convert(source)];
            case 1:
              hashableImageSouce = _a.sent();
              return [2, this.generator.generate(source, hashableImageSouce)];
          }
        });
      });
    };
    return DifferenceHashBuilder2;
  }()
);
var DifferenceHashBuilder_default = DifferenceHashBuilder;

// src/v2/common/plugin.ts
var DotLottiePlugin = class {
  constructor(options) {
    __publicField(this, "dotlottie");
    __publicField(this, "_parallel", false);
    this.dotlottie = void 0;
    if (options?.parallel) {
      this._parallel = options.parallel;
    }
  }
  install(dotlottie) {
    this.dotlottie = dotlottie;
  }
  uninstall() {
    this.dotlottie = void 0;
  }
  get parallel() {
    return this._parallel;
  }
  set parallel(value) {
    this._parallel = value;
  }
  async onBuild() {
    throw new DotLottieError("dotlottie-plugin build Not implemented!");
  }
  _requireDotLottie(dotLottie) {
    if (!dotLottie) throw new DotLottieError("dotLottie context is null inside of duplicate image detector plugin.");
  }
};

// src/v2/common/plugins/duplicate-image-detector.ts
var DuplicateImageDetectorCommon = class extends DotLottiePlugin {
  async generatePhash(_image) {
    throw new DotLottieError(
      "generatePhash(image: LottieImageCommon): Promise<Hash> is not implemented in concrete class."
    );
  }
  distanceTo(_imageHash, _targetImageHash) {
    throw new DotLottieError(
      "distanceTo(_imageHash: string, _targetImageHash: string): Promise<number> is not implemented in concrete class."
    );
  }
  async _createRecordOfDuplicates() {
    this._requireDotLottie(this.dotlottie);
    const images = [];
    const recordOfDuplicates = {};
    for (const animation of this.dotlottie.animations) {
      for (const image of animation.imageAssets) {
        images.push({
          excludeFromExport: false,
          image,
          hash: await this.generatePhash(image)
        });
      }
    }
    for (const image of images) {
      for (const compareImage of images) {
        if (image.image.lottieAssetId !== compareImage.image.lottieAssetId && !image.excludeFromExport && !compareImage.excludeFromExport && image.hash && compareImage.hash && this.distanceTo(image.hash, compareImage.hash) < 5) {
          if (!recordOfDuplicates[image.image.fileName] && !recordOfDuplicates[compareImage.image.fileName]) {
            compareImage.excludeFromExport = true;
            recordOfDuplicates[image.image.fileName] = [compareImage.image];
          } else if (recordOfDuplicates[compareImage.image.fileName]) {
            if (!recordOfDuplicates[compareImage.image.fileName]?.find((item) => item.id === image.image.lottieAssetId)) {
              image.excludeFromExport = true;
              recordOfDuplicates[compareImage.image.fileName]?.push(image.image);
            }
          }
        }
      }
    }
    return recordOfDuplicates;
  }
  /**
   * Apply the image path to all duplicate images.
   *
   * @param recordOfDuplicates - A record of duplicate images, the key being a fileName,
   * the value being the identical LottieImageCommon object.
   */
  adjustDuplicateImageAssetPath(animation, recordOfDuplicates) {
    for (const key in recordOfDuplicates) {
      if (key) {
        recordOfDuplicates[key]?.forEach((item) => {
          if (animation.data) {
            const animationAssets = animation.data.assets;
            if (animationAssets) {
              animationAssets.forEach((asset) => {
                if ("w" in asset && "h" in asset) {
                  if (asset.p === item.fileName) {
                    const fileName = key;
                    asset.p = fileName;
                  }
                }
              });
            }
          }
        });
      }
    }
  }
  async onBuild() {
    this._requireDotLottie(this.dotlottie);
    const recordOfDuplicates = await this._createRecordOfDuplicates();
    this.dotlottie.animations.forEach((animation) => {
      this.adjustDuplicateImageAssetPath(animation, recordOfDuplicates);
    });
    const clonedImages = {};
    const images = this.dotlottie.getImages();
    for (const key in recordOfDuplicates) {
      if (key) {
        for (const image of images) {
          if (image.fileName === key && image.data !== void 0) {
            clonedImages[key] = new LottieImage({
              data: image.data,
              id: image.id,
              lottieAssetId: image.lottieAssetId,
              fileName: image.fileName
            });
          }
        }
      }
    }
    if (Object.keys(clonedImages).length !== Object.keys(recordOfDuplicates).length)
      throw new DotLottieError("The number of cloned images does not match the number of duplicate keys.");
    for (const key in recordOfDuplicates) {
      if (key) {
        recordOfDuplicates[key]?.forEach((image) => {
          if (image.parentAnimations.length) {
            for (const parentAnimation of image.parentAnimations) {
              parentAnimation.imageAssets.splice(parentAnimation.imageAssets.indexOf(image), 1);
              const clonedImage = clonedImages[key];
              if (clonedImage !== void 0) {
                parentAnimation.imageAssets.push(clonedImage);
                clonedImage.parentAnimations.push(parentAnimation);
              }
            }
          }
        });
      }
    }
  }
};

// src/v2/browser/plugins/duplicate-image-detector.ts
var DuplicateImageDetector = class extends DuplicateImageDetectorCommon {
  async generatePhash(image) {
    const builder = new DifferenceHashBuilder_default();
    const targetURL = new URL(await image.toDataURL());
    const destHash = await builder.build(targetURL);
    return destHash.rawHash;
  }
  distanceTo(imageHash, targetImageHash) {
    const srcHash = new Hash_default(imageHash);
    const targetHash = new Hash_default(targetImageHash);
    return srcHash.getHammingDistance(targetHash);
  }
};

// src/v2/browser/dotlottie.ts
async function toDotLottieV2(arrayBuffer) {
  const version = await getDotLottieVersion(new Uint8Array(arrayBuffer));
  if (version !== "2") {
    const dotLottieV2 = new DotLottie();
    const dotLottieV1 = await new DotLottieV1().fromArrayBuffer(arrayBuffer);
    const animationIds = dotLottieV1.animations.map((animation) => animation.id);
    for (const animationId of animationIds) {
      const animation = await dotLottieV1.getAnimation(animationId, { inlineAssets: true });
      if (animation && animation.data) {
        dotLottieV2.addAnimation({
          data: animation.data,
          id: animationId
        });
      }
    }
    await dotLottieV2.build();
    return dotLottieV2;
  }
  return new DotLottie().fromArrayBuffer(arrayBuffer);
}
var DotLottie = class _DotLottie extends DotLottieCommon {
  constructor(options) {
    super(options);
    if (this.enableDuplicateImageOptimization) {
      const plugin = new DuplicateImageDetector();
      plugin.install(this);
      this._plugins.push(plugin);
    }
  }
  addAnimation(animationOptions) {
    const animation = new LottieAnimation(animationOptions);
    if (this._animationsMap.get(animationOptions.id)) {
      throw new DotLottieError("Duplicate animation id detected, aborting.");
    }
    this._animationsMap.set(animation.id, animation);
    return this;
  }
  async toBase64(options) {
    const data = await this.toArrayBuffer(options);
    const uint8Array = new Uint8Array(data);
    const binaryString = uint8Array.reduce((acc, val) => acc + String.fromCharCode(val), "");
    return window.btoa(binaryString);
  }
  async download(fileName, options) {
    const blob = await this.toBlob(options);
    const dataURL = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = dataURL;
    link.download = fileName;
    link.style.display = "none";
    document.body.append(link);
    link.click();
    setTimeout(() => {
      URL.revokeObjectURL(dataURL);
      link.remove();
    }, 1e3);
  }
  create(options) {
    return new _DotLottie(options);
  }
  async toArrayBuffer(options) {
    const manifest = this._buildManifest();
    const dotlottie = {
      "manifest.json": [strToU8(JSON.stringify(manifest)), {}]
    };
    for (const animation of this.animations) {
      const json = await animation.toJSON();
      dotlottie[`a/${animation.id}.json`] = [strToU8(JSON.stringify(json)), animation.zipOptions];
      const imageAssets = animation.imageAssets;
      const audioAssets = animation.audioAssets;
      for (const asset of imageAssets) {
        const dataAsString = await asset.toDataURL();
        dotlottie[`i/${asset.fileName}`] = [base64ToUint8Array(dataAsString), asset.zipOptions];
      }
      for (const asset of audioAssets) {
        const dataAsString = await asset.toDataURL();
        dotlottie[`u/${asset.fileName}`] = [base64ToUint8Array(dataAsString), asset.zipOptions];
      }
    }
    for (const theme of this.themes) {
      const themeData = await theme.toString();
      dotlottie[`t/${theme.id}.json`] = [strToU8(themeData), theme.zipOptions];
    }
    for (const state of this.stateMachines) {
      const stateData = state.toString();
      dotlottie[`s/${state.id}.json`] = [strToU8(stateData), state.zipOptions];
    }
    const dotlottieArrayBuffer = await new Promise((resolve, reject) => {
      zip(dotlottie, options?.zipOptions || {}, (err, data) => {
        if (err) {
          reject(err);
          return;
        }
        resolve(data.buffer);
      });
    });
    return dotlottieArrayBuffer;
  }
  /**
   * Creates a DotLottie instance from an array buffer
   * @param arrayBuffer - array buffer of the dotlottie file
   * @returns DotLottie instance
   * @throws Error
   */
  async fromArrayBuffer(arrayBuffer) {
    const dotLottieVersion = await getDotLottieVersion(new Uint8Array(arrayBuffer));
    if (dotLottieVersion !== "2") {
      return toDotLottieV2(arrayBuffer);
    }
    const dotlottie = new _DotLottie();
    try {
      const contentObj = await new Promise((resolve, reject) => {
        unzip(new Uint8Array(arrayBuffer), (err, data) => {
          if (err) {
            reject(err);
          }
          resolve(data);
        });
      });
      const tmpImages = [];
      const tmpAudio = [];
      if (contentObj["manifest.json"] instanceof Uint8Array) {
        try {
          const manifest = JSON.parse(strFromU8(contentObj["manifest.json"], false));
          for (const key of Object.keys(contentObj)) {
            const decodedStr = strFromU8(contentObj[key], true);
            if (key.startsWith("a/") && key.endsWith(".json")) {
              const animationId = /a\/(.+)\.json/u.exec(key)?.[1];
              if (!animationId) {
                throw new DotLottieError("Invalid animation id");
              }
              const animation = JSON.parse(decodedStr);
              const animationSettings = manifest.animations.find((anim) => anim.id === animationId);
              if (animationSettings === void 0) {
                throw new DotLottieError("Animation not found inside manifest");
              }
              dotlottie.addAnimation({
                data: animation,
                ...animationSettings
              });
            } else if (key.startsWith("i/")) {
              const imageId = /i\/(.+)\./u.exec(key)?.[1];
              if (!imageId) {
                throw new DotLottieError("Invalid image id");
              }
              let decodedImg = btoa(decodedStr);
              const ext = await getExtensionTypeFromBase64(decodedImg);
              decodedImg = `data:image/${ext};base64,${decodedImg}`;
              tmpImages.push(
                new LottieImage({
                  id: imageId,
                  lottieAssetId: imageId,
                  data: decodedImg,
                  fileName: key.split("/")[1] || ""
                })
              );
            } else if (key.startsWith("u/")) {
              const audioId = /u\/(.+)\./u.exec(key)?.[1];
              if (!audioId) {
                throw new DotLottieError("Invalid image id");
              }
              let decodedAudio = btoa(decodedStr);
              const ext = await getExtensionTypeFromBase64(decodedAudio);
              decodedAudio = `data:audio/${ext};base64,${decodedAudio}`;
              tmpAudio.push(
                new LottieAudio({
                  id: audioId,
                  data: decodedAudio,
                  fileName: key.split("/")[1] || ""
                })
              );
            } else if (key.startsWith("t/") && key.endsWith(".json")) {
              const themeId = /t\/(.+)\.json/u.exec(key)?.[1];
              if (!themeId) {
                throw new DotLottieError("Invalid theme id");
              }
              manifest.themes?.forEach((theme) => {
                if (theme.id === themeId) {
                  dotlottie.addTheme({
                    id: theme.id,
                    name: theme.name,
                    data: JSON.parse(decodedStr)
                  });
                }
              });
            } else if (key.startsWith("s/") && key.endsWith(".json")) {
              const stateId = /s\/(.+)\.json/u.exec(key)?.[1];
              if (!stateId) {
                throw new DotLottieError("Invalid theme id");
              }
              manifest.stateMachines?.forEach((stateMachine) => {
                if (stateMachine.id === stateId) {
                  dotlottie.addStateMachine({
                    id: stateMachine.id,
                    name: stateMachine.name,
                    data: JSON.parse(decodedStr)
                  });
                }
              });
            }
          }
          for (const image of tmpImages) {
            for (const parentAnimation of dotlottie.animations) {
              if (parentAnimation.data) {
                const animationAssets = parentAnimation.data.assets;
                if (animationAssets) {
                  for (const asset of animationAssets) {
                    if ("w" in asset && "h" in asset) {
                      if (asset.p === image.fileName) {
                        image.parentAnimations.push(parentAnimation);
                        parentAnimation.imageAssets.push(image);
                      }
                    }
                  }
                }
              }
            }
          }
          for (const audio of tmpAudio) {
            for (const parentAnimation of dotlottie.animations) {
              if (parentAnimation.data) {
                const animationAssets = parentAnimation.data.assets;
                if (animationAssets) {
                  for (const asset of animationAssets) {
                    if (isAudioAsset(asset)) {
                      if (asset.p.includes(audio.id)) {
                        audio.parentAnimations.push(parentAnimation);
                        parentAnimation.audioAssets.push(audio);
                      }
                    }
                  }
                }
              }
            }
          }
        } catch (err) {
          if (err instanceof Error) {
            throw new DotLottieError(`Invalid manifest inside buffer! ${err.message}`);
          }
        }
      } else {
        throw new DotLottieError("Invalid buffer");
      }
    } catch (err) {
      if (err instanceof Error) {
        throw new DotLottieError(err.message);
      }
    }
    return dotlottie;
  }
};

// src/v2/browser/theme.ts
var LottieTheme = class extends LottieThemeCommon {
  constructor(options) {
    super(options);
  }
};

// src/v2/browser/state-machine.ts
var LottieStateMachine = class extends DotLottieStateMachineCommon {
  constructor(options) {
    super(options);
  }
};

// src/v1/common/dotlottie.ts
var DotLottieCommonV1 = class {
  constructor(options) {
    __publicField(this, "_animationsMap", /* @__PURE__ */ new Map());
    __publicField(this, "_plugins", []);
    __publicField(this, "_author", PACKAGE_NAME);
    __publicField(this, "_description");
    __publicField(this, "_generator", PACKAGE_NAME);
    __publicField(this, "_keywords");
    __publicField(this, "_version", "1");
    __publicField(this, "_revision");
    // Custom data for the DotLottieV1
    __publicField(this, "_customData");
    __publicField(this, "enableDuplicateImageOptimization");
    if (typeof options?.author === "string") {
      this._author = options.author;
    }
    if (typeof options?.description === "string") {
      this._description = options.description;
    }
    if (typeof options?.generator === "string") {
      this._generator = options.generator;
    }
    if (typeof options?.keywords === "string") {
      this._keywords = options.keywords;
    }
    if (typeof options?.revision === "number") {
      this._revision = options.revision;
    }
    this.enableDuplicateImageOptimization = options?.enableDuplicateImageOptimization ?? false;
  }
  async toBase64(_options = void 0) {
    throw new DotLottieError("toBase64() method not implemented in concrete class!");
  }
  create(_options) {
    throw new DotLottieError("create() method not implemented in concrete class!");
  }
  async download(_fileName, _options = void 0) {
    throw new DotLottieError("download(fileName:string) method not implemented in concrete class!");
  }
  addPlugins(..._plugins) {
    throw new DotLottieError("addPlugins(...plugins: DotLottieV1Plugin[]) not implemented in concrete class!");
  }
  addAnimation(_animationOptions) {
    throw new DotLottieError("addAnimation(animationOptions: AnimationOptions) not implemented in concrete class!");
  }
  async fromArrayBuffer(_arrayBuffer) {
    throw new DotLottieError(
      "fromArrayBuffer(arrayBuffer: ArrayBuffer): Promise<DotLottieCommonV1> not implemented in concrete class!"
    );
  }
  async toArrayBuffer(_options = void 0) {
    throw new DotLottieError("toArrayBuffer(): Promise<ArrayBuffer> is not implemented in concrete class!");
  }
  get plugins() {
    return this._plugins;
  }
  get version() {
    return this._version;
  }
  get revision() {
    return this._revision;
  }
  get author() {
    return this._author;
  }
  get description() {
    return this._description;
  }
  get keywords() {
    return this._keywords;
  }
  get generator() {
    return this._generator;
  }
  get animations() {
    return Array.from(this._animationsMap.values());
  }
  get manifest() {
    return this._buildManifest();
  }
  get custom() {
    return this._customData;
  }
  setCustomData(customData) {
    this._customData = customData ?? {};
    return this;
  }
  setAuthor(author) {
    this._author = author;
    return this;
  }
  setDescription(description) {
    this._description = typeof description === "string" ? description : "";
    return this;
  }
  setKeywords(keywords) {
    this._keywords = typeof keywords === "string" ? keywords : "DotLottieV1";
    return this;
  }
  setRevision(revision) {
    this._revision = revision;
    return this;
  }
  /**
   * Renames the underlying LottieImageV1, as well as updating the image asset path inside the animation data.
   * @param newName - desired id and fileName,
   * @param imageId - The id of the LottieImageV1 to rename
   */
  async _renameImage(animation, newLottieAssetId, lottieAssetId) {
    for (const imageAsset of animation.imageAssets) {
      if (imageAsset.lottieAssetId === lottieAssetId) {
        const oldPath = imageAsset.fileName;
        await imageAsset.renameImage(newLottieAssetId);
        if (!animation.data) throw new DotLottieError("No animation data available.");
        const animationAssets = animation.data.assets;
        if (!animationAssets) throw new DotLottieError("No image assets to rename.");
        for (const asset of animationAssets) {
          if ("w" in asset && "h" in asset) {
            if (asset.p === oldPath) {
              asset.p = imageAsset.fileName;
            }
          }
        }
      }
    }
  }
  /**
   * Generates a map of duplicate image ids and their count.
   * @returns Map of duplicate image ids and their count.
   */
  _generateMapOfOccurencesFromImageIds() {
    const dupeMap = /* @__PURE__ */ new Map();
    this.animations.forEach((animation) => {
      animation.imageAssets.forEach((imageAsset) => {
        if (dupeMap.has(imageAsset.lottieAssetId)) {
          const count = dupeMap.get(imageAsset.lottieAssetId) ?? 0;
          dupeMap.set(imageAsset.lottieAssetId, count + 1);
        } else {
          dupeMap.set(imageAsset.lottieAssetId, 1);
        }
      });
    });
    return dupeMap;
  }
  /**
   * Renames the image assets in all animations to avoid conflicts.
   *
   * Steps:
   *  - Generate how many times across all animations the same image id has been used.
   *  - Loop through every animation in reverse order
   *  - Every time an animation uses an image asset that is also used elsewhere, append the count to the image's asset id and then decrement.
   *
   * Result of renaming for every animation:
   *
   * - Inside the Lottie's data and it's Asset object:
   *  - The Asset id stays the same, meaning that every reference to the asset is still valid (refId)
   *  - The path is changed to the new asset id with the format \{assetId\}_\{count\}
   *
   * - On the dotLottie file system scope:
   *  - The image file name is changed to the new asset id \{assetId\}_\{count\}.\{ext\}
   */
  async _renameImageAssets() {
    const occurenceMap = this._generateMapOfOccurencesFromImageIds();
    for (let i = this.animations.length - 1; i >= 0; i -= 1) {
      const animation = this.animations.at(i);
      if (animation) {
        for (let j = animation.imageAssets.length - 1; j >= 0; j -= 1) {
          const image = animation.imageAssets.at(j);
          if (image) {
            let count = occurenceMap.get(image.lottieAssetId) ?? 0;
            if (count > 0) {
              count -= 1;
            }
            occurenceMap.set(image.lottieAssetId, count);
            if (count > 0) {
              await this._renameImage(animation, `${image.lottieAssetId}_${count}`, image.lottieAssetId);
            }
          }
        }
      }
    }
  }
  /**
   * Renames the underlying LottieAudioV1, as well as updating the audio asset path inside the animation data.
   * @param newName - desired id and fileName,
   * @param audioId - The id of the LottieAudioV1 to rename
   */
  async _renameAudio(animation, newName, audioId) {
    for (const audioAsset of animation.audioAssets) {
      if (audioAsset.id === audioId) {
        await audioAsset.renameAudio(newName);
        if (!animation.data) throw new DotLottieError("No animation data available.");
        const animationAssets = animation.data.assets;
        if (!animationAssets) throw new DotLottieError("No audio assets to rename.");
        for (const asset of animationAssets) {
          if (isAudioAsset(asset)) {
            if (asset.id === audioId) {
              asset.p = audioAsset.fileName;
            }
          }
        }
      }
    }
  }
  async _renameAudioAssets() {
    const audio = /* @__PURE__ */ new Map();
    this.animations.forEach((animation) => {
      audio.set(animation.id, animation.audioAssets);
    });
    let size = 0;
    audio.forEach((value) => {
      size += value.length;
    });
    for (let i = this.animations.length - 1; i >= 0; i -= 1) {
      const animation = this.animations.at(i);
      if (animation) {
        for (let j = animation.audioAssets.length - 1; j >= 0; j -= 1) {
          const audioAsset = animation.audioAssets.at(j);
          if (audioAsset) {
            await this._renameAudio(animation, `audio_${size}`, audioAsset.id);
            size -= 1;
          }
        }
      }
    }
  }
  _addLottieAnimation(animation) {
    if (this._animationsMap.get(animation.id)) {
      throw new DotLottieError("Duplicate animation id detected, aborting.");
    }
    this._animationsMap.set(animation.id, animation);
    return this;
  }
  /**
   * Inlines all assets of the passed animation
   * @param animation - Animation whose asset are to be inlined
   * @returns LottieAnimationCommonV1 with inlined assets
   */
  async _findAssetsAndInline(animation) {
    const animationAssets = animation.data?.assets;
    if (!animationAssets) throw new DotLottieError("Failed to inline assets, the animation's assets are undefined.");
    const images = this.getImages();
    const audios = this.getAudio();
    for (const asset of animationAssets) {
      if (isImageAsset(asset)) {
        for (const image of images) {
          if (image.fileName === asset.p) {
            asset.e = 1;
            asset.u = "";
            asset.p = await image.toDataURL();
          }
        }
      } else if (isAudioAsset(asset)) {
        for (const audio of audios) {
          if (audio.fileName === asset.p) {
            asset.e = 1;
            asset.u = "";
            asset.p = await audio.toDataURL();
          }
        }
      }
    }
    return animation;
  }
  /**
   * Returns the desired animation
   * @param animationId - desired animation id
   * @param inlineAssets - if true will inline the assets inside the data of the LottieAnimationV1
   * @returns
   */
  async getAnimation(animationId, options) {
    if (!options?.inlineAssets) return this._animationsMap.get(animationId);
    let dataWithInlinedImages = this._animationsMap.get(animationId);
    if (!dataWithInlinedImages) throw new DotLottieError("Failed to find animation.");
    dataWithInlinedImages = await this._findAssetsAndInline(dataWithInlinedImages);
    return dataWithInlinedImages;
  }
  getAnimations() {
    return Array.from(this._animationsMap);
  }
  removeAnimation(animationId) {
    const targetAnimation = this._animationsMap.get(animationId);
    if (targetAnimation) {
      this._animationsMap.delete(targetAnimation.id);
    }
    return this;
  }
  getImages() {
    const images = [];
    this.animations.map((animation) => {
      return images.push(...animation.imageAssets);
    });
    return images;
  }
  getAudio() {
    const audio = [];
    this.animations.map((animation) => {
      return audio.push(...animation.audioAssets);
    });
    return audio;
  }
  _buildManifest() {
    const animationsList = Array.from(this._animationsMap.values()).map((animation) => ({
      id: animation.id,
      ...animation.autoplay !== void 0 && { autoplay: animation.autoplay },
      ...animation.loop !== void 0 && { loop: animation.loop },
      ...animation.speed !== void 0 && { speed: animation.speed },
      ...animation.direction !== void 0 && { direction: animation.direction },
      ...animation.playMode !== void 0 && { playMode: animation.playMode },
      ...animation.hover !== void 0 && { hover: animation.hover },
      ...animation.intermission !== void 0 && { intermission: animation.intermission },
      ...animation.themeColor !== void 0 && { themeColor: animation.themeColor }
    }));
    const manifest = {
      version: this.version,
      generator: this.generator,
      author: this.author,
      ...this.keywords !== void 0 && { keywords: this.keywords },
      ...this.revision !== void 0 && { revision: this.revision },
      animations: animationsList,
      ...this.description && this.description.trim() !== "" ? { description: this.description } : {},
      ...this._customData && Object.keys(this._customData).length !== 0 ? { custom: this._customData } : {}
    };
    return manifest;
  }
  /**
   * Constructs the manifest and calls toJSON on the animations
   * so the data is fetched for every animation.
   *
   * @returns DotLottieV1 context
   */
  async build() {
    this._buildManifest();
    for (const animation of this.animations) {
      await animation.toJSON();
    }
    if (this.animations.length > 1) {
      await this._renameImageAssets();
      await this._renameAudioAssets();
    }
    const parallelPlugins = [];
    const sequentialPlugins = [];
    for (const plugin of this.plugins) {
      if (plugin.parallel) {
        parallelPlugins.push(plugin);
      } else {
        sequentialPlugins.push(plugin);
      }
    }
    await Promise.all(parallelPlugins.map(async (plugin) => plugin.onBuild()));
    for (const plugin of sequentialPlugins) {
      await plugin.onBuild();
    }
    return this;
  }
  async toBlob(options = void 0) {
    const arrayBuffer = await this.toArrayBuffer(options);
    return new Blob([arrayBuffer], { type: "application/zip" });
  }
  /**
   * Creates a DotLottieV1 instance from a url to a DotLottieV1 file
   * @param url - url to the DotLottieV1 file
   * @returns DotLottieV1 instance
   */
  async fromURL(url) {
    if (!isValidURL(url)) throw new DotLottieError("Invalid URL");
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new DotLottieError(response.statusText);
      }
      const arrayBuffer = await response.arrayBuffer();
      return this.fromArrayBuffer(arrayBuffer);
    } catch (err) {
      if (err instanceof Error) {
        throw new DotLottieError(err.message);
      }
    }
    throw new DotLottieError("Unknown error");
  }
  merge(...DotLottieV1s) {
    const mergedDotLottieV1 = this.create();
    for (const dotLottieV1 of DotLottieV1s) {
      dotLottieV1.animations.forEach((animation) => {
        if (animation.data) {
          mergedDotLottieV1.addAnimation({
            id: animation.id,
            data: animation.data
          });
        } else if (animation.url) {
          mergedDotLottieV1.addAnimation({
            id: animation.id,
            url: animation.url
          });
        }
      });
    }
    return mergedDotLottieV1;
  }
  _requireValidAuthor(author) {
    if (typeof author !== "string") throw new DotLottieError("Invalid author");
  }
  _requireValidDescription(description) {
    if (typeof description !== "string") throw new DotLottieError("Invalid description");
  }
  _requireValidGenerator(generator) {
    if (typeof generator !== "string") throw new DotLottieError("Invalid generator");
  }
  _requireValidKeywords(keywords) {
    if (typeof keywords !== "string") throw new DotLottieError("Invalid keywords");
  }
  _requireValidVersion(version) {
    if (typeof version !== "string") throw new DotLottieError("Invalid version");
  }
  _requireValidCustomData(customData) {
    if (!customData) throw new DotLottieError("Invalid customData");
  }
};
var PlayMode = /* @__PURE__ */ ((PlayMode2) => {
  PlayMode2["Bounce"] = "bounce";
  PlayMode2["Normal"] = "normal";
  return PlayMode2;
})(PlayMode || {});
var PlayModeSchema = nativeEnum(PlayMode);
var ManifestAnimationSchemaV1 = object({
  id: string(),
  autoplay: optional(boolean()),
  loop: optional(union([boolean(), number()])),
  speed: optional(number()),
  direction: optional(union([literal(1), literal(-1)])),
  playMode: optional(PlayModeSchema),
  hover: optional(boolean()),
  intermission: optional(number()),
  themeColor: optional(string())
});
var ManifestSchemaV1 = object({
  version: optional(string()),
  generator: optional(string()),
  activeAnimationId: optional(string()),
  animations: array(ManifestAnimationSchemaV1),
  author: optional(string()),
  custom: optional(record(string(), any())),
  description: optional(string()),
  keywords: optional(string()),
  revision: optional(number())
});

// src/v1/common/animation.ts
var LottieAnimationCommonV1 = class {
  constructor(options) {
    __publicField(this, "_data");
    __publicField(this, "_id", "");
    __publicField(this, "_url");
    __publicField(this, "_direction");
    __publicField(this, "_speed");
    __publicField(this, "_playMode");
    __publicField(this, "_loop");
    __publicField(this, "_autoplay");
    __publicField(this, "_hover");
    __publicField(this, "_intermission");
    __publicField(this, "_themeColor");
    __publicField(this, "_zipOptions");
    // Will be translated to 'activeAnimationId' inside of the manifest file
    // This indicates if the player should play this animation by default rather than the first in the list.
    __publicField(this, "_defaultActiveAnimation");
    __publicField(this, "_imageAssets", []);
    __publicField(this, "_audioAssets", []);
    this._requireValidOptions(options);
    this._id = options.id;
    this._zipOptions = options.zipOptions ?? {};
    if (options.data) this._data = options.data;
    if (options.url) this._url = options.url;
    this._defaultActiveAnimation = options.defaultActiveAnimation ?? false;
    if (typeof options.direction === "number") {
      this.direction = options.direction;
    }
    if (typeof options.speed === "number") {
      this.speed = options.speed;
    }
    if (typeof options.playMode === "string") {
      this.playMode = options.playMode;
    }
    if (typeof options.loop === "boolean" || typeof options.loop === "number") {
      this.loop = options.loop;
    }
    if (typeof options.autoplay === "boolean") {
      this.autoplay = options.autoplay;
    }
    if (typeof options.hover === "boolean") {
      this.hover = options.hover;
    }
    if (typeof options.intermission === "number") {
      this.intermission = options.intermission;
    }
    if (typeof options.themeColor === "string") {
      this.themeColor = options.themeColor;
    }
  }
  async toBase64() {
    throw new DotLottieError("lottie animation controls tobase64 not implemented!");
  }
  get zipOptions() {
    return this._zipOptions;
  }
  set zipOptions(zipOptions) {
    this._zipOptions = zipOptions;
  }
  get id() {
    return this._id;
  }
  set id(id) {
    this._requireValidId(id);
    this._id = id;
  }
  get imageAssets() {
    return this._imageAssets;
  }
  set imageAssets(imageAssets) {
    this._imageAssets = imageAssets;
  }
  get audioAssets() {
    return this._audioAssets;
  }
  set audioAssets(audioAssets) {
    this._audioAssets = audioAssets;
  }
  get data() {
    return this._data;
  }
  set data(data) {
    this._requireValidLottieData(data);
    this._data = data;
  }
  get url() {
    return this._url;
  }
  set url(url) {
    this._requireValidUrl(url);
    this._url = url;
  }
  get themeColor() {
    return this._themeColor;
  }
  set themeColor(themeColor) {
    if (themeColor) {
      this._requireValidThemeColor(themeColor);
    }
    this._themeColor = themeColor;
  }
  get direction() {
    return this._direction;
  }
  set direction(direction) {
    this._direction = direction;
  }
  get speed() {
    return this._speed;
  }
  set speed(speed) {
    if (typeof speed === "number") {
      this._requireValidSpeed(speed);
    }
    this._speed = speed;
  }
  get playMode() {
    return this._playMode;
  }
  set playMode(playMode) {
    if (typeof playMode === "string") {
      this._requireValidPlayMode(playMode);
    }
    this._playMode = playMode;
  }
  get loop() {
    return this._loop;
  }
  set loop(loop) {
    if (typeof loop === "number" || typeof loop === "boolean") {
      this._requireValidLoop(loop);
    }
    this._loop = loop;
  }
  get autoplay() {
    return this._autoplay;
  }
  set autoplay(autoplay) {
    if (typeof autoplay === "boolean") {
      this._requireValidAutoplay(autoplay);
    }
    this._autoplay = autoplay;
  }
  get defaultActiveAnimation() {
    return this._defaultActiveAnimation;
  }
  set defaultActiveAnimation(defaultActiveAnimation) {
    this._defaultActiveAnimation = defaultActiveAnimation;
  }
  get hover() {
    return this._hover;
  }
  set hover(hover) {
    if (typeof hover === "boolean") {
      this._requireValidHover(hover);
    }
    this._hover = hover;
  }
  get intermission() {
    return this._intermission;
  }
  set intermission(intermission) {
    if (typeof intermission === "number") {
      this._requireValidIntermission(intermission);
    }
    this._intermission = intermission;
  }
  /**
   * Return the animation data as an array buffer.
   * @returns data - The animation data as an ArrayBuffer.
   * @throws Error - if the animation data is not set and the url is not provided.
   * @throws Error - if the animation data is not a valid Lottie animation data object.
   * @throws Error - if the fetch request fails.
   */
  async toArrayBuffer(options) {
    const dataJson = await this.toJSON(options);
    return new TextEncoder().encode(JSON.stringify(dataJson)).buffer;
  }
  async _extractImageAssets() {
    throw new DotLottieError("_extractImageAssets(): Promise<boolean> method not implemented in concrete class");
  }
  async _extractAudioAssets() {
    throw new DotLottieError("_extractAudioAssets(): Promise<boolean> method not implemented in concrete class");
  }
  /**
   * Return the animation data as a blob.
   * @returns blob - The animation data as a Blob.
   * @throws Error - if the animation data is not set and the url is not provided.
   * @throws Error - if the animation data is not a valid Lottie animation data object.
   * @throws Error - if the fetch request fails.
   */
  async toBlob(options = {}) {
    const dataJson = await this.toJSON(options);
    return new Blob([JSON.stringify(dataJson)], { type: "application/json" });
  }
  /**
   * Return the animation data as a JSON object.
   * If the animation data is not already set, it will be fetched from the provided url.
   * @returns data - The animation data.
   * @throws Error - if the animation data is not a valid Lottie animation data object.
   * @throws Error - if the fetch request fails.
   */
  async toJSON(options) {
    if (this._url && !this._data) {
      this._data = await this._fromUrl(this._url);
    }
    this._requireValidLottieData(this._data);
    if (this._data.assets?.length) {
      await this._extractImageAssets();
      await this._extractAudioAssets();
      if (options?.inlineAssets) {
        const animationAssets = this.data?.assets;
        if (!animationAssets)
          throw new DotLottieError("Failed to inline assets, the animation's assets are undefined.");
        const images = this.imageAssets;
        const audios = this.audioAssets;
        for (const asset of animationAssets) {
          if ("w" in asset && "h" in asset && !("xt" in asset) && "p" in asset) {
            for (const image of images) {
              if (image.fileName === asset.p) {
                asset.e = 1;
                asset.u = "";
                asset.p = await image.toDataURL();
              }
            }
          } else if (isAudioAsset(asset)) {
            for (const audio of audios) {
              if (audio.fileName === asset.p) {
                asset.e = 1;
                asset.u = "";
                asset.p = await audio.toDataURL();
              }
            }
          }
        }
      }
    }
    return this._data;
  }
  /**
   * Fetch the animation data from the provided url.
   * @param url - The url to fetch the animation data from.
   * @returns animationData - The animation data.
   * @throws Error - if the fetch request fails.
   * @throws Error - if the data object is not a valid Lottie animation data object.
   */
  async _fromUrl(url) {
    const response = await fetch(url);
    const text = await response.text();
    let json;
    try {
      json = JSON.parse(text);
    } catch (error) {
      if (error instanceof Error) {
        throw new DotLottieError(`${error.message}: Invalid json returned from url`);
      }
    }
    this._requireValidLottieData(json);
    return json;
  }
  /**
   * Ensure that the provided url is a valid string.
   * The url must be a non-empty string, otherwise an error will be thrown.
   * @param url - The url to validate.
   * @throws Error - if the url is not a valid string.
   *
   */
  _requireValidUrl(url) {
    try {
      new URL(url || "");
    } catch (_err) {
      throw new DotLottieError("Invalid animation url");
    }
  }
  /**
   * Ensure that the provided data object is a valid Lottie animation data object.
   * The data object must contain the following mandatory properties: v, ip, op, layers, fr, w, h.
   * If the data object does not contain all mandatory properties, an error will be thrown.
   * @param data - The data object to validate.
   * @throws Error - if the data object is not a valid Lottie animation data object.
   */
  _requireValidLottieData(data) {
    const mandatoryLottieProperties = ["v", "ip", "op", "layers", "fr", "w", "h"];
    const hasAllMandatoryProperties = mandatoryLottieProperties.every(
      (field) => Object.prototype.hasOwnProperty.call(data, field)
    );
    if (!hasAllMandatoryProperties) {
      throw new DotLottieError("Received invalid Lottie data.");
    }
  }
  /**
   * Ensure that the provided id is a valid string.
   * The id must be a non-empty string, otherwise an error will be thrown.
   * @param id - The id to validate.
   * @throws Error - if the id is not a valid string.
   */
  _requireValidId(id) {
    if (!id) throw new DotLottieError("Invalid animation id");
  }
  /**
   * Ensure that the provided url is a valid string.
   * The url must be a non-empty string, otherwise an error will be thrown.
   * @param url - The url to validate.
   * @throws Error - if the url is not a valid string.
   *
   */
  _requireValidDirection(direction) {
    if (direction !== -1 && direction !== 1) {
      throw new DotLottieError("Direction can only be -1 (backwards) or 1 (forwards)");
    }
  }
  /**
   * Ensure that the provided intermission is a valid, positive number.
   * @param intermission - The intermission to validate.
   * @throws Error - if the intermission is not a valid number.
   */
  _requireValidIntermission(intermission) {
    if (intermission < 0 || !Number.isInteger(intermission)) {
      throw new DotLottieError("intermission must be a positive number");
    }
  }
  /**
   * Ensure that the provided loop is a valid, positive number or boolean.
   * @param loop - The loop to validate.
   * @throws Error - if the loop is not a valid number or boolean.
   */
  _requireValidLoop(loop) {
    if (typeof loop === "number" && (!Number.isInteger(loop) || loop < 0)) {
      throw new DotLottieError("loop must be a positive number or boolean");
    }
  }
  /**
   * Ensure that the provided options object is a valid AnimationOptions object.
   * The options object must contain the following mandatory properties: id, data or url.
   * If the options object does not contain all mandatory properties, an error will be thrown.
   * @param options - The options object to validate.
   * @throws Error - if the options object is not a valid AnimationOptions object.
   * @throws Error - if the id is not a valid string.
   * @throws Error - if the data object is not a valid Lottie animation data object.
   * @throws Error - if the url is not a valid url string.
   * @throws Error - if the data object is not set and the url is not provided.
   */
  _requireValidOptions(options) {
    this._requireValidId(options.id);
    if (!options.data && !options.url) {
      throw new DotLottieError("No data or url provided.");
    }
    if (options.data) {
      this._requireValidLottieData(options.data);
    }
    if (options.url) {
      this._requireValidUrl(options.url);
    }
    if (options.direction) {
      this._requireValidDirection(options.direction);
    }
    if (options.intermission) {
      this._requireValidIntermission(options.intermission);
    }
    if (options.loop) {
      this._requireValidLoop(options.loop);
    }
  }
  _requireValidSpeed(speed) {
    if (speed !== void 0 && (typeof speed !== "number" || speed < 0)) {
      throw new DotLottieError("Speed must be a non-negative number");
    }
  }
  _requireValidPlayMode(playMode) {
    const validPlayModes = Object.values(PlayMode);
    if (playMode !== void 0 && !validPlayModes.includes(playMode)) {
      throw new DotLottieError(`playMode must be one of: ${validPlayModes.join(", ")}`);
    }
  }
  _requireValidAutoplay(autoplay) {
    if (autoplay !== void 0 && typeof autoplay !== "boolean") {
      throw new DotLottieError("autoplay must be a boolean");
    }
  }
  _requireValidHover(hover) {
    if (hover !== void 0 && typeof hover !== "boolean") {
      throw new DotLottieError("Hover must be a boolean");
    }
  }
  _requireValidThemeColor(themeColor) {
    if (themeColor !== void 0 && typeof themeColor !== "string") {
      throw new DotLottieError("themeColor must be a string and start with #");
    }
    if (themeColor !== void 0 && !themeColor.startsWith("#")) {
      throw new DotLottieError("themeColor must be a string and start with #");
    }
  }
};

// src/v1/common/image.ts
var LottieImageCommonV1 = class {
  constructor(options) {
    __publicField(this, "_data");
    /**
     * Unique id for the LottieImageCommon object. This is never modified.
     */
    __publicField(this, "_id", "");
    /**
     * Asset id representing the image asset inside the Lottie animation. This can be modified.
     */
    __publicField(this, "_lottieAssetId", "");
    __publicField(this, "_fileName", "");
    __publicField(this, "_parentAnimations");
    __publicField(this, "_zipOptions");
    this._requireValidId(options.id);
    this._requireValidLottieAssetId(options.lottieAssetId);
    this._requireValidFileName(options.fileName);
    this._zipOptions = options.zipOptions ?? {};
    if (options.data) {
      this._data = options.data;
    }
    if (options.id) {
      this._id = options.id;
    }
    if (options.lottieAssetId) {
      this._lottieAssetId = options.lottieAssetId;
    }
    if (options.fileName) {
      this._fileName = options.fileName;
    }
    this._parentAnimations = options.parentAnimations || [];
  }
  get zipOptions() {
    return this._zipOptions;
  }
  set zipOptions(zipOptions) {
    this._zipOptions = zipOptions;
  }
  /**
   * Ensure that the provided id is a valid string.
   * The id must be a non-empty string, otherwise an error will be thrown.
   * @param id - The id to validate.
   * @throws Error - if the id is not a valid string.
   */
  _requireValidId(id) {
    if (!id) throw new DotLottieError("Invalid image id");
  }
  /**
   * Ensure that the provided id is a valid string.
   * The id must be a non-empty string, otherwise an error will be thrown.
   * @param id - The id to validate.
   * @throws Error - if the id is not a valid string.
   */
  _requireValidLottieAssetId(id) {
    if (!id) throw new DotLottieError("Invalid Lottie Image Asset Id");
  }
  /**
   * Ensure that the provided fileName is a valid string.
   * The fileName must be a non-empty string, otherwise an error will be thrown.
   * @param fileName - The fileName to validate.
   * @throws Error - if the fileName is not a valid string.
   */
  _requireValidFileName(fileName) {
    if (!fileName) throw new DotLottieError("Invalid image fileName");
  }
  get fileName() {
    return this._fileName;
  }
  set fileName(fileName) {
    this._requireValidFileName(fileName);
    this._fileName = fileName;
  }
  get id() {
    return this._id;
  }
  set id(id) {
    this._requireValidId(id);
    this._id = id;
  }
  get lottieAssetId() {
    return this._lottieAssetId;
  }
  set lottieAssetId(id) {
    this._requireValidLottieAssetId(id);
    this._lottieAssetId = id;
  }
  get data() {
    return this._data;
  }
  set data(data) {
    if (!data) {
      throw new DotLottieError("Invalid data");
    }
    this._data = data;
  }
  get parentAnimations() {
    return this._parentAnimations;
  }
  set parentAnimations(parentAnimations) {
    this._parentAnimations = parentAnimations;
  }
  async toDataURL() {
    if (this._data && this._isDataURL(this._data)) return this.data;
    const arrayBuffer = await this.toArrayBuffer();
    return dataUrlFromU8(new Uint8Array(arrayBuffer));
  }
  /**
   * Renames the lottieAssetId and fileName to newName.
   * @param newName - A new lottieAssetId and filename for the image.
   */
  async renameImage(newLottieAssetId) {
    this._lottieAssetId = newLottieAssetId;
    const data = await this.toDataURL();
    const ext = await getExtensionTypeFromBase64(data);
    if (!ext) {
      throw new DotLottieError("File extension type could not be detected from asset file.");
    }
    this.fileName = `${newLottieAssetId}.${ext}`;
  }
  async toArrayBuffer() {
    const blob = await (await this.toBlob()).arrayBuffer();
    return blob;
  }
  async toBlob() {
    if (!this._data) {
      throw new DotLottieError("Invalid image data.");
    }
    if (this._isDataURL(this._data)) {
      const data = this._data;
      const [header, base64] = data.split(",");
      if ((!header || !base64) && data.length) {
        return new Blob([data]);
      }
      if (!header || !base64) {
        throw new DotLottieError("Invalid image data.");
      }
      const type = header.replace("data:", "").replace(/;base64$/, "");
      return new Blob([base64], { type });
    }
    if (this._isArrayBuffer(this._data)) {
      return new Blob([this._data]);
    }
    if (this._isBlob(this._data)) {
      return this._data;
    }
    throw new DotLottieError("Invalid image data.");
  }
  async _fromUrlToBlob(url) {
    const response = await fetch(url);
    return response.blob();
  }
  _isArrayBuffer(data) {
    return data instanceof ArrayBuffer;
  }
  _isDataURL(data) {
    return typeof data === "string" && data.startsWith("data:");
  }
  _isBlob(data) {
    return data instanceof Blob;
  }
};

// src/v1/common/audio.ts
var LottieAudioCommonV1 = class {
  constructor(options) {
    __publicField(this, "_data");
    __publicField(this, "_id", "");
    __publicField(this, "_url");
    __publicField(this, "_fileName", "");
    __publicField(this, "_parentAnimations");
    __publicField(this, "_zipOptions");
    this._requireValidId(options.id);
    this._requireValidFileName(options.fileName);
    this._zipOptions = options.zipOptions ?? {};
    if (options.data) {
      this._data = options.data;
    }
    if (options.id) {
      this._id = options.id;
    }
    if (options.url) {
      this._url = options.url;
    }
    if (options.fileName) {
      this._fileName = options.fileName;
    }
    this._parentAnimations = options.parentAnimations || [];
  }
  get zipOptions() {
    return this._zipOptions;
  }
  set zipOptions(zipOptions) {
    this._zipOptions = zipOptions;
  }
  get fileName() {
    return this._fileName;
  }
  set fileName(fileName) {
    if (!fileName) throw new DotLottieError("Invalid audio file name", "ASSET_NOT_FOUND" /* ASSET_NOT_FOUND */);
    this._fileName = fileName;
  }
  get id() {
    return this._id;
  }
  set id(id) {
    if (!id) throw new DotLottieError("Invalid audio id", "ASSET_NOT_FOUND" /* ASSET_NOT_FOUND */);
    this._id = id;
  }
  get data() {
    return this._data;
  }
  set data(data) {
    if (!data) {
      throw new DotLottieError("Invalid data");
    }
    this._data = data;
  }
  get parentAnimations() {
    return this._parentAnimations;
  }
  set parentAnimations(parentAnimations) {
    this._parentAnimations = parentAnimations;
  }
  async toDataURL() {
    if (this._data && this._isDataURL(this._data)) return this.data;
    const arrayBuffer = await this.toArrayBuffer();
    return dataUrlFromU8(new Uint8Array(arrayBuffer));
  }
  /**
   * Renames the id and fileName to newName.
   * @param newName - A new id and filename for the audio.
   */
  async renameAudio(newName) {
    this.id = newName;
    const data = await this.toDataURL();
    const ext = await getExtensionTypeFromBase64(data);
    if (!ext) {
      throw new DotLottieError("File extension type could not be detected from asset file.");
    }
    this.fileName = `${newName}.${ext}`;
  }
  async toArrayBuffer() {
    const blob = await (await this.toBlob()).arrayBuffer();
    return blob;
  }
  async toBlob() {
    if (!this._data && this._url) {
      this._data = await this._fromUrlToBlob(this._url);
    }
    if (!this._data) {
      throw new Error("Invalid data");
    }
    if (this._isDataURL(this._data)) {
      const data = this._data;
      const [header, base64] = data.split(",");
      if ((!header || !base64) && data.length) {
        return new Blob([data]);
      }
      if (!header || !base64) {
        throw new Error("Invalid data");
      }
      const type = header.replace("data:", "").replace(/;base64$/, "");
      return new Blob([base64], { type });
    }
    if (this._isArrayBuffer(this._data)) {
      return new Blob([this._data]);
    }
    if (this._isBlob(this._data)) {
      return this._data;
    }
    throw new Error("Invalid data");
  }
  async _fromUrlToBlob(url) {
    const response = await fetch(url);
    return response.blob();
  }
  _isArrayBuffer(data) {
    return data instanceof ArrayBuffer;
  }
  _isDataURL(data) {
    return typeof data === "string" && data.startsWith("data:");
  }
  _isBlob(data) {
    return data instanceof Blob;
  }
  /**
   * Ensure that the provided id is a valid string.
   * The id must be a non-empty string, otherwise an error will be thrown.
   * @param id - The id to validate.
   * @throws Error - if the id is not a valid string.
   */
  _requireValidId(id) {
    if (!id) throw new DotLottieError("Invalid audio id");
  }
  /**
   * Ensure that the provided fileName is a valid string.
   * The fileName must be a non-empty string, otherwise an error will be thrown.
   * @param fileName - The fileName to validate.
   * @throws Error - if the fileName is not a valid string.
   */
  _requireValidFileName(fileName) {
    if (!fileName) throw new DotLottieError("Invalid audio fileName");
  }
};

// src/v1/browser/audio.ts
var LottieAudioV1 = class extends LottieAudioCommonV1 {
  constructor(options) {
    super(options);
  }
};

// src/v1/browser/image.ts
var LottieImageV1 = class extends LottieImageCommonV1 {
  constructor(options) {
    super(options);
  }
};

// src/v1/browser/animation.ts
var LottieAnimationV1 = class extends LottieAnimationCommonV1 {
  constructor(options) {
    super(options);
  }
  /**
   * Return the animation data as a base64 encoded string.
   *
   * @returns data - The animation data as a base64 encoded string.
   * @throws Error - if the animation data is not set and the url is not provided.
   * @throws Error - if the animation data is not a valid Lottie animation data object.
   * @throws Error - if the fetch request fails.
   */
  async toBase64() {
    const data = await this.toArrayBuffer();
    if (typeof window === "undefined") return Buffer.from(data).toString("base64");
    const uint8Array = new Uint8Array(data);
    const binaryString = uint8Array.reduce((acc, val) => acc + String.fromCharCode(val), "");
    return window.btoa(binaryString);
  }
  /**
   *
   * Extract image assets from the animation.
   *
   * @returns boolean - true on error otherwise false on success
   */
  async _extractImageAssets() {
    if (!this._data) throw new DotLottieError("Failed to extract image assets: Animation data does not exist");
    const animationAssets = this._data.assets;
    if (!animationAssets) throw new DotLottieError("Failed to extract image assets: No assets found inside animation");
    for (const asset of animationAssets) {
      if ("w" in asset && "h" in asset && !("xt" in asset) && "p" in asset) {
        const imageData = asset.p.split(",");
        if (!imageData.length || !imageData[0] || !imageData[1]) {
          break;
        }
        let extType = null;
        const fileType = await getExtensionTypeFromBase64(asset.p);
        if (fileType) {
          extType = fileType;
          const fileName = `${asset.id}.${extType}`;
          this._imageAssets.push(
            new LottieImageV1({
              data: asset.p,
              id: asset.id,
              lottieAssetId: asset.id,
              fileName,
              parentAnimations: [this]
            })
          );
          asset.p = fileName;
          asset.u = "/images/";
          asset.e = 0;
        }
      }
    }
    return false;
  }
  /**
   *
   * Extract audio assets from the animation.
   *
   * @returns boolean - true on error otherwise false on success
   */
  async _extractAudioAssets() {
    if (!this._data) throw new DotLottieError("Failed to extract audio assets: Animation data does not exist");
    const animationAssets = this._data.assets;
    if (!animationAssets) throw new DotLottieError("Failed to extract image assets: No assets found inside animation");
    for (const asset of animationAssets) {
      if (isAudioAsset(asset)) {
        const audioData = asset.p.split(",");
        if (!audioData.length || !audioData[0] || !audioData[1]) {
          break;
        }
        let extType = null;
        const fileType = await getExtensionTypeFromBase64(asset.p);
        extType = fileType;
        const fileName = `${asset.id}.${extType}`;
        this._audioAssets.push(
          new LottieAudioV1({
            data: asset.p,
            id: asset.id,
            fileName,
            parentAnimations: [this]
          })
        );
        asset.p = fileName;
        asset.u = "/audio/";
        asset.e = 0;
      }
    }
    return false;
  }
};

// src/v1/common/plugin.ts
var DotLottieV1Plugin = class {
  constructor(options) {
    __publicField(this, "dotLottieV1");
    __publicField(this, "_parallel", false);
    this.dotLottieV1 = void 0;
    if (options?.parallel) {
      this._parallel = options.parallel;
    }
  }
  install(dotLottieV1) {
    this.dotLottieV1 = dotLottieV1;
  }
  uninstall() {
    this.dotLottieV1 = void 0;
  }
  get parallel() {
    return this._parallel;
  }
  set parallel(value) {
    this._parallel = value;
  }
  async onBuild() {
    throw new DotLottieError("DotLottieV1-plugin build Not implemented!");
  }
  _requireDotLottieV1(dotLottieV1) {
    if (!dotLottieV1)
      throw new DotLottieError("DotLottieV1 context is null inside of duplicate image detector plugin.");
  }
};

// src/v1/common/plugins/duplicate-image-detector.ts
var DuplicateImageDetectorCommon2 = class extends DotLottieV1Plugin {
  async generatePhash(_image) {
    throw new DotLottieError(
      "generatePhash(image: LottieImageCommonV1): Promise<Hash> is not implemented in concrete class."
    );
  }
  distanceTo(_imageHash, _targetImageHash) {
    throw new DotLottieError(
      "distanceTo(_imageHash: string, _targetImageHash: string): Promise<number> is not implemented in concrete class."
    );
  }
  async _createRecordOfDuplicates() {
    this._requireDotLottieV1(this.dotLottieV1);
    const images = [];
    const recordOfDuplicates = {};
    for (const animation of this.dotLottieV1.animations) {
      for (const image of animation.imageAssets) {
        images.push({
          excludeFromExport: false,
          image,
          hash: await this.generatePhash(image)
        });
      }
    }
    for (const image of images) {
      for (const compareImage of images) {
        if (image.image.lottieAssetId !== compareImage.image.lottieAssetId && !image.excludeFromExport && !compareImage.excludeFromExport && image.hash && compareImage.hash && this.distanceTo(image.hash, compareImage.hash) < 5) {
          if (!recordOfDuplicates[image.image.fileName] && !recordOfDuplicates[compareImage.image.fileName]) {
            compareImage.excludeFromExport = true;
            recordOfDuplicates[image.image.fileName] = [compareImage.image];
          } else if (recordOfDuplicates[compareImage.image.fileName]) {
            if (!recordOfDuplicates[compareImage.image.fileName]?.find(
              (item) => item.lottieAssetId === image.image.lottieAssetId
            )) {
              image.excludeFromExport = true;
              recordOfDuplicates[compareImage.image.fileName]?.push(image.image);
            }
          }
        }
      }
    }
    return recordOfDuplicates;
  }
  /**
   * Apply the image path to all duplicate images.
   *
   * @param recordOfDuplicates - A record of duplicate images, the key being a fileName,
   * the value being the identical LottieImageCommonV1 object.
   */
  adjustDuplicateImageAssetPath(animation, recordOfDuplicates) {
    for (const key in recordOfDuplicates) {
      if (key) {
        recordOfDuplicates[key]?.forEach((item) => {
          if (animation.data) {
            const animationAssets = animation.data.assets;
            if (animationAssets) {
              animationAssets.forEach((asset) => {
                if ("w" in asset && "h" in asset) {
                  if (asset.p === item.fileName) {
                    const fileName = key;
                    asset.p = fileName;
                  }
                }
              });
            }
          }
        });
      }
    }
  }
  async onBuild() {
    this._requireDotLottieV1(this.dotLottieV1);
    const recordOfDuplicates = await this._createRecordOfDuplicates();
    this.dotLottieV1.animations.forEach((animation) => {
      this.adjustDuplicateImageAssetPath(animation, recordOfDuplicates);
    });
    const clonedImages = {};
    const images = this.dotLottieV1.getImages();
    for (const key in recordOfDuplicates) {
      if (key) {
        for (const image of images) {
          if (image.fileName === key && image.data !== void 0) {
            clonedImages[key] = new LottieImageV1({
              data: image.data,
              id: image.id,
              lottieAssetId: image.lottieAssetId,
              fileName: image.fileName
            });
          }
        }
      }
    }
    if (Object.keys(clonedImages).length !== Object.keys(recordOfDuplicates).length) {
      throw new DotLottieError("The number of cloned images does not match the number of duplicate keys.");
    }
    for (const key in recordOfDuplicates) {
      if (key) {
        recordOfDuplicates[key]?.forEach((image) => {
          if (image.parentAnimations.length) {
            for (const parentAnimation of image.parentAnimations) {
              parentAnimation.imageAssets.splice(parentAnimation.imageAssets.indexOf(image), 1);
              const clonedImage = clonedImages[key];
              if (clonedImage !== void 0) {
                parentAnimation.imageAssets.push(clonedImage);
                clonedImage.parentAnimations.push(parentAnimation);
              }
            }
          }
        });
      }
    }
  }
};

// src/v1/browser/plugins/duplicate-image-detector.ts
var DuplicateImageDetector2 = class extends DuplicateImageDetectorCommon2 {
  async generatePhash(image) {
    const builder = new DifferenceHashBuilder_default();
    const targetURL = new URL(await image.toDataURL());
    const destHash = await builder.build(targetURL);
    return destHash.rawHash;
  }
  distanceTo(imageHash, targetImageHash) {
    const srcHash = new Hash_default(imageHash);
    const targetHash = new Hash_default(targetImageHash);
    return srcHash.getHammingDistance(targetHash);
  }
};

// src/v1/browser/dotlottie.ts
async function toDotLottieV1(arrayBuffer) {
  const version = await getDotLottieVersion(new Uint8Array(arrayBuffer));
  if (version === "2") {
    const dotLottieV1 = new DotLottieV1();
    const dotLottieV2 = await new DotLottie().fromArrayBuffer(arrayBuffer);
    const animationIds = dotLottieV2.animations.map((animation) => animation.id);
    for (const animationId of animationIds) {
      const animation = await dotLottieV2.getAnimation(animationId, { inlineAssets: true });
      if (animation && animation.data) {
        dotLottieV1.addAnimation({
          data: animation.data,
          id: animationId
        });
      }
    }
    await dotLottieV1.build();
    return dotLottieV1;
  } else {
    return new DotLottieV1().fromArrayBuffer(arrayBuffer);
  }
}
var DotLottieV1 = class _DotLottieV1 extends DotLottieCommonV1 {
  constructor(options) {
    super(options);
    if (this.enableDuplicateImageOptimization) {
      const plugin = new DuplicateImageDetector2();
      plugin.install(this);
      this._plugins.push(plugin);
    }
  }
  addAnimation(animationOptions) {
    const animation = new LottieAnimationV1(animationOptions);
    if (this._animationsMap.get(animationOptions.id)) {
      throw new DotLottieError("Duplicate animation id detected, aborting.");
    }
    this._animationsMap.set(animation.id, animation);
    return this;
  }
  async toBase64(options) {
    const data = await this.toArrayBuffer(options);
    const uint8Array = new Uint8Array(data);
    const binaryString = uint8Array.reduce((acc, val) => acc + String.fromCharCode(val), "");
    return window.btoa(binaryString);
  }
  async download(fileName, options) {
    const blob = await this.toBlob(options);
    const dataURL = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = dataURL;
    link.download = fileName;
    link.style.display = "none";
    document.body.append(link);
    link.click();
    setTimeout(() => {
      URL.revokeObjectURL(dataURL);
      link.remove();
    }, 1e3);
  }
  create(options) {
    return new _DotLottieV1(options);
  }
  async toArrayBuffer(options) {
    const manifest = this._buildManifest();
    const dotLottie = {
      "manifest.json": [strToU8(JSON.stringify(manifest)), {}]
    };
    for (const animation of this.animations) {
      const json = await animation.toJSON();
      dotLottie[`animations/${animation.id}.json`] = [strToU8(JSON.stringify(json)), animation.zipOptions];
      const imageAssets = animation.imageAssets;
      const audioAssets = animation.audioAssets;
      for (const asset of imageAssets) {
        const dataAsString = await asset.toDataURL();
        dotLottie[`images/${asset.fileName}`] = [base64ToUint8Array(dataAsString), asset.zipOptions];
      }
      for (const asset of audioAssets) {
        const dataAsString = await asset.toDataURL();
        dotLottie[`audio/${asset.fileName}`] = [base64ToUint8Array(dataAsString), asset.zipOptions];
      }
    }
    const dotLottieArrayBuffer = await new Promise((resolve, reject) => {
      zip(dotLottie, options?.zipOptions || {}, (err, data) => {
        if (err) {
          reject(err);
          return;
        }
        resolve(data.buffer);
      });
    });
    return dotLottieArrayBuffer;
  }
  /**
   * Creates a DotLottieV1 instance from an array buffer
   * @param arrayBuffer - array buffer of the DotLottieV1 file
   * @returns DotLottieV1 instance
   * @throws Error
   */
  async fromArrayBuffer(arrayBuffer) {
    const dotLottieVersion = await getDotLottieVersion(new Uint8Array(arrayBuffer));
    if (dotLottieVersion === "2") {
      return toDotLottieV1(arrayBuffer);
    }
    const dotLottie = new _DotLottieV1();
    try {
      const contentObj = await new Promise((resolve, reject) => {
        unzip(new Uint8Array(arrayBuffer), (err, data) => {
          if (err) {
            reject(err);
          }
          resolve(data);
        });
      });
      const tmpImages = [];
      const tmpAudio = [];
      if (contentObj["manifest.json"] instanceof Uint8Array) {
        try {
          const manifest = JSON.parse(strFromU8(contentObj["manifest.json"], false));
          const { author, custom, description, keywords } = manifest;
          if (author) {
            this._requireValidAuthor(author);
            dotLottie.setAuthor(author);
          }
          if (custom) {
            this._requireValidCustomData(custom);
            dotLottie.setCustomData(custom);
          }
          if (description) {
            this._requireValidDescription(description);
            dotLottie.setDescription(description);
          }
          if (keywords) {
            this._requireValidKeywords(keywords);
            dotLottie.setKeywords(keywords);
          }
          for (const key of Object.keys(contentObj)) {
            const decodedStr = strFromU8(contentObj[key], true);
            if (key.startsWith("animations/") && key.endsWith(".json")) {
              const animationId = /animations\/(.+)\.json/u.exec(key)?.[1];
              if (!animationId) {
                throw new DotLottieError("Invalid animation id");
              }
              const animation = JSON.parse(decodedStr);
              const animationSettings = manifest.animations.find((anim) => anim.id === animationId);
              if (animationSettings === void 0) {
                throw new DotLottieError("Animation not found inside manifest");
              }
              dotLottie.addAnimation({
                data: animation,
                ...animationSettings
              });
            } else if (key.startsWith("images/")) {
              const imageId = /images\/(.+)\./u.exec(key)?.[1];
              if (!imageId) {
                throw new DotLottieError("Invalid image id");
              }
              let decodedImg = btoa(decodedStr);
              const ext = await getExtensionTypeFromBase64(decodedImg);
              decodedImg = `data:image/${ext};base64,${decodedImg}`;
              tmpImages.push(
                new LottieImageV1({
                  id: imageId,
                  lottieAssetId: imageId,
                  data: decodedImg,
                  fileName: key.split("/")[1] || ""
                })
              );
            } else if (key.startsWith("audio/")) {
              const audioId = /audio\/(.+)\./u.exec(key)?.[1];
              if (!audioId) {
                throw new DotLottieError("Invalid image id");
              }
              let decodedAudio = btoa(decodedStr);
              const ext = await getExtensionTypeFromBase64(decodedAudio);
              decodedAudio = `data:audio/${ext};base64,${decodedAudio}`;
              tmpAudio.push(
                new LottieAudioV1({
                  id: audioId,
                  data: decodedAudio,
                  fileName: key.split("/")[1] || ""
                })
              );
            }
          }
          for (const image of tmpImages) {
            for (const parentAnimation of dotLottie.animations) {
              if (parentAnimation.data) {
                const animationAssets = parentAnimation.data.assets;
                if (animationAssets) {
                  for (const asset of animationAssets) {
                    if ("w" in asset && "h" in asset) {
                      if (asset.p === image.fileName) {
                        image.parentAnimations.push(parentAnimation);
                        parentAnimation.imageAssets.push(image);
                      }
                    }
                  }
                }
              }
            }
          }
          for (const audio of tmpAudio) {
            for (const parentAnimation of dotLottie.animations) {
              if (parentAnimation.data) {
                const animationAssets = parentAnimation.data.assets;
                if (animationAssets) {
                  for (const asset of animationAssets) {
                    if (isAudioAsset(asset)) {
                      if (asset.p.includes(audio.id)) {
                        audio.parentAnimations.push(parentAnimation);
                        parentAnimation.audioAssets.push(audio);
                      }
                    }
                  }
                }
              }
            }
          }
        } catch (err) {
          if (err instanceof Error) {
            throw new DotLottieError(`Invalid manifest inside buffer! ${err.message}`);
          }
        }
      } else {
        throw new DotLottieError("Invalid buffer");
      }
    } catch (err) {
      if (err instanceof Error) {
        throw new DotLottieError(err.message);
      }
    }
    return dotLottie;
  }
};

// src/index.browser.ts
function makeDotLottie(version, options) {
  if (version === "v1") {
    return new DotLottieV1(options);
  }
  return new DotLottie(options);
}
/*! Bundled license information:

ieee754/index.js:
  (*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> *)
*/

export { BooleanGuardSchema, BooleanTriggerSchema, DotLottie, DotLottieCommon, DotLottieCommonV1, DotLottieError, DotLottieStateMachineCommon, DotLottieStateMachineSchema, DotLottieV1, ErrorCodes, EventGuardSchema, EventTriggerSchema, GlobalStateSchema, GuardSchema, InitialObjectSchema, ListenerSchema, ListenersSchema, LottieAnimation, LottieAnimationCommon, LottieAnimationCommonV1, LottieAnimationV1, LottieAudio, LottieAudioCommon, LottieAudioCommonV1, LottieAudioV1, LottieImage, LottieImageCommon, LottieImageCommonV1, LottieImageV1, LottieStateMachine, LottieTheme, LottieThemeCommon, ManifestAnimationSchema, ManifestAnimationSchemaV1, ManifestSchema, ManifestSchemaV1, ManifestStateMachineSchema, ManifestThemeSchema, NumericGuardSchema, NumericTriggerSchema, OnCompleteSchema, PlayMode, PlayModeSchema, PlaybackStateSchema, PointerDownSchema, PointerEnterSchema, PointerExitSchema, PointerMoveSchema, PointerUpSchema, RulesSchema, StateSchema, StatesSchema, StringGuardSchema, StringTriggerSchema, ThemeDataSchema, TransitionSchema, TransitionsSchema, TriggerSchema, TriggersSchema, base64ToUint8Array, dataUrlFromU8, getAllAudio, getAnimation, getAnimations, getAudio, getDotLottieVersion, getExtensionTypeFromBase64, getImage, getImages, getManifest, getMimeTypeFromBase64, getMimeTypeFromUint8Data, getStateMachine, getStateMachines, getTheme, getThemes, inlineAudioAssets, inlineImageAssets, isAudioAsset, isImageAsset, isValidURL, loadFromArrayBuffer, loadFromURL, makeDotLottie, toDotLottieV1, toDotLottieV2, unzipDotLottie, unzipDotLottieFile, validateDotLottie };
//# sourceMappingURL=index.browser.js.map
//# sourceMappingURL=index.browser.js.map